function av(h) {
  return h && h.__esModule && Object.prototype.hasOwnProperty.call(h, "default")
    ? h.default
    : h;
}
var cf = { exports: {} },
  Ee = {};
var bm;
function uv() {
  if (bm) return Ee;
  bm = 1;
  var h = Symbol.for("react.transitional.element"),
    g = Symbol.for("react.fragment");
  function O(s, R, L) {
    var J = null;
    if (
      (L !== void 0 && (J = "" + L),
      R.key !== void 0 && (J = "" + R.key),
      "key" in R)
    ) {
      L = {};
      for (var q in R) q !== "key" && (L[q] = R[q]);
    } else L = R;
    return (
      (R = L.ref),
      { $$typeof: h, type: s, key: J, ref: R !== void 0 ? R : null, props: L }
    );
  }
  return ((Ee.Fragment = g), (Ee.jsx = O), (Ee.jsxs = O), Ee);
}
var pm;
function ev() {
  return (pm || ((pm = 1), (cf.exports = uv())), cf.exports);
}
var T = ev(),
  ff = { exports: {} },
  Q = {};
var Em;
function nv() {
  if (Em) return Q;
  Em = 1;
  var h = Symbol.for("react.transitional.element"),
    g = Symbol.for("react.portal"),
    O = Symbol.for("react.fragment"),
    s = Symbol.for("react.strict_mode"),
    R = Symbol.for("react.profiler"),
    L = Symbol.for("react.consumer"),
    J = Symbol.for("react.context"),
    q = Symbol.for("react.forward_ref"),
    M = Symbol.for("react.suspense"),
    b = Symbol.for("react.memo"),
    Y = Symbol.for("react.lazy"),
    N = Symbol.for("react.activity"),
    B = Symbol.iterator;
  function vl(o) {
    return o === null || typeof o != "object"
      ? null
      : ((o = (B && o[B]) || o["@@iterator"]),
        typeof o == "function" ? o : null);
  }
  var ol = {
      isMounted: function () {
        return !1;
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {},
    },
    Sl = Object.assign,
    Nl = {};
  function jl(o, A, U) {
    ((this.props = o),
      (this.context = A),
      (this.refs = Nl),
      (this.updater = U || ol));
  }
  ((jl.prototype.isReactComponent = {}),
    (jl.prototype.setState = function (o, A) {
      if (typeof o != "object" && typeof o != "function" && o != null)
        throw Error(
          "takes an object of state variables to update or a function which returns an object of state variables.",
        );
      this.updater.enqueueSetState(this, o, A, "setState");
    }),
    (jl.prototype.forceUpdate = function (o) {
      this.updater.enqueueForceUpdate(this, o, "forceUpdate");
    }));
  function Tt() {}
  Tt.prototype = jl.prototype;
  function ll(o, A, U) {
    ((this.props = o),
      (this.context = A),
      (this.refs = Nl),
      (this.updater = U || ol));
  }
  var Xl = (ll.prototype = new Tt());
  ((Xl.constructor = ll), Sl(Xl, jl.prototype), (Xl.isPureReactComponent = !0));
  var Ll = Array.isArray;
  function Hl() {}
  var I = { H: null, A: null, T: null, S: null },
    Kl = Object.prototype.hasOwnProperty;
  function At(o, A, U) {
    var H = U.ref;
    return {
      $$typeof: h,
      type: o,
      key: A,
      ref: H !== void 0 ? H : null,
      props: U,
    };
  }
  function Va(o, A) {
    return At(o.type, A, o.props);
  }
  function Ot(o) {
    return typeof o == "object" && o !== null && o.$$typeof === h;
  }
  function Jl(o) {
    var A = { "=": "=0", ":": "=2" };
    return (
      "$" +
      o.replace(/[=:]/g, function (U) {
        return A[U];
      })
    );
  }
  var _a = /\/+/g;
  function jt(o, A) {
    return typeof o == "object" && o !== null && o.key != null
      ? Jl("" + o.key)
      : A.toString(36);
  }
  function pt(o) {
    switch (o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw o.reason;
      default:
        switch (
          (typeof o.status == "string"
            ? o.then(Hl, Hl)
            : ((o.status = "pending"),
              o.then(
                function (A) {
                  o.status === "pending" &&
                    ((o.status = "fulfilled"), (o.value = A));
                },
                function (A) {
                  o.status === "pending" &&
                    ((o.status = "rejected"), (o.reason = A));
                },
              )),
          o.status)
        ) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw o.reason;
        }
    }
    throw o;
  }
  function E(o, A, U, H, Z) {
    var w = typeof o;
    (w === "undefined" || w === "boolean") && (o = null);
    var el = !1;
    if (o === null) el = !0;
    else
      switch (w) {
        case "bigint":
        case "string":
        case "number":
          el = !0;
          break;
        case "object":
          switch (o.$$typeof) {
            case h:
            case g:
              el = !0;
              break;
            case Y:
              return ((el = o._init), E(el(o._payload), A, U, H, Z));
          }
      }
    if (el)
      return (
        (Z = Z(o)),
        (el = H === "" ? "." + jt(o, 0) : H),
        Ll(Z)
          ? ((U = ""),
            el != null && (U = el.replace(_a, "$&/") + "/"),
            E(Z, A, U, "", function (Nu) {
              return Nu;
            }))
          : Z != null &&
            (Ot(Z) &&
              (Z = Va(
                Z,
                U +
                  (Z.key == null || (o && o.key === Z.key)
                    ? ""
                    : ("" + Z.key).replace(_a, "$&/") + "/") +
                  el,
              )),
            A.push(Z)),
        1
      );
    el = 0;
    var Zl = H === "" ? "." : H + ":";
    if (Ll(o))
      for (var El = 0; El < o.length; El++)
        ((H = o[El]), (w = Zl + jt(H, El)), (el += E(H, A, U, w, Z)));
    else if (((El = vl(o)), typeof El == "function"))
      for (o = El.call(o), El = 0; !(H = o.next()).done; )
        ((H = H.value), (w = Zl + jt(H, El++)), (el += E(H, A, U, w, Z)));
    else if (w === "object") {
      if (typeof o.then == "function") return E(pt(o), A, U, H, Z);
      throw (
        (A = String(o)),
        Error(
          "Objects are not valid as a React child (found: " +
            (A === "[object Object]"
              ? "object with keys {" + Object.keys(o).join(", ") + "}"
              : A) +
            "). If you meant to render a collection of children, use an array instead.",
        )
      );
    }
    return el;
  }
  function D(o, A, U) {
    if (o == null) return o;
    var H = [],
      Z = 0;
    return (
      E(o, H, "", "", function (w) {
        return A.call(U, w, Z++);
      }),
      H
    );
  }
  function X(o) {
    if (o._status === -1) {
      var A = o._result;
      ((A = A()),
        A.then(
          function (U) {
            (o._status === 0 || o._status === -1) &&
              ((o._status = 1), (o._result = U));
          },
          function (U) {
            (o._status === 0 || o._status === -1) &&
              ((o._status = 2), (o._result = U));
          },
        ),
        o._status === -1 && ((o._status = 0), (o._result = A)));
    }
    if (o._status === 1) return o._result.default;
    throw o._result;
  }
  var il =
      typeof reportError == "function"
        ? reportError
        : function (o) {
            if (
              typeof window == "object" &&
              typeof window.ErrorEvent == "function"
            ) {
              var A = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message:
                  typeof o == "object" &&
                  o !== null &&
                  typeof o.message == "string"
                    ? String(o.message)
                    : String(o),
                error: o,
              });
              if (!window.dispatchEvent(A)) return;
            } else if (
              typeof process == "object" &&
              typeof process.emit == "function"
            ) {
              process.emit("uncaughtException", o);
              return;
            }
            console.error(o);
          },
    ml = {
      map: D,
      forEach: function (o, A, U) {
        D(
          o,
          function () {
            A.apply(this, arguments);
          },
          U,
        );
      },
      count: function (o) {
        var A = 0;
        return (
          D(o, function () {
            A++;
          }),
          A
        );
      },
      toArray: function (o) {
        return (
          D(o, function (A) {
            return A;
          }) || []
        );
      },
      only: function (o) {
        if (!Ot(o))
          throw Error(
            "React.Children.only expected to receive a single React element child.",
          );
        return o;
      },
    };
  return (
    (Q.Activity = N),
    (Q.Children = ml),
    (Q.Component = jl),
    (Q.Fragment = O),
    (Q.Profiler = R),
    (Q.PureComponent = ll),
    (Q.StrictMode = s),
    (Q.Suspense = M),
    (Q.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = I),
    (Q.__COMPILER_RUNTIME = {
      __proto__: null,
      c: function (o) {
        return I.H.useMemoCache(o);
      },
    }),
    (Q.cache = function (o) {
      return function () {
        return o.apply(null, arguments);
      };
    }),
    (Q.cacheSignal = function () {
      return null;
    }),
    (Q.cloneElement = function (o, A, U) {
      if (o == null)
        throw Error(
          "The argument must be a React element, but you passed " + o + ".",
        );
      var H = Sl({}, o.props),
        Z = o.key;
      if (A != null)
        for (w in (A.key !== void 0 && (Z = "" + A.key), A))
          !Kl.call(A, w) ||
            w === "key" ||
            w === "__self" ||
            w === "__source" ||
            (w === "ref" && A.ref === void 0) ||
            (H[w] = A[w]);
      var w = arguments.length - 2;
      if (w === 1) H.children = U;
      else if (1 < w) {
        for (var el = Array(w), Zl = 0; Zl < w; Zl++)
          el[Zl] = arguments[Zl + 2];
        H.children = el;
      }
      return At(o.type, Z, H);
    }),
    (Q.createContext = function (o) {
      return (
        (o = {
          $$typeof: J,
          _currentValue: o,
          _currentValue2: o,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
        }),
        (o.Provider = o),
        (o.Consumer = { $$typeof: L, _context: o }),
        o
      );
    }),
    (Q.createElement = function (o, A, U) {
      var H,
        Z = {},
        w = null;
      if (A != null)
        for (H in (A.key !== void 0 && (w = "" + A.key), A))
          Kl.call(A, H) &&
            H !== "key" &&
            H !== "__self" &&
            H !== "__source" &&
            (Z[H] = A[H]);
      var el = arguments.length - 2;
      if (el === 1) Z.children = U;
      else if (1 < el) {
        for (var Zl = Array(el), El = 0; El < el; El++)
          Zl[El] = arguments[El + 2];
        Z.children = Zl;
      }
      if (o && o.defaultProps)
        for (H in ((el = o.defaultProps), el))
          Z[H] === void 0 && (Z[H] = el[H]);
      return At(o, w, Z);
    }),
    (Q.createRef = function () {
      return { current: null };
    }),
    (Q.forwardRef = function (o) {
      return { $$typeof: q, render: o };
    }),
    (Q.isValidElement = Ot),
    (Q.lazy = function (o) {
      return { $$typeof: Y, _payload: { _status: -1, _result: o }, _init: X };
    }),
    (Q.memo = function (o, A) {
      return { $$typeof: b, type: o, compare: A === void 0 ? null : A };
    }),
    (Q.startTransition = function (o) {
      var A = I.T,
        U = {};
      I.T = U;
      try {
        var H = o(),
          Z = I.S;
        (Z !== null && Z(U, H),
          typeof H == "object" &&
            H !== null &&
            typeof H.then == "function" &&
            H.then(Hl, il));
      } catch (w) {
        il(w);
      } finally {
        (A !== null && U.types !== null && (A.types = U.types), (I.T = A));
      }
    }),
    (Q.unstable_useCacheRefresh = function () {
      return I.H.useCacheRefresh();
    }),
    (Q.use = function (o) {
      return I.H.use(o);
    }),
    (Q.useActionState = function (o, A, U) {
      return I.H.useActionState(o, A, U);
    }),
    (Q.useCallback = function (o, A) {
      return I.H.useCallback(o, A);
    }),
    (Q.useContext = function (o) {
      return I.H.useContext(o);
    }),
    (Q.useDebugValue = function () {}),
    (Q.useDeferredValue = function (o, A) {
      return I.H.useDeferredValue(o, A);
    }),
    (Q.useEffect = function (o, A) {
      return I.H.useEffect(o, A);
    }),
    (Q.useEffectEvent = function (o) {
      return I.H.useEffectEvent(o);
    }),
    (Q.useId = function () {
      return I.H.useId();
    }),
    (Q.useImperativeHandle = function (o, A, U) {
      return I.H.useImperativeHandle(o, A, U);
    }),
    (Q.useInsertionEffect = function (o, A) {
      return I.H.useInsertionEffect(o, A);
    }),
    (Q.useLayoutEffect = function (o, A) {
      return I.H.useLayoutEffect(o, A);
    }),
    (Q.useMemo = function (o, A) {
      return I.H.useMemo(o, A);
    }),
    (Q.useOptimistic = function (o, A) {
      return I.H.useOptimistic(o, A);
    }),
    (Q.useReducer = function (o, A, U) {
      return I.H.useReducer(o, A, U);
    }),
    (Q.useRef = function (o) {
      return I.H.useRef(o);
    }),
    (Q.useState = function (o) {
      return I.H.useState(o);
    }),
    (Q.useSyncExternalStore = function (o, A, U) {
      return I.H.useSyncExternalStore(o, A, U);
    }),
    (Q.useTransition = function () {
      return I.H.useTransition();
    }),
    (Q.version = "19.2.3"),
    Q
  );
}
var _m;
function vf() {
  return (_m || ((_m = 1), (ff.exports = nv())), ff.exports);
}
var Ul = vf();
const hf = av(Ul);
var sf = { exports: {} },
  _e = {},
  df = { exports: {} },
  of = {};
var zm;
function cv() {
  return (
    zm ||
      ((zm = 1),
      (function (h) {
        function g(E, D) {
          var X = E.length;
          E.push(D);
          l: for (; 0 < X; ) {
            var il = (X - 1) >>> 1,
              ml = E[il];
            if (0 < R(ml, D)) ((E[il] = D), (E[X] = ml), (X = il));
            else break l;
          }
        }
        function O(E) {
          return E.length === 0 ? null : E[0];
        }
        function s(E) {
          if (E.length === 0) return null;
          var D = E[0],
            X = E.pop();
          if (X !== D) {
            E[0] = X;
            l: for (var il = 0, ml = E.length, o = ml >>> 1; il < o; ) {
              var A = 2 * (il + 1) - 1,
                U = E[A],
                H = A + 1,
                Z = E[H];
              if (0 > R(U, X))
                H < ml && 0 > R(Z, U)
                  ? ((E[il] = Z), (E[H] = X), (il = H))
                  : ((E[il] = U), (E[A] = X), (il = A));
              else if (H < ml && 0 > R(Z, X))
                ((E[il] = Z), (E[H] = X), (il = H));
              else break l;
            }
          }
          return D;
        }
        function R(E, D) {
          var X = E.sortIndex - D.sortIndex;
          return X !== 0 ? X : E.id - D.id;
        }
        if (
          ((h.unstable_now = void 0),
          typeof performance == "object" &&
            typeof performance.now == "function")
        ) {
          var L = performance;
          h.unstable_now = function () {
            return L.now();
          };
        } else {
          var J = Date,
            q = J.now();
          h.unstable_now = function () {
            return J.now() - q;
          };
        }
        var M = [],
          b = [],
          Y = 1,
          N = null,
          B = 3,
          vl = !1,
          ol = !1,
          Sl = !1,
          Nl = !1,
          jl = typeof setTimeout == "function" ? setTimeout : null,
          Tt = typeof clearTimeout == "function" ? clearTimeout : null,
          ll = typeof setImmediate < "u" ? setImmediate : null;
        function Xl(E) {
          for (var D = O(b); D !== null; ) {
            if (D.callback === null) s(b);
            else if (D.startTime <= E)
              (s(b), (D.sortIndex = D.expirationTime), g(M, D));
            else break;
            D = O(b);
          }
        }
        function Ll(E) {
          if (((Sl = !1), Xl(E), !ol))
            if (O(M) !== null) ((ol = !0), Hl || ((Hl = !0), Jl()));
            else {
              var D = O(b);
              D !== null && pt(Ll, D.startTime - E);
            }
        }
        var Hl = !1,
          I = -1,
          Kl = 5,
          At = -1;
        function Va() {
          return Nl ? !0 : !(h.unstable_now() - At < Kl);
        }
        function Ot() {
          if (((Nl = !1), Hl)) {
            var E = h.unstable_now();
            At = E;
            var D = !0;
            try {
              l: {
                ((ol = !1), Sl && ((Sl = !1), Tt(I), (I = -1)), (vl = !0));
                var X = B;
                try {
                  t: {
                    for (
                      Xl(E), N = O(M);
                      N !== null && !(N.expirationTime > E && Va());

                    ) {
                      var il = N.callback;
                      if (typeof il == "function") {
                        ((N.callback = null), (B = N.priorityLevel));
                        var ml = il(N.expirationTime <= E);
                        if (((E = h.unstable_now()), typeof ml == "function")) {
                          ((N.callback = ml), Xl(E), (D = !0));
                          break t;
                        }
                        (N === O(M) && s(M), Xl(E));
                      } else s(M);
                      N = O(M);
                    }
                    if (N !== null) D = !0;
                    else {
                      var o = O(b);
                      (o !== null && pt(Ll, o.startTime - E), (D = !1));
                    }
                  }
                  break l;
                } finally {
                  ((N = null), (B = X), (vl = !1));
                }
                D = void 0;
              }
            } finally {
              D ? Jl() : (Hl = !1);
            }
          }
        }
        var Jl;
        if (typeof ll == "function")
          Jl = function () {
            ll(Ot);
          };
        else if (typeof MessageChannel < "u") {
          var _a = new MessageChannel(),
            jt = _a.port2;
          ((_a.port1.onmessage = Ot),
            (Jl = function () {
              jt.postMessage(null);
            }));
        } else
          Jl = function () {
            jl(Ot, 0);
          };
        function pt(E, D) {
          I = jl(function () {
            E(h.unstable_now());
          }, D);
        }
        ((h.unstable_IdlePriority = 5),
          (h.unstable_ImmediatePriority = 1),
          (h.unstable_LowPriority = 4),
          (h.unstable_NormalPriority = 3),
          (h.unstable_Profiling = null),
          (h.unstable_UserBlockingPriority = 2),
          (h.unstable_cancelCallback = function (E) {
            E.callback = null;
          }),
          (h.unstable_forceFrameRate = function (E) {
            0 > E || 125 < E
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (Kl = 0 < E ? Math.floor(1e3 / E) : 5);
          }),
          (h.unstable_getCurrentPriorityLevel = function () {
            return B;
          }),
          (h.unstable_next = function (E) {
            switch (B) {
              case 1:
              case 2:
              case 3:
                var D = 3;
                break;
              default:
                D = B;
            }
            var X = B;
            B = D;
            try {
              return E();
            } finally {
              B = X;
            }
          }),
          (h.unstable_requestPaint = function () {
            Nl = !0;
          }),
          (h.unstable_runWithPriority = function (E, D) {
            switch (E) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                E = 3;
            }
            var X = B;
            B = E;
            try {
              return D();
            } finally {
              B = X;
            }
          }),
          (h.unstable_scheduleCallback = function (E, D, X) {
            var il = h.unstable_now();
            switch (
              (typeof X == "object" && X !== null
                ? ((X = X.delay),
                  (X = typeof X == "number" && 0 < X ? il + X : il))
                : (X = il),
              E)
            ) {
              case 1:
                var ml = -1;
                break;
              case 2:
                ml = 250;
                break;
              case 5:
                ml = 1073741823;
                break;
              case 4:
                ml = 1e4;
                break;
              default:
                ml = 5e3;
            }
            return (
              (ml = X + ml),
              (E = {
                id: Y++,
                callback: D,
                priorityLevel: E,
                startTime: X,
                expirationTime: ml,
                sortIndex: -1,
              }),
              X > il
                ? ((E.sortIndex = X),
                  g(b, E),
                  O(M) === null &&
                    E === O(b) &&
                    (Sl ? (Tt(I), (I = -1)) : (Sl = !0), pt(Ll, X - il)))
                : ((E.sortIndex = ml),
                  g(M, E),
                  ol || vl || ((ol = !0), Hl || ((Hl = !0), Jl()))),
              E
            );
          }),
          (h.unstable_shouldYield = Va),
          (h.unstable_wrapCallback = function (E) {
            var D = B;
            return function () {
              var X = B;
              B = D;
              try {
                return E.apply(this, arguments);
              } finally {
                B = X;
              }
            };
          }));
      })(of)),
    of
  );
}
var Tm;
function iv() {
  return (Tm || ((Tm = 1), (df.exports = cv())), df.exports);
}
var mf = { exports: {} },
  Ql = {};
var Am;
function fv() {
  if (Am) return Ql;
  Am = 1;
  var h = vf();
  function g(M) {
    var b = "https://react.dev/errors/" + M;
    if (1 < arguments.length) {
      b += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var Y = 2; Y < arguments.length; Y++)
        b += "&args[]=" + encodeURIComponent(arguments[Y]);
    }
    return (
      "Minified React error #" +
      M +
      "; visit " +
      b +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function O() {}
  var s = {
      d: {
        f: O,
        r: function () {
          throw Error(g(522));
        },
        D: O,
        C: O,
        L: O,
        m: O,
        X: O,
        S: O,
        M: O,
      },
      p: 0,
      findDOMNode: null,
    },
    R = Symbol.for("react.portal");
  function L(M, b, Y) {
    var N =
      3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: R,
      key: N == null ? null : "" + N,
      children: M,
      containerInfo: b,
      implementation: Y,
    };
  }
  var J = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function q(M, b) {
    if (M === "font") return "";
    if (typeof b == "string") return b === "use-credentials" ? b : "";
  }
  return (
    (Ql.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = s),
    (Ql.createPortal = function (M, b) {
      var Y =
        2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!b || (b.nodeType !== 1 && b.nodeType !== 9 && b.nodeType !== 11))
        throw Error(g(299));
      return L(M, b, null, Y);
    }),
    (Ql.flushSync = function (M) {
      var b = J.T,
        Y = s.p;
      try {
        if (((J.T = null), (s.p = 2), M)) return M();
      } finally {
        ((J.T = b), (s.p = Y), s.d.f());
      }
    }),
    (Ql.preconnect = function (M, b) {
      typeof M == "string" &&
        (b
          ? ((b = b.crossOrigin),
            (b =
              typeof b == "string"
                ? b === "use-credentials"
                  ? b
                  : ""
                : void 0))
          : (b = null),
        s.d.C(M, b));
    }),
    (Ql.prefetchDNS = function (M) {
      typeof M == "string" && s.d.D(M);
    }),
    (Ql.preinit = function (M, b) {
      if (typeof M == "string" && b && typeof b.as == "string") {
        var Y = b.as,
          N = q(Y, b.crossOrigin),
          B = typeof b.integrity == "string" ? b.integrity : void 0,
          vl = typeof b.fetchPriority == "string" ? b.fetchPriority : void 0;
        Y === "style"
          ? s.d.S(M, typeof b.precedence == "string" ? b.precedence : void 0, {
              crossOrigin: N,
              integrity: B,
              fetchPriority: vl,
            })
          : Y === "script" &&
            s.d.X(M, {
              crossOrigin: N,
              integrity: B,
              fetchPriority: vl,
              nonce: typeof b.nonce == "string" ? b.nonce : void 0,
            });
      }
    }),
    (Ql.preinitModule = function (M, b) {
      if (typeof M == "string")
        if (typeof b == "object" && b !== null) {
          if (b.as == null || b.as === "script") {
            var Y = q(b.as, b.crossOrigin);
            s.d.M(M, {
              crossOrigin: Y,
              integrity: typeof b.integrity == "string" ? b.integrity : void 0,
              nonce: typeof b.nonce == "string" ? b.nonce : void 0,
            });
          }
        } else b == null && s.d.M(M);
    }),
    (Ql.preload = function (M, b) {
      if (
        typeof M == "string" &&
        typeof b == "object" &&
        b !== null &&
        typeof b.as == "string"
      ) {
        var Y = b.as,
          N = q(Y, b.crossOrigin);
        s.d.L(M, Y, {
          crossOrigin: N,
          integrity: typeof b.integrity == "string" ? b.integrity : void 0,
          nonce: typeof b.nonce == "string" ? b.nonce : void 0,
          type: typeof b.type == "string" ? b.type : void 0,
          fetchPriority:
            typeof b.fetchPriority == "string" ? b.fetchPriority : void 0,
          referrerPolicy:
            typeof b.referrerPolicy == "string" ? b.referrerPolicy : void 0,
          imageSrcSet:
            typeof b.imageSrcSet == "string" ? b.imageSrcSet : void 0,
          imageSizes: typeof b.imageSizes == "string" ? b.imageSizes : void 0,
          media: typeof b.media == "string" ? b.media : void 0,
        });
      }
    }),
    (Ql.preloadModule = function (M, b) {
      if (typeof M == "string")
        if (b) {
          var Y = q(b.as, b.crossOrigin);
          s.d.m(M, {
            as: typeof b.as == "string" && b.as !== "script" ? b.as : void 0,
            crossOrigin: Y,
            integrity: typeof b.integrity == "string" ? b.integrity : void 0,
          });
        } else s.d.m(M);
    }),
    (Ql.requestFormReset = function (M) {
      s.d.r(M);
    }),
    (Ql.unstable_batchedUpdates = function (M, b) {
      return M(b);
    }),
    (Ql.useFormState = function (M, b, Y) {
      return J.H.useFormState(M, b, Y);
    }),
    (Ql.useFormStatus = function () {
      return J.H.useHostTransitionStatus();
    }),
    (Ql.version = "19.2.3"),
    Ql
  );
}
var Om;
function sv() {
  if (Om) return mf.exports;
  Om = 1;
  function h() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(h);
      } catch (g) {
        console.error(g);
      }
  }
  return (h(), (mf.exports = fv()), mf.exports);
}
var Mm;
function dv() {
  if (Mm) return _e;
  Mm = 1;
  var h = iv(),
    g = vf(),
    O = sv();
  function s(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var a = 2; a < arguments.length; a++)
        t += "&args[]=" + encodeURIComponent(arguments[a]);
    }
    return (
      "Minified React error #" +
      l +
      "; visit " +
      t +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    );
  }
  function R(l) {
    return !(!l || (l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11));
  }
  function L(l) {
    var t = l,
      a = l;
    if (l.alternate) for (; t.return; ) t = t.return;
    else {
      l = t;
      do ((t = l), (t.flags & 4098) !== 0 && (a = t.return), (l = t.return));
      while (l);
    }
    return t.tag === 3 ? a : null;
  }
  function J(l) {
    if (l.tag === 13) {
      var t = l.memoizedState;
      if (
        (t === null && ((l = l.alternate), l !== null && (t = l.memoizedState)),
        t !== null)
      )
        return t.dehydrated;
    }
    return null;
  }
  function q(l) {
    if (l.tag === 31) {
      var t = l.memoizedState;
      if (
        (t === null && ((l = l.alternate), l !== null && (t = l.memoizedState)),
        t !== null)
      )
        return t.dehydrated;
    }
    return null;
  }
  function M(l) {
    if (L(l) !== l) throw Error(s(188));
  }
  function b(l) {
    var t = l.alternate;
    if (!t) {
      if (((t = L(l)), t === null)) throw Error(s(188));
      return t !== l ? null : l;
    }
    for (var a = l, u = t; ; ) {
      var e = a.return;
      if (e === null) break;
      var n = e.alternate;
      if (n === null) {
        if (((u = e.return), u !== null)) {
          a = u;
          continue;
        }
        break;
      }
      if (e.child === n.child) {
        for (n = e.child; n; ) {
          if (n === a) return (M(e), l);
          if (n === u) return (M(e), t);
          n = n.sibling;
        }
        throw Error(s(188));
      }
      if (a.return !== u.return) ((a = e), (u = n));
      else {
        for (var c = !1, i = e.child; i; ) {
          if (i === a) {
            ((c = !0), (a = e), (u = n));
            break;
          }
          if (i === u) {
            ((c = !0), (u = e), (a = n));
            break;
          }
          i = i.sibling;
        }
        if (!c) {
          for (i = n.child; i; ) {
            if (i === a) {
              ((c = !0), (a = n), (u = e));
              break;
            }
            if (i === u) {
              ((c = !0), (u = n), (a = e));
              break;
            }
            i = i.sibling;
          }
          if (!c) throw Error(s(189));
        }
      }
      if (a.alternate !== u) throw Error(s(190));
    }
    if (a.tag !== 3) throw Error(s(188));
    return a.stateNode.current === a ? l : t;
  }
  function Y(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l;
    for (l = l.child; l !== null; ) {
      if (((t = Y(l)), t !== null)) return t;
      l = l.sibling;
    }
    return null;
  }
  var N = Object.assign,
    B = Symbol.for("react.element"),
    vl = Symbol.for("react.transitional.element"),
    ol = Symbol.for("react.portal"),
    Sl = Symbol.for("react.fragment"),
    Nl = Symbol.for("react.strict_mode"),
    jl = Symbol.for("react.profiler"),
    Tt = Symbol.for("react.consumer"),
    ll = Symbol.for("react.context"),
    Xl = Symbol.for("react.forward_ref"),
    Ll = Symbol.for("react.suspense"),
    Hl = Symbol.for("react.suspense_list"),
    I = Symbol.for("react.memo"),
    Kl = Symbol.for("react.lazy"),
    At = Symbol.for("react.activity"),
    Va = Symbol.for("react.memo_cache_sentinel"),
    Ot = Symbol.iterator;
  function Jl(l) {
    return l === null || typeof l != "object"
      ? null
      : ((l = (Ot && l[Ot]) || l["@@iterator"]),
        typeof l == "function" ? l : null);
  }
  var _a = Symbol.for("react.client.reference");
  function jt(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === _a ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case Sl:
        return "Fragment";
      case jl:
        return "Profiler";
      case Nl:
        return "StrictMode";
      case Ll:
        return "Suspense";
      case Hl:
        return "SuspenseList";
      case At:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case ol:
          return "Portal";
        case ll:
          return l.displayName || "Context";
        case Tt:
          return (l._context.displayName || "Context") + ".Consumer";
        case Xl:
          var t = l.render;
          return (
            (l = l.displayName),
            l ||
              ((l = t.displayName || t.name || ""),
              (l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef")),
            l
          );
        case I:
          return (
            (t = l.displayName || null),
            t !== null ? t : jt(l.type) || "Memo"
          );
        case Kl:
          ((t = l._payload), (l = l._init));
          try {
            return jt(l(t));
          } catch {}
      }
    return null;
  }
  var pt = Array.isArray,
    E = g.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    D = O.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
    X = { pending: !1, data: null, method: null, action: null },
    il = [],
    ml = -1;
  function o(l) {
    return { current: l };
  }
  function A(l) {
    0 > ml || ((l.current = il[ml]), (il[ml] = null), ml--);
  }
  function U(l, t) {
    (ml++, (il[ml] = l.current), (l.current = t));
  }
  var H = o(null),
    Z = o(null),
    w = o(null),
    el = o(null);
  function Zl(l, t) {
    switch ((U(w, t), U(Z, l), U(H, null), t.nodeType)) {
      case 9:
      case 11:
        l = (l = t.documentElement) && (l = l.namespaceURI) ? Zo(l) : 0;
        break;
      default:
        if (((l = t.tagName), (t = t.namespaceURI)))
          ((t = Zo(t)), (l = Vo(t, l)));
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    (A(H), U(H, l));
  }
  function El() {
    (A(H), A(Z), A(w));
  }
  function Nu(l) {
    l.memoizedState !== null && U(el, l);
    var t = H.current,
      a = Vo(t, l.type);
    t !== a && (U(Z, l), U(H, a));
  }
  function ze(l) {
    (Z.current === l && (A(H), A(Z)),
      el.current === l && (A(el), (ge._currentValue = X)));
  }
  var Zn, gf;
  function za(l) {
    if (Zn === void 0)
      try {
        throw Error();
      } catch (a) {
        var t = a.stack.trim().match(/\n( *(at )?)/);
        ((Zn = (t && t[1]) || ""),
          (gf =
            -1 <
            a.stack.indexOf(`
    at`)
              ? " (<anonymous>)"
              : -1 < a.stack.indexOf("@")
                ? "@unknown:0:0"
                : ""));
      }
    return (
      `
` +
      Zn +
      l +
      gf
    );
  }
  var Vn = !1;
  function Ln(l, t) {
    if (!l || Vn) return "";
    Vn = !0;
    var a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var u = {
        DetermineComponentFrameRoot: function () {
          try {
            if (t) {
              var z = function () {
                throw Error();
              };
              if (
                (Object.defineProperty(z.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(z, []);
                } catch (S) {
                  var r = S;
                }
                Reflect.construct(l, [], z);
              } else {
                try {
                  z.call();
                } catch (S) {
                  r = S;
                }
                l.call(z.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (S) {
                r = S;
              }
              (z = l()) &&
                typeof z.catch == "function" &&
                z.catch(function () {});
            }
          } catch (S) {
            if (S && r && typeof S.stack == "string") return [S.stack, r.stack];
          }
          return [null, null];
        },
      };
      u.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var e = Object.getOwnPropertyDescriptor(
        u.DetermineComponentFrameRoot,
        "name",
      );
      e &&
        e.configurable &&
        Object.defineProperty(u.DetermineComponentFrameRoot, "name", {
          value: "DetermineComponentFrameRoot",
        });
      var n = u.DetermineComponentFrameRoot(),
        c = n[0],
        i = n[1];
      if (c && i) {
        var f = c.split(`
`),
          v = i.split(`
`);
        for (
          e = u = 0;
          u < f.length && !f[u].includes("DetermineComponentFrameRoot");

        )
          u++;
        for (; e < v.length && !v[e].includes("DetermineComponentFrameRoot"); )
          e++;
        if (u === f.length || e === v.length)
          for (
            u = f.length - 1, e = v.length - 1;
            1 <= u && 0 <= e && f[u] !== v[e];

          )
            e--;
        for (; 1 <= u && 0 <= e; u--, e--)
          if (f[u] !== v[e]) {
            if (u !== 1 || e !== 1)
              do
                if ((u--, e--, 0 > e || f[u] !== v[e])) {
                  var p =
                    `
` + f[u].replace(" at new ", " at ");
                  return (
                    l.displayName &&
                      p.includes("<anonymous>") &&
                      (p = p.replace("<anonymous>", l.displayName)),
                    p
                  );
                }
              while (1 <= u && 0 <= e);
            break;
          }
      }
    } finally {
      ((Vn = !1), (Error.prepareStackTrace = a));
    }
    return (a = l ? l.displayName || l.name : "") ? za(a) : "";
  }
  function Rm(l, t) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return za(l.type);
      case 16:
        return za("Lazy");
      case 13:
        return l.child !== t && t !== null
          ? za("Suspense Fallback")
          : za("Suspense");
      case 19:
        return za("SuspenseList");
      case 0:
      case 15:
        return Ln(l.type, !1);
      case 11:
        return Ln(l.type.render, !1);
      case 1:
        return Ln(l.type, !0);
      case 31:
        return za("Activity");
      default:
        return "";
    }
  }
  function Sf(l) {
    try {
      var t = "",
        a = null;
      do ((t += Rm(l, a)), (a = l), (l = l.return));
      while (l);
      return t;
    } catch (u) {
      return (
        `
Error generating stack: ` +
        u.message +
        `
` +
        u.stack
      );
    }
  }
  var Kn = Object.prototype.hasOwnProperty,
    Jn = h.unstable_scheduleCallback,
    wn = h.unstable_cancelCallback,
    Cm = h.unstable_shouldYield,
    qm = h.unstable_requestPaint,
    lt = h.unstable_now,
    xm = h.unstable_getCurrentPriorityLevel,
    bf = h.unstable_ImmediatePriority,
    pf = h.unstable_UserBlockingPriority,
    Te = h.unstable_NormalPriority,
    Bm = h.unstable_LowPriority,
    Ef = h.unstable_IdlePriority,
    Ym = h.log,
    Gm = h.unstable_setDisableYieldValue,
    Du = null,
    tt = null;
  function Ft(l) {
    if (
      (typeof Ym == "function" && Gm(l),
      tt && typeof tt.setStrictMode == "function")
    )
      try {
        tt.setStrictMode(Du, l);
      } catch {}
  }
  var at = Math.clz32 ? Math.clz32 : Zm,
    Xm = Math.log,
    Qm = Math.LN2;
  function Zm(l) {
    return ((l >>>= 0), l === 0 ? 32 : (31 - ((Xm(l) / Qm) | 0)) | 0);
  }
  var Ae = 256,
    Oe = 262144,
    Me = 4194304;
  function Ta(l) {
    var t = l & 42;
    if (t !== 0) return t;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Ne(l, t, a) {
    var u = l.pendingLanes;
    if (u === 0) return 0;
    var e = 0,
      n = l.suspendedLanes,
      c = l.pingedLanes;
    l = l.warmLanes;
    var i = u & 134217727;
    return (
      i !== 0
        ? ((u = i & ~n),
          u !== 0
            ? (e = Ta(u))
            : ((c &= i),
              c !== 0
                ? (e = Ta(c))
                : a || ((a = i & ~l), a !== 0 && (e = Ta(a)))))
        : ((i = u & ~n),
          i !== 0
            ? (e = Ta(i))
            : c !== 0
              ? (e = Ta(c))
              : a || ((a = u & ~l), a !== 0 && (e = Ta(a)))),
      e === 0
        ? 0
        : t !== 0 &&
            t !== e &&
            (t & n) === 0 &&
            ((n = e & -e),
            (a = t & -t),
            n >= a || (n === 32 && (a & 4194048) !== 0))
          ? t
          : e
    );
  }
  function Uu(l, t) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & t) === 0;
  }
  function Vm(l, t) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function _f() {
    var l = Me;
    return ((Me <<= 1), (Me & 62914560) === 0 && (Me = 4194304), l);
  }
  function Wn(l) {
    for (var t = [], a = 0; 31 > a; a++) t.push(l);
    return t;
  }
  function ju(l, t) {
    ((l.pendingLanes |= t),
      t !== 268435456 &&
        ((l.suspendedLanes = 0), (l.pingedLanes = 0), (l.warmLanes = 0)));
  }
  function Lm(l, t, a, u, e, n) {
    var c = l.pendingLanes;
    ((l.pendingLanes = a),
      (l.suspendedLanes = 0),
      (l.pingedLanes = 0),
      (l.warmLanes = 0),
      (l.expiredLanes &= a),
      (l.entangledLanes &= a),
      (l.errorRecoveryDisabledLanes &= a),
      (l.shellSuspendCounter = 0));
    var i = l.entanglements,
      f = l.expirationTimes,
      v = l.hiddenUpdates;
    for (a = c & ~a; 0 < a; ) {
      var p = 31 - at(a),
        z = 1 << p;
      ((i[p] = 0), (f[p] = -1));
      var r = v[p];
      if (r !== null)
        for (v[p] = null, p = 0; p < r.length; p++) {
          var S = r[p];
          S !== null && (S.lane &= -536870913);
        }
      a &= ~z;
    }
    (u !== 0 && zf(l, u, 0),
      n !== 0 && e === 0 && l.tag !== 0 && (l.suspendedLanes |= n & ~(c & ~t)));
  }
  function zf(l, t, a) {
    ((l.pendingLanes |= t), (l.suspendedLanes &= ~t));
    var u = 31 - at(t);
    ((l.entangledLanes |= t),
      (l.entanglements[u] = l.entanglements[u] | 1073741824 | (a & 261930)));
  }
  function Tf(l, t) {
    var a = (l.entangledLanes |= t);
    for (l = l.entanglements; a; ) {
      var u = 31 - at(a),
        e = 1 << u;
      ((e & t) | (l[u] & t) && (l[u] |= t), (a &= ~e));
    }
  }
  function Af(l, t) {
    var a = t & -t;
    return (
      (a = (a & 42) !== 0 ? 1 : $n(a)),
      (a & (l.suspendedLanes | t)) !== 0 ? 0 : a
    );
  }
  function $n(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function Fn(l) {
    return (
      (l &= -l),
      2 < l ? (8 < l ? ((l & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
    );
  }
  function Of() {
    var l = D.p;
    return l !== 0 ? l : ((l = window.event), l === void 0 ? 32 : mm(l.type));
  }
  function Mf(l, t) {
    var a = D.p;
    try {
      return ((D.p = l), t());
    } finally {
      D.p = a;
    }
  }
  var kt = Math.random().toString(36).slice(2),
    ql = "__reactFiber$" + kt,
    wl = "__reactProps$" + kt,
    La = "__reactContainer$" + kt,
    kn = "__reactEvents$" + kt,
    Km = "__reactListeners$" + kt,
    Jm = "__reactHandles$" + kt,
    Nf = "__reactResources$" + kt,
    Hu = "__reactMarker$" + kt;
  function In(l) {
    (delete l[ql], delete l[wl], delete l[kn], delete l[Km], delete l[Jm]);
  }
  function Ka(l) {
    var t = l[ql];
    if (t) return t;
    for (var a = l.parentNode; a; ) {
      if ((t = a[La] || a[ql])) {
        if (
          ((a = t.alternate),
          t.child !== null || (a !== null && a.child !== null))
        )
          for (l = Fo(l); l !== null; ) {
            if ((a = l[ql])) return a;
            l = Fo(l);
          }
        return t;
      }
      ((l = a), (a = l.parentNode));
    }
    return null;
  }
  function Ja(l) {
    if ((l = l[ql] || l[La])) {
      var t = l.tag;
      if (
        t === 5 ||
        t === 6 ||
        t === 13 ||
        t === 31 ||
        t === 26 ||
        t === 27 ||
        t === 3
      )
        return l;
    }
    return null;
  }
  function Ru(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l.stateNode;
    throw Error(s(33));
  }
  function wa(l) {
    var t = l[Nf];
    return (
      t ||
        (t = l[Nf] =
          { hoistableStyles: new Map(), hoistableScripts: new Map() }),
      t
    );
  }
  function Rl(l) {
    l[Hu] = !0;
  }
  var Df = new Set(),
    Uf = {};
  function Aa(l, t) {
    (Wa(l, t), Wa(l + "Capture", t));
  }
  function Wa(l, t) {
    for (Uf[l] = t, l = 0; l < t.length; l++) Df.add(t[l]);
  }
  var wm = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$",
    ),
    jf = {},
    Hf = {};
  function Wm(l) {
    return Kn.call(Hf, l)
      ? !0
      : Kn.call(jf, l)
        ? !1
        : wm.test(l)
          ? (Hf[l] = !0)
          : ((jf[l] = !0), !1);
  }
  function De(l, t, a) {
    if (Wm(t))
      if (a === null) l.removeAttribute(t);
      else {
        switch (typeof a) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(t);
            return;
          case "boolean":
            var u = t.toLowerCase().slice(0, 5);
            if (u !== "data-" && u !== "aria-") {
              l.removeAttribute(t);
              return;
            }
        }
        l.setAttribute(t, "" + a);
      }
  }
  function Ue(l, t, a) {
    if (a === null) l.removeAttribute(t);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(t);
          return;
      }
      l.setAttribute(t, "" + a);
    }
  }
  function Ht(l, t, a, u) {
    if (u === null) l.removeAttribute(a);
    else {
      switch (typeof u) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(a);
          return;
      }
      l.setAttributeNS(t, a, "" + u);
    }
  }
  function dt(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Rf(l) {
    var t = l.type;
    return (
      (l = l.nodeName) &&
      l.toLowerCase() === "input" &&
      (t === "checkbox" || t === "radio")
    );
  }
  function $m(l, t, a) {
    var u = Object.getOwnPropertyDescriptor(l.constructor.prototype, t);
    if (
      !l.hasOwnProperty(t) &&
      typeof u < "u" &&
      typeof u.get == "function" &&
      typeof u.set == "function"
    ) {
      var e = u.get,
        n = u.set;
      return (
        Object.defineProperty(l, t, {
          configurable: !0,
          get: function () {
            return e.call(this);
          },
          set: function (c) {
            ((a = "" + c), n.call(this, c));
          },
        }),
        Object.defineProperty(l, t, { enumerable: u.enumerable }),
        {
          getValue: function () {
            return a;
          },
          setValue: function (c) {
            a = "" + c;
          },
          stopTracking: function () {
            ((l._valueTracker = null), delete l[t]);
          },
        }
      );
    }
  }
  function Pn(l) {
    if (!l._valueTracker) {
      var t = Rf(l) ? "checked" : "value";
      l._valueTracker = $m(l, t, "" + l[t]);
    }
  }
  function Cf(l) {
    if (!l) return !1;
    var t = l._valueTracker;
    if (!t) return !0;
    var a = t.getValue(),
      u = "";
    return (
      l && (u = Rf(l) ? (l.checked ? "true" : "false") : l.value),
      (l = u),
      l !== a ? (t.setValue(l), !0) : !1
    );
  }
  function je(l) {
    if (
      ((l = l || (typeof document < "u" ? document : void 0)), typeof l > "u")
    )
      return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var Fm = /[\n"\\]/g;
  function ot(l) {
    return l.replace(Fm, function (t) {
      return "\\" + t.charCodeAt(0).toString(16) + " ";
    });
  }
  function lc(l, t, a, u, e, n, c, i) {
    ((l.name = ""),
      c != null &&
      typeof c != "function" &&
      typeof c != "symbol" &&
      typeof c != "boolean"
        ? (l.type = c)
        : l.removeAttribute("type"),
      t != null
        ? c === "number"
          ? ((t === 0 && l.value === "") || l.value != t) &&
            (l.value = "" + dt(t))
          : l.value !== "" + dt(t) && (l.value = "" + dt(t))
        : (c !== "submit" && c !== "reset") || l.removeAttribute("value"),
      t != null
        ? tc(l, c, dt(t))
        : a != null
          ? tc(l, c, dt(a))
          : u != null && l.removeAttribute("value"),
      e == null && n != null && (l.defaultChecked = !!n),
      e != null &&
        (l.checked = e && typeof e != "function" && typeof e != "symbol"),
      i != null &&
      typeof i != "function" &&
      typeof i != "symbol" &&
      typeof i != "boolean"
        ? (l.name = "" + dt(i))
        : l.removeAttribute("name"));
  }
  function qf(l, t, a, u, e, n, c, i) {
    if (
      (n != null &&
        typeof n != "function" &&
        typeof n != "symbol" &&
        typeof n != "boolean" &&
        (l.type = n),
      t != null || a != null)
    ) {
      if (!((n !== "submit" && n !== "reset") || t != null)) {
        Pn(l);
        return;
      }
      ((a = a != null ? "" + dt(a) : ""),
        (t = t != null ? "" + dt(t) : a),
        i || t === l.value || (l.value = t),
        (l.defaultValue = t));
    }
    ((u = u ?? e),
      (u = typeof u != "function" && typeof u != "symbol" && !!u),
      (l.checked = i ? l.checked : !!u),
      (l.defaultChecked = !!u),
      c != null &&
        typeof c != "function" &&
        typeof c != "symbol" &&
        typeof c != "boolean" &&
        (l.name = c),
      Pn(l));
  }
  function tc(l, t, a) {
    (t === "number" && je(l.ownerDocument) === l) ||
      l.defaultValue === "" + a ||
      (l.defaultValue = "" + a);
  }
  function $a(l, t, a, u) {
    if (((l = l.options), t)) {
      t = {};
      for (var e = 0; e < a.length; e++) t["$" + a[e]] = !0;
      for (a = 0; a < l.length; a++)
        ((e = t.hasOwnProperty("$" + l[a].value)),
          l[a].selected !== e && (l[a].selected = e),
          e && u && (l[a].defaultSelected = !0));
    } else {
      for (a = "" + dt(a), t = null, e = 0; e < l.length; e++) {
        if (l[e].value === a) {
          ((l[e].selected = !0), u && (l[e].defaultSelected = !0));
          return;
        }
        t !== null || l[e].disabled || (t = l[e]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function xf(l, t, a) {
    if (
      t != null &&
      ((t = "" + dt(t)), t !== l.value && (l.value = t), a == null)
    ) {
      l.defaultValue !== t && (l.defaultValue = t);
      return;
    }
    l.defaultValue = a != null ? "" + dt(a) : "";
  }
  function Bf(l, t, a, u) {
    if (t == null) {
      if (u != null) {
        if (a != null) throw Error(s(92));
        if (pt(u)) {
          if (1 < u.length) throw Error(s(93));
          u = u[0];
        }
        a = u;
      }
      (a == null && (a = ""), (t = a));
    }
    ((a = dt(t)),
      (l.defaultValue = a),
      (u = l.textContent),
      u === a && u !== "" && u !== null && (l.value = u),
      Pn(l));
  }
  function Fa(l, t) {
    if (t) {
      var a = l.firstChild;
      if (a && a === l.lastChild && a.nodeType === 3) {
        a.nodeValue = t;
        return;
      }
    }
    l.textContent = t;
  }
  var km = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " ",
    ),
  );
  function Yf(l, t, a) {
    var u = t.indexOf("--") === 0;
    a == null || typeof a == "boolean" || a === ""
      ? u
        ? l.setProperty(t, "")
        : t === "float"
          ? (l.cssFloat = "")
          : (l[t] = "")
      : u
        ? l.setProperty(t, a)
        : typeof a != "number" || a === 0 || km.has(t)
          ? t === "float"
            ? (l.cssFloat = a)
            : (l[t] = ("" + a).trim())
          : (l[t] = a + "px");
  }
  function Gf(l, t, a) {
    if (t != null && typeof t != "object") throw Error(s(62));
    if (((l = l.style), a != null)) {
      for (var u in a)
        !a.hasOwnProperty(u) ||
          (t != null && t.hasOwnProperty(u)) ||
          (u.indexOf("--") === 0
            ? l.setProperty(u, "")
            : u === "float"
              ? (l.cssFloat = "")
              : (l[u] = ""));
      for (var e in t)
        ((u = t[e]), t.hasOwnProperty(e) && a[e] !== u && Yf(l, e, u));
    } else for (var n in t) t.hasOwnProperty(n) && Yf(l, n, t[n]);
  }
  function ac(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Im = new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"],
    ]),
    Pm =
      /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function He(l) {
    return Pm.test("" + l)
      ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
      : l;
  }
  function Rt() {}
  var uc = null;
  function ec(l) {
    return (
      (l = l.target || l.srcElement || window),
      l.correspondingUseElement && (l = l.correspondingUseElement),
      l.nodeType === 3 ? l.parentNode : l
    );
  }
  var ka = null,
    Ia = null;
  function Xf(l) {
    var t = Ja(l);
    if (t && (l = t.stateNode)) {
      var a = l[wl] || null;
      l: switch (((l = t.stateNode), t.type)) {
        case "input":
          if (
            (lc(
              l,
              a.value,
              a.defaultValue,
              a.defaultValue,
              a.checked,
              a.defaultChecked,
              a.type,
              a.name,
            ),
            (t = a.name),
            a.type === "radio" && t != null)
          ) {
            for (a = l; a.parentNode; ) a = a.parentNode;
            for (
              a = a.querySelectorAll(
                'input[name="' + ot("" + t) + '"][type="radio"]',
              ),
                t = 0;
              t < a.length;
              t++
            ) {
              var u = a[t];
              if (u !== l && u.form === l.form) {
                var e = u[wl] || null;
                if (!e) throw Error(s(90));
                lc(
                  u,
                  e.value,
                  e.defaultValue,
                  e.defaultValue,
                  e.checked,
                  e.defaultChecked,
                  e.type,
                  e.name,
                );
              }
            }
            for (t = 0; t < a.length; t++)
              ((u = a[t]), u.form === l.form && Cf(u));
          }
          break l;
        case "textarea":
          xf(l, a.value, a.defaultValue);
          break l;
        case "select":
          ((t = a.value), t != null && $a(l, !!a.multiple, t, !1));
      }
    }
  }
  var nc = !1;
  function Qf(l, t, a) {
    if (nc) return l(t, a);
    nc = !0;
    try {
      var u = l(t);
      return u;
    } finally {
      if (
        ((nc = !1),
        (ka !== null || Ia !== null) &&
          (pn(), ka && ((t = ka), (l = Ia), (Ia = ka = null), Xf(t), l)))
      )
        for (t = 0; t < l.length; t++) Xf(l[t]);
    }
  }
  function Cu(l, t) {
    var a = l.stateNode;
    if (a === null) return null;
    var u = a[wl] || null;
    if (u === null) return null;
    a = u[t];
    l: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        ((u = !u.disabled) ||
          ((l = l.type),
          (u = !(
            l === "button" ||
            l === "input" ||
            l === "select" ||
            l === "textarea"
          ))),
          (l = !u));
        break l;
      default:
        l = !1;
    }
    if (l) return null;
    if (a && typeof a != "function") throw Error(s(231, t, typeof a));
    return a;
  }
  var Ct = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    cc = !1;
  if (Ct)
    try {
      var qu = {};
      (Object.defineProperty(qu, "passive", {
        get: function () {
          cc = !0;
        },
      }),
        window.addEventListener("test", qu, qu),
        window.removeEventListener("test", qu, qu));
    } catch {
      cc = !1;
    }
  var It = null,
    ic = null,
    Re = null;
  function Zf() {
    if (Re) return Re;
    var l,
      t = ic,
      a = t.length,
      u,
      e = "value" in It ? It.value : It.textContent,
      n = e.length;
    for (l = 0; l < a && t[l] === e[l]; l++);
    var c = a - l;
    for (u = 1; u <= c && t[a - u] === e[n - u]; u++);
    return (Re = e.slice(l, 1 < u ? 1 - u : void 0));
  }
  function Ce(l) {
    var t = l.keyCode;
    return (
      "charCode" in l
        ? ((l = l.charCode), l === 0 && t === 13 && (l = 13))
        : (l = t),
      l === 10 && (l = 13),
      32 <= l || l === 13 ? l : 0
    );
  }
  function qe() {
    return !0;
  }
  function Vf() {
    return !1;
  }
  function Wl(l) {
    function t(a, u, e, n, c) {
      ((this._reactName = a),
        (this._targetInst = e),
        (this.type = u),
        (this.nativeEvent = n),
        (this.target = c),
        (this.currentTarget = null));
      for (var i in l)
        l.hasOwnProperty(i) && ((a = l[i]), (this[i] = a ? a(n) : n[i]));
      return (
        (this.isDefaultPrevented = (
          n.defaultPrevented != null ? n.defaultPrevented : n.returnValue === !1
        )
          ? qe
          : Vf),
        (this.isPropagationStopped = Vf),
        this
      );
    }
    return (
      N(t.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0;
          var a = this.nativeEvent;
          a &&
            (a.preventDefault
              ? a.preventDefault()
              : typeof a.returnValue != "unknown" && (a.returnValue = !1),
            (this.isDefaultPrevented = qe));
        },
        stopPropagation: function () {
          var a = this.nativeEvent;
          a &&
            (a.stopPropagation
              ? a.stopPropagation()
              : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0),
            (this.isPropagationStopped = qe));
        },
        persist: function () {},
        isPersistent: qe,
      }),
      t
    );
  }
  var Oa = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (l) {
        return l.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    xe = Wl(Oa),
    xu = N({}, Oa, { view: 0, detail: 0 }),
    l0 = Wl(xu),
    fc,
    sc,
    Bu,
    Be = N({}, xu, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: oc,
      button: 0,
      buttons: 0,
      relatedTarget: function (l) {
        return l.relatedTarget === void 0
          ? l.fromElement === l.srcElement
            ? l.toElement
            : l.fromElement
          : l.relatedTarget;
      },
      movementX: function (l) {
        return "movementX" in l
          ? l.movementX
          : (l !== Bu &&
              (Bu && l.type === "mousemove"
                ? ((fc = l.screenX - Bu.screenX), (sc = l.screenY - Bu.screenY))
                : (sc = fc = 0),
              (Bu = l)),
            fc);
      },
      movementY: function (l) {
        return "movementY" in l ? l.movementY : sc;
      },
    }),
    Lf = Wl(Be),
    t0 = N({}, Be, { dataTransfer: 0 }),
    a0 = Wl(t0),
    u0 = N({}, xu, { relatedTarget: 0 }),
    dc = Wl(u0),
    e0 = N({}, Oa, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    n0 = Wl(e0),
    c0 = N({}, Oa, {
      clipboardData: function (l) {
        return "clipboardData" in l ? l.clipboardData : window.clipboardData;
      },
    }),
    i0 = Wl(c0),
    f0 = N({}, Oa, { data: 0 }),
    Kf = Wl(f0),
    s0 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    d0 = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    o0 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey",
    };
  function m0(l) {
    var t = this.nativeEvent;
    return t.getModifierState
      ? t.getModifierState(l)
      : (l = o0[l])
        ? !!t[l]
        : !1;
  }
  function oc() {
    return m0;
  }
  var y0 = N({}, xu, {
      key: function (l) {
        if (l.key) {
          var t = s0[l.key] || l.key;
          if (t !== "Unidentified") return t;
        }
        return l.type === "keypress"
          ? ((l = Ce(l)), l === 13 ? "Enter" : String.fromCharCode(l))
          : l.type === "keydown" || l.type === "keyup"
            ? d0[l.keyCode] || "Unidentified"
            : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: oc,
      charCode: function (l) {
        return l.type === "keypress" ? Ce(l) : 0;
      },
      keyCode: function (l) {
        return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
      },
      which: function (l) {
        return l.type === "keypress"
          ? Ce(l)
          : l.type === "keydown" || l.type === "keyup"
            ? l.keyCode
            : 0;
      },
    }),
    v0 = Wl(y0),
    h0 = N({}, Be, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    Jf = Wl(h0),
    r0 = N({}, xu, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: oc,
    }),
    g0 = Wl(r0),
    S0 = N({}, Oa, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    b0 = Wl(S0),
    p0 = N({}, Be, {
      deltaX: function (l) {
        return "deltaX" in l
          ? l.deltaX
          : "wheelDeltaX" in l
            ? -l.wheelDeltaX
            : 0;
      },
      deltaY: function (l) {
        return "deltaY" in l
          ? l.deltaY
          : "wheelDeltaY" in l
            ? -l.wheelDeltaY
            : "wheelDelta" in l
              ? -l.wheelDelta
              : 0;
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    E0 = Wl(p0),
    _0 = N({}, Oa, { newState: 0, oldState: 0 }),
    z0 = Wl(_0),
    T0 = [9, 13, 27, 32],
    mc = Ct && "CompositionEvent" in window,
    Yu = null;
  Ct && "documentMode" in document && (Yu = document.documentMode);
  var A0 = Ct && "TextEvent" in window && !Yu,
    wf = Ct && (!mc || (Yu && 8 < Yu && 11 >= Yu)),
    Wf = " ",
    $f = !1;
  function Ff(l, t) {
    switch (l) {
      case "keyup":
        return T0.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function kf(l) {
    return (
      (l = l.detail),
      typeof l == "object" && "data" in l ? l.data : null
    );
  }
  var Pa = !1;
  function O0(l, t) {
    switch (l) {
      case "compositionend":
        return kf(t);
      case "keypress":
        return t.which !== 32 ? null : (($f = !0), Wf);
      case "textInput":
        return ((l = t.data), l === Wf && $f ? null : l);
      default:
        return null;
    }
  }
  function M0(l, t) {
    if (Pa)
      return l === "compositionend" || (!mc && Ff(l, t))
        ? ((l = Zf()), (Re = ic = It = null), (Pa = !1), l)
        : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
          if (t.char && 1 < t.char.length) return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return wf && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var N0 = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  };
  function If(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t === "input" ? !!N0[l.type] : t === "textarea";
  }
  function Pf(l, t, a, u) {
    (ka ? (Ia ? Ia.push(u) : (Ia = [u])) : (ka = u),
      (t = Mn(t, "onChange")),
      0 < t.length &&
        ((a = new xe("onChange", "change", null, a, u)),
        l.push({ event: a, listeners: t })));
  }
  var Gu = null,
    Xu = null;
  function D0(l) {
    xo(l, 0);
  }
  function Ye(l) {
    var t = Ru(l);
    if (Cf(t)) return l;
  }
  function ls(l, t) {
    if (l === "change") return t;
  }
  var ts = !1;
  if (Ct) {
    var yc;
    if (Ct) {
      var vc = "oninput" in document;
      if (!vc) {
        var as = document.createElement("div");
        (as.setAttribute("oninput", "return;"),
          (vc = typeof as.oninput == "function"));
      }
      yc = vc;
    } else yc = !1;
    ts = yc && (!document.documentMode || 9 < document.documentMode);
  }
  function us() {
    Gu && (Gu.detachEvent("onpropertychange", es), (Xu = Gu = null));
  }
  function es(l) {
    if (l.propertyName === "value" && Ye(Xu)) {
      var t = [];
      (Pf(t, Xu, l, ec(l)), Qf(D0, t));
    }
  }
  function U0(l, t, a) {
    l === "focusin"
      ? (us(), (Gu = t), (Xu = a), Gu.attachEvent("onpropertychange", es))
      : l === "focusout" && us();
  }
  function j0(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return Ye(Xu);
  }
  function H0(l, t) {
    if (l === "click") return Ye(t);
  }
  function R0(l, t) {
    if (l === "input" || l === "change") return Ye(t);
  }
  function C0(l, t) {
    return (l === t && (l !== 0 || 1 / l === 1 / t)) || (l !== l && t !== t);
  }
  var ut = typeof Object.is == "function" ? Object.is : C0;
  function Qu(l, t) {
    if (ut(l, t)) return !0;
    if (
      typeof l != "object" ||
      l === null ||
      typeof t != "object" ||
      t === null
    )
      return !1;
    var a = Object.keys(l),
      u = Object.keys(t);
    if (a.length !== u.length) return !1;
    for (u = 0; u < a.length; u++) {
      var e = a[u];
      if (!Kn.call(t, e) || !ut(l[e], t[e])) return !1;
    }
    return !0;
  }
  function ns(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function cs(l, t) {
    var a = ns(l);
    l = 0;
    for (var u; a; ) {
      if (a.nodeType === 3) {
        if (((u = l + a.textContent.length), l <= t && u >= t))
          return { node: a, offset: t - l };
        l = u;
      }
      l: {
        for (; a; ) {
          if (a.nextSibling) {
            a = a.nextSibling;
            break l;
          }
          a = a.parentNode;
        }
        a = void 0;
      }
      a = ns(a);
    }
  }
  function is(l, t) {
    return l && t
      ? l === t
        ? !0
        : l && l.nodeType === 3
          ? !1
          : t && t.nodeType === 3
            ? is(l, t.parentNode)
            : "contains" in l
              ? l.contains(t)
              : l.compareDocumentPosition
                ? !!(l.compareDocumentPosition(t) & 16)
                : !1
      : !1;
  }
  function fs(l) {
    l =
      l != null &&
      l.ownerDocument != null &&
      l.ownerDocument.defaultView != null
        ? l.ownerDocument.defaultView
        : window;
    for (var t = je(l.document); t instanceof l.HTMLIFrameElement; ) {
      try {
        var a = typeof t.contentWindow.location.href == "string";
      } catch {
        a = !1;
      }
      if (a) l = t.contentWindow;
      else break;
      t = je(l.document);
    }
    return t;
  }
  function hc(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return (
      t &&
      ((t === "input" &&
        (l.type === "text" ||
          l.type === "search" ||
          l.type === "tel" ||
          l.type === "url" ||
          l.type === "password")) ||
        t === "textarea" ||
        l.contentEditable === "true")
    );
  }
  var q0 = Ct && "documentMode" in document && 11 >= document.documentMode,
    lu = null,
    rc = null,
    Zu = null,
    gc = !1;
  function ss(l, t, a) {
    var u =
      a.window === a ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
    gc ||
      lu == null ||
      lu !== je(u) ||
      ((u = lu),
      "selectionStart" in u && hc(u)
        ? (u = { start: u.selectionStart, end: u.selectionEnd })
        : ((u = (
            (u.ownerDocument && u.ownerDocument.defaultView) ||
            window
          ).getSelection()),
          (u = {
            anchorNode: u.anchorNode,
            anchorOffset: u.anchorOffset,
            focusNode: u.focusNode,
            focusOffset: u.focusOffset,
          })),
      (Zu && Qu(Zu, u)) ||
        ((Zu = u),
        (u = Mn(rc, "onSelect")),
        0 < u.length &&
          ((t = new xe("onSelect", "select", null, t, a)),
          l.push({ event: t, listeners: u }),
          (t.target = lu))));
  }
  function Ma(l, t) {
    var a = {};
    return (
      (a[l.toLowerCase()] = t.toLowerCase()),
      (a["Webkit" + l] = "webkit" + t),
      (a["Moz" + l] = "moz" + t),
      a
    );
  }
  var tu = {
      animationend: Ma("Animation", "AnimationEnd"),
      animationiteration: Ma("Animation", "AnimationIteration"),
      animationstart: Ma("Animation", "AnimationStart"),
      transitionrun: Ma("Transition", "TransitionRun"),
      transitionstart: Ma("Transition", "TransitionStart"),
      transitioncancel: Ma("Transition", "TransitionCancel"),
      transitionend: Ma("Transition", "TransitionEnd"),
    },
    Sc = {},
    ds = {};
  Ct &&
    ((ds = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete tu.animationend.animation,
      delete tu.animationiteration.animation,
      delete tu.animationstart.animation),
    "TransitionEvent" in window || delete tu.transitionend.transition);
  function Na(l) {
    if (Sc[l]) return Sc[l];
    if (!tu[l]) return l;
    var t = tu[l],
      a;
    for (a in t) if (t.hasOwnProperty(a) && a in ds) return (Sc[l] = t[a]);
    return l;
  }
  var os = Na("animationend"),
    ms = Na("animationiteration"),
    ys = Na("animationstart"),
    x0 = Na("transitionrun"),
    B0 = Na("transitionstart"),
    Y0 = Na("transitioncancel"),
    vs = Na("transitionend"),
    hs = new Map(),
    bc =
      "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " ",
      );
  bc.push("scrollEnd");
  function Et(l, t) {
    (hs.set(l, t), Aa(t, [l]));
  }
  var Ge =
      typeof reportError == "function"
        ? reportError
        : function (l) {
            if (
              typeof window == "object" &&
              typeof window.ErrorEvent == "function"
            ) {
              var t = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message:
                  typeof l == "object" &&
                  l !== null &&
                  typeof l.message == "string"
                    ? String(l.message)
                    : String(l),
                error: l,
              });
              if (!window.dispatchEvent(t)) return;
            } else if (
              typeof process == "object" &&
              typeof process.emit == "function"
            ) {
              process.emit("uncaughtException", l);
              return;
            }
            console.error(l);
          },
    mt = [],
    au = 0,
    pc = 0;
  function Xe() {
    for (var l = au, t = (pc = au = 0); t < l; ) {
      var a = mt[t];
      mt[t++] = null;
      var u = mt[t];
      mt[t++] = null;
      var e = mt[t];
      mt[t++] = null;
      var n = mt[t];
      if (((mt[t++] = null), u !== null && e !== null)) {
        var c = u.pending;
        (c === null ? (e.next = e) : ((e.next = c.next), (c.next = e)),
          (u.pending = e));
      }
      n !== 0 && rs(a, e, n);
    }
  }
  function Qe(l, t, a, u) {
    ((mt[au++] = l),
      (mt[au++] = t),
      (mt[au++] = a),
      (mt[au++] = u),
      (pc |= u),
      (l.lanes |= u),
      (l = l.alternate),
      l !== null && (l.lanes |= u));
  }
  function Ec(l, t, a, u) {
    return (Qe(l, t, a, u), Ze(l));
  }
  function Da(l, t) {
    return (Qe(l, null, null, t), Ze(l));
  }
  function rs(l, t, a) {
    l.lanes |= a;
    var u = l.alternate;
    u !== null && (u.lanes |= a);
    for (var e = !1, n = l.return; n !== null; )
      ((n.childLanes |= a),
        (u = n.alternate),
        u !== null && (u.childLanes |= a),
        n.tag === 22 &&
          ((l = n.stateNode), l === null || l._visibility & 1 || (e = !0)),
        (l = n),
        (n = n.return));
    return l.tag === 3
      ? ((n = l.stateNode),
        e &&
          t !== null &&
          ((e = 31 - at(a)),
          (l = n.hiddenUpdates),
          (u = l[e]),
          u === null ? (l[e] = [t]) : u.push(t),
          (t.lane = a | 536870912)),
        n)
      : null;
  }
  function Ze(l) {
    if (50 < de) throw ((de = 0), (Ui = null), Error(s(185)));
    for (var t = l.return; t !== null; ) ((l = t), (t = l.return));
    return l.tag === 3 ? l.stateNode : null;
  }
  var uu = {};
  function G0(l, t, a, u) {
    ((this.tag = l),
      (this.key = a),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.refCleanup = this.ref = null),
      (this.pendingProps = t),
      (this.dependencies =
        this.memoizedState =
        this.updateQueue =
        this.memoizedProps =
          null),
      (this.mode = u),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null));
  }
  function et(l, t, a, u) {
    return new G0(l, t, a, u);
  }
  function _c(l) {
    return ((l = l.prototype), !(!l || !l.isReactComponent));
  }
  function qt(l, t) {
    var a = l.alternate;
    return (
      a === null
        ? ((a = et(l.tag, t, l.key, l.mode)),
          (a.elementType = l.elementType),
          (a.type = l.type),
          (a.stateNode = l.stateNode),
          (a.alternate = l),
          (l.alternate = a))
        : ((a.pendingProps = t),
          (a.type = l.type),
          (a.flags = 0),
          (a.subtreeFlags = 0),
          (a.deletions = null)),
      (a.flags = l.flags & 65011712),
      (a.childLanes = l.childLanes),
      (a.lanes = l.lanes),
      (a.child = l.child),
      (a.memoizedProps = l.memoizedProps),
      (a.memoizedState = l.memoizedState),
      (a.updateQueue = l.updateQueue),
      (t = l.dependencies),
      (a.dependencies =
        t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
      (a.sibling = l.sibling),
      (a.index = l.index),
      (a.ref = l.ref),
      (a.refCleanup = l.refCleanup),
      a
    );
  }
  function gs(l, t) {
    l.flags &= 65011714;
    var a = l.alternate;
    return (
      a === null
        ? ((l.childLanes = 0),
          (l.lanes = t),
          (l.child = null),
          (l.subtreeFlags = 0),
          (l.memoizedProps = null),
          (l.memoizedState = null),
          (l.updateQueue = null),
          (l.dependencies = null),
          (l.stateNode = null))
        : ((l.childLanes = a.childLanes),
          (l.lanes = a.lanes),
          (l.child = a.child),
          (l.subtreeFlags = 0),
          (l.deletions = null),
          (l.memoizedProps = a.memoizedProps),
          (l.memoizedState = a.memoizedState),
          (l.updateQueue = a.updateQueue),
          (l.type = a.type),
          (t = a.dependencies),
          (l.dependencies =
            t === null
              ? null
              : { lanes: t.lanes, firstContext: t.firstContext })),
      l
    );
  }
  function Ve(l, t, a, u, e, n) {
    var c = 0;
    if (((u = l), typeof l == "function")) _c(l) && (c = 1);
    else if (typeof l == "string")
      c = Ly(l, a, H.current)
        ? 26
        : l === "html" || l === "head" || l === "body"
          ? 27
          : 5;
    else
      l: switch (l) {
        case At:
          return (
            (l = et(31, a, t, e)),
            (l.elementType = At),
            (l.lanes = n),
            l
          );
        case Sl:
          return Ua(a.children, e, n, t);
        case Nl:
          ((c = 8), (e |= 24));
          break;
        case jl:
          return (
            (l = et(12, a, t, e | 2)),
            (l.elementType = jl),
            (l.lanes = n),
            l
          );
        case Ll:
          return (
            (l = et(13, a, t, e)),
            (l.elementType = Ll),
            (l.lanes = n),
            l
          );
        case Hl:
          return (
            (l = et(19, a, t, e)),
            (l.elementType = Hl),
            (l.lanes = n),
            l
          );
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case ll:
                c = 10;
                break l;
              case Tt:
                c = 9;
                break l;
              case Xl:
                c = 11;
                break l;
              case I:
                c = 14;
                break l;
              case Kl:
                ((c = 16), (u = null));
                break l;
            }
          ((c = 29),
            (a = Error(s(130, l === null ? "null" : typeof l, ""))),
            (u = null));
      }
    return (
      (t = et(c, a, t, e)),
      (t.elementType = l),
      (t.type = u),
      (t.lanes = n),
      t
    );
  }
  function Ua(l, t, a, u) {
    return ((l = et(7, l, u, t)), (l.lanes = a), l);
  }
  function zc(l, t, a) {
    return ((l = et(6, l, null, t)), (l.lanes = a), l);
  }
  function Ss(l) {
    var t = et(18, null, null, 0);
    return ((t.stateNode = l), t);
  }
  function Tc(l, t, a) {
    return (
      (t = et(4, l.children !== null ? l.children : [], l.key, t)),
      (t.lanes = a),
      (t.stateNode = {
        containerInfo: l.containerInfo,
        pendingChildren: null,
        implementation: l.implementation,
      }),
      t
    );
  }
  var bs = new WeakMap();
  function yt(l, t) {
    if (typeof l == "object" && l !== null) {
      var a = bs.get(l);
      return a !== void 0
        ? a
        : ((t = { value: l, source: t, stack: Sf(t) }), bs.set(l, t), t);
    }
    return { value: l, source: t, stack: Sf(t) };
  }
  var eu = [],
    nu = 0,
    Le = null,
    Vu = 0,
    vt = [],
    ht = 0,
    Pt = null,
    Mt = 1,
    Nt = "";
  function xt(l, t) {
    ((eu[nu++] = Vu), (eu[nu++] = Le), (Le = l), (Vu = t));
  }
  function ps(l, t, a) {
    ((vt[ht++] = Mt), (vt[ht++] = Nt), (vt[ht++] = Pt), (Pt = l));
    var u = Mt;
    l = Nt;
    var e = 32 - at(u) - 1;
    ((u &= ~(1 << e)), (a += 1));
    var n = 32 - at(t) + e;
    if (30 < n) {
      var c = e - (e % 5);
      ((n = (u & ((1 << c) - 1)).toString(32)),
        (u >>= c),
        (e -= c),
        (Mt = (1 << (32 - at(t) + e)) | (a << e) | u),
        (Nt = n + l));
    } else ((Mt = (1 << n) | (a << e) | u), (Nt = l));
  }
  function Ac(l) {
    l.return !== null && (xt(l, 1), ps(l, 1, 0));
  }
  function Oc(l) {
    for (; l === Le; )
      ((Le = eu[--nu]), (eu[nu] = null), (Vu = eu[--nu]), (eu[nu] = null));
    for (; l === Pt; )
      ((Pt = vt[--ht]),
        (vt[ht] = null),
        (Nt = vt[--ht]),
        (vt[ht] = null),
        (Mt = vt[--ht]),
        (vt[ht] = null));
  }
  function Es(l, t) {
    ((vt[ht++] = Mt),
      (vt[ht++] = Nt),
      (vt[ht++] = Pt),
      (Mt = t.id),
      (Nt = t.overflow),
      (Pt = l));
  }
  var xl = null,
    hl = null,
    P = !1,
    la = null,
    rt = !1,
    Mc = Error(s(519));
  function ta(l) {
    var t = Error(
      s(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1]
          ? "text"
          : "HTML",
        "",
      ),
    );
    throw (Lu(yt(t, l)), Mc);
  }
  function _s(l) {
    var t = l.stateNode,
      a = l.type,
      u = l.memoizedProps;
    switch (((t[ql] = l), (t[wl] = u), a)) {
      case "dialog":
        ($("cancel", t), $("close", t));
        break;
      case "iframe":
      case "object":
      case "embed":
        $("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < me.length; a++) $(me[a], t);
        break;
      case "source":
        $("error", t);
        break;
      case "img":
      case "image":
      case "link":
        ($("error", t), $("load", t));
        break;
      case "details":
        $("toggle", t);
        break;
      case "input":
        ($("invalid", t),
          qf(
            t,
            u.value,
            u.defaultValue,
            u.checked,
            u.defaultChecked,
            u.type,
            u.name,
            !0,
          ));
        break;
      case "select":
        $("invalid", t);
        break;
      case "textarea":
        ($("invalid", t), Bf(t, u.value, u.defaultValue, u.children));
    }
    ((a = u.children),
      (typeof a != "string" && typeof a != "number" && typeof a != "bigint") ||
      t.textContent === "" + a ||
      u.suppressHydrationWarning === !0 ||
      Xo(t.textContent, a)
        ? (u.popover != null && ($("beforetoggle", t), $("toggle", t)),
          u.onScroll != null && $("scroll", t),
          u.onScrollEnd != null && $("scrollend", t),
          u.onClick != null && (t.onclick = Rt),
          (t = !0))
        : (t = !1),
      t || ta(l, !0));
  }
  function zs(l) {
    for (xl = l.return; xl; )
      switch (xl.tag) {
        case 5:
        case 31:
        case 13:
          rt = !1;
          return;
        case 27:
        case 3:
          rt = !0;
          return;
        default:
          xl = xl.return;
      }
  }
  function cu(l) {
    if (l !== xl) return !1;
    if (!P) return (zs(l), (P = !0), !1);
    var t = l.tag,
      a;
    if (
      ((a = t !== 3 && t !== 27) &&
        ((a = t === 5) &&
          ((a = l.type),
          (a =
            !(a !== "form" && a !== "button") || Ki(l.type, l.memoizedProps))),
        (a = !a)),
      a && hl && ta(l),
      zs(l),
      t === 13)
    ) {
      if (((l = l.memoizedState), (l = l !== null ? l.dehydrated : null), !l))
        throw Error(s(317));
      hl = $o(l);
    } else if (t === 31) {
      if (((l = l.memoizedState), (l = l !== null ? l.dehydrated : null), !l))
        throw Error(s(317));
      hl = $o(l);
    } else
      t === 27
        ? ((t = hl), ha(l.type) ? ((l = Fi), (Fi = null), (hl = l)) : (hl = t))
        : (hl = xl ? St(l.stateNode.nextSibling) : null);
    return !0;
  }
  function ja() {
    ((hl = xl = null), (P = !1));
  }
  function Nc() {
    var l = la;
    return (
      l !== null &&
        (Il === null ? (Il = l) : Il.push.apply(Il, l), (la = null)),
      l
    );
  }
  function Lu(l) {
    la === null ? (la = [l]) : la.push(l);
  }
  var Dc = o(null),
    Ha = null,
    Bt = null;
  function aa(l, t, a) {
    (U(Dc, t._currentValue), (t._currentValue = a));
  }
  function Yt(l) {
    ((l._currentValue = Dc.current), A(Dc));
  }
  function Uc(l, t, a) {
    for (; l !== null; ) {
      var u = l.alternate;
      if (
        ((l.childLanes & t) !== t
          ? ((l.childLanes |= t), u !== null && (u.childLanes |= t))
          : u !== null && (u.childLanes & t) !== t && (u.childLanes |= t),
        l === a)
      )
        break;
      l = l.return;
    }
  }
  function jc(l, t, a, u) {
    var e = l.child;
    for (e !== null && (e.return = l); e !== null; ) {
      var n = e.dependencies;
      if (n !== null) {
        var c = e.child;
        n = n.firstContext;
        l: for (; n !== null; ) {
          var i = n;
          n = e;
          for (var f = 0; f < t.length; f++)
            if (i.context === t[f]) {
              ((n.lanes |= a),
                (i = n.alternate),
                i !== null && (i.lanes |= a),
                Uc(n.return, a, l),
                u || (c = null));
              break l;
            }
          n = i.next;
        }
      } else if (e.tag === 18) {
        if (((c = e.return), c === null)) throw Error(s(341));
        ((c.lanes |= a),
          (n = c.alternate),
          n !== null && (n.lanes |= a),
          Uc(c, a, l),
          (c = null));
      } else c = e.child;
      if (c !== null) c.return = e;
      else
        for (c = e; c !== null; ) {
          if (c === l) {
            c = null;
            break;
          }
          if (((e = c.sibling), e !== null)) {
            ((e.return = c.return), (c = e));
            break;
          }
          c = c.return;
        }
      e = c;
    }
  }
  function iu(l, t, a, u) {
    l = null;
    for (var e = t, n = !1; e !== null; ) {
      if (!n) {
        if ((e.flags & 524288) !== 0) n = !0;
        else if ((e.flags & 262144) !== 0) break;
      }
      if (e.tag === 10) {
        var c = e.alternate;
        if (c === null) throw Error(s(387));
        if (((c = c.memoizedProps), c !== null)) {
          var i = e.type;
          ut(e.pendingProps.value, c.value) ||
            (l !== null ? l.push(i) : (l = [i]));
        }
      } else if (e === el.current) {
        if (((c = e.alternate), c === null)) throw Error(s(387));
        c.memoizedState.memoizedState !== e.memoizedState.memoizedState &&
          (l !== null ? l.push(ge) : (l = [ge]));
      }
      e = e.return;
    }
    (l !== null && jc(t, l, a, u), (t.flags |= 262144));
  }
  function Ke(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!ut(l.context._currentValue, l.memoizedValue)) return !0;
      l = l.next;
    }
    return !1;
  }
  function Ra(l) {
    ((Ha = l),
      (Bt = null),
      (l = l.dependencies),
      l !== null && (l.firstContext = null));
  }
  function Bl(l) {
    return Ts(Ha, l);
  }
  function Je(l, t) {
    return (Ha === null && Ra(l), Ts(l, t));
  }
  function Ts(l, t) {
    var a = t._currentValue;
    if (((t = { context: t, memoizedValue: a, next: null }), Bt === null)) {
      if (l === null) throw Error(s(308));
      ((Bt = t),
        (l.dependencies = { lanes: 0, firstContext: t }),
        (l.flags |= 524288));
    } else Bt = Bt.next = t;
    return a;
  }
  var X0 =
      typeof AbortController < "u"
        ? AbortController
        : function () {
            var l = [],
              t = (this.signal = {
                aborted: !1,
                addEventListener: function (a, u) {
                  l.push(u);
                },
              });
            this.abort = function () {
              ((t.aborted = !0),
                l.forEach(function (a) {
                  return a();
                }));
            };
          },
    Q0 = h.unstable_scheduleCallback,
    Z0 = h.unstable_NormalPriority,
    Tl = {
      $$typeof: ll,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
    };
  function Hc() {
    return { controller: new X0(), data: new Map(), refCount: 0 };
  }
  function Ku(l) {
    (l.refCount--,
      l.refCount === 0 &&
        Q0(Z0, function () {
          l.controller.abort();
        }));
  }
  var Ju = null,
    Rc = 0,
    fu = 0,
    su = null;
  function V0(l, t) {
    if (Ju === null) {
      var a = (Ju = []);
      ((Rc = 0),
        (fu = xi()),
        (su = {
          status: "pending",
          value: void 0,
          then: function (u) {
            a.push(u);
          },
        }));
    }
    return (Rc++, t.then(As, As), t);
  }
  function As() {
    if (--Rc === 0 && Ju !== null) {
      su !== null && (su.status = "fulfilled");
      var l = Ju;
      ((Ju = null), (fu = 0), (su = null));
      for (var t = 0; t < l.length; t++) (0, l[t])();
    }
  }
  function L0(l, t) {
    var a = [],
      u = {
        status: "pending",
        value: null,
        reason: null,
        then: function (e) {
          a.push(e);
        },
      };
    return (
      l.then(
        function () {
          ((u.status = "fulfilled"), (u.value = t));
          for (var e = 0; e < a.length; e++) (0, a[e])(t);
        },
        function (e) {
          for (u.status = "rejected", u.reason = e, e = 0; e < a.length; e++)
            (0, a[e])(void 0);
        },
      ),
      u
    );
  }
  var Os = E.S;
  E.S = function (l, t) {
    ((so = lt()),
      typeof t == "object" &&
        t !== null &&
        typeof t.then == "function" &&
        V0(l, t),
      Os !== null && Os(l, t));
  };
  var Ca = o(null);
  function Cc() {
    var l = Ca.current;
    return l !== null ? l : yl.pooledCache;
  }
  function we(l, t) {
    t === null ? U(Ca, Ca.current) : U(Ca, t.pool);
  }
  function Ms() {
    var l = Cc();
    return l === null ? null : { parent: Tl._currentValue, pool: l };
  }
  var du = Error(s(460)),
    qc = Error(s(474)),
    We = Error(s(542)),
    $e = { then: function () {} };
  function Ns(l) {
    return ((l = l.status), l === "fulfilled" || l === "rejected");
  }
  function Ds(l, t, a) {
    switch (
      ((a = l[a]),
      a === void 0 ? l.push(t) : a !== t && (t.then(Rt, Rt), (t = a)),
      t.status)
    ) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw ((l = t.reason), js(l), l);
      default:
        if (typeof t.status == "string") t.then(Rt, Rt);
        else {
          if (((l = yl), l !== null && 100 < l.shellSuspendCounter))
            throw Error(s(482));
          ((l = t),
            (l.status = "pending"),
            l.then(
              function (u) {
                if (t.status === "pending") {
                  var e = t;
                  ((e.status = "fulfilled"), (e.value = u));
                }
              },
              function (u) {
                if (t.status === "pending") {
                  var e = t;
                  ((e.status = "rejected"), (e.reason = u));
                }
              },
            ));
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw ((l = t.reason), js(l), l);
        }
        throw ((xa = t), du);
    }
  }
  function qa(l) {
    try {
      var t = l._init;
      return t(l._payload);
    } catch (a) {
      throw a !== null && typeof a == "object" && typeof a.then == "function"
        ? ((xa = a), du)
        : a;
    }
  }
  var xa = null;
  function Us() {
    if (xa === null) throw Error(s(459));
    var l = xa;
    return ((xa = null), l);
  }
  function js(l) {
    if (l === du || l === We) throw Error(s(483));
  }
  var ou = null,
    wu = 0;
  function Fe(l) {
    var t = wu;
    return ((wu += 1), ou === null && (ou = []), Ds(ou, l, t));
  }
  function Wu(l, t) {
    ((t = t.props.ref), (l.ref = t !== void 0 ? t : null));
  }
  function ke(l, t) {
    throw t.$$typeof === B
      ? Error(s(525))
      : ((l = Object.prototype.toString.call(t)),
        Error(
          s(
            31,
            l === "[object Object]"
              ? "object with keys {" + Object.keys(t).join(", ") + "}"
              : l,
          ),
        ));
  }
  function Hs(l) {
    function t(m, d) {
      if (l) {
        var y = m.deletions;
        y === null ? ((m.deletions = [d]), (m.flags |= 16)) : y.push(d);
      }
    }
    function a(m, d) {
      if (!l) return null;
      for (; d !== null; ) (t(m, d), (d = d.sibling));
      return null;
    }
    function u(m) {
      for (var d = new Map(); m !== null; )
        (m.key !== null ? d.set(m.key, m) : d.set(m.index, m), (m = m.sibling));
      return d;
    }
    function e(m, d) {
      return ((m = qt(m, d)), (m.index = 0), (m.sibling = null), m);
    }
    function n(m, d, y) {
      return (
        (m.index = y),
        l
          ? ((y = m.alternate),
            y !== null
              ? ((y = y.index), y < d ? ((m.flags |= 67108866), d) : y)
              : ((m.flags |= 67108866), d))
          : ((m.flags |= 1048576), d)
      );
    }
    function c(m) {
      return (l && m.alternate === null && (m.flags |= 67108866), m);
    }
    function i(m, d, y, _) {
      return d === null || d.tag !== 6
        ? ((d = zc(y, m.mode, _)), (d.return = m), d)
        : ((d = e(d, y)), (d.return = m), d);
    }
    function f(m, d, y, _) {
      var x = y.type;
      return x === Sl
        ? p(m, d, y.props.children, _, y.key)
        : d !== null &&
            (d.elementType === x ||
              (typeof x == "object" &&
                x !== null &&
                x.$$typeof === Kl &&
                qa(x) === d.type))
          ? ((d = e(d, y.props)), Wu(d, y), (d.return = m), d)
          : ((d = Ve(y.type, y.key, y.props, null, m.mode, _)),
            Wu(d, y),
            (d.return = m),
            d);
    }
    function v(m, d, y, _) {
      return d === null ||
        d.tag !== 4 ||
        d.stateNode.containerInfo !== y.containerInfo ||
        d.stateNode.implementation !== y.implementation
        ? ((d = Tc(y, m.mode, _)), (d.return = m), d)
        : ((d = e(d, y.children || [])), (d.return = m), d);
    }
    function p(m, d, y, _, x) {
      return d === null || d.tag !== 7
        ? ((d = Ua(y, m.mode, _, x)), (d.return = m), d)
        : ((d = e(d, y)), (d.return = m), d);
    }
    function z(m, d, y) {
      if (
        (typeof d == "string" && d !== "") ||
        typeof d == "number" ||
        typeof d == "bigint"
      )
        return ((d = zc("" + d, m.mode, y)), (d.return = m), d);
      if (typeof d == "object" && d !== null) {
        switch (d.$$typeof) {
          case vl:
            return (
              (y = Ve(d.type, d.key, d.props, null, m.mode, y)),
              Wu(y, d),
              (y.return = m),
              y
            );
          case ol:
            return ((d = Tc(d, m.mode, y)), (d.return = m), d);
          case Kl:
            return ((d = qa(d)), z(m, d, y));
        }
        if (pt(d) || Jl(d))
          return ((d = Ua(d, m.mode, y, null)), (d.return = m), d);
        if (typeof d.then == "function") return z(m, Fe(d), y);
        if (d.$$typeof === ll) return z(m, Je(m, d), y);
        ke(m, d);
      }
      return null;
    }
    function r(m, d, y, _) {
      var x = d !== null ? d.key : null;
      if (
        (typeof y == "string" && y !== "") ||
        typeof y == "number" ||
        typeof y == "bigint"
      )
        return x !== null ? null : i(m, d, "" + y, _);
      if (typeof y == "object" && y !== null) {
        switch (y.$$typeof) {
          case vl:
            return y.key === x ? f(m, d, y, _) : null;
          case ol:
            return y.key === x ? v(m, d, y, _) : null;
          case Kl:
            return ((y = qa(y)), r(m, d, y, _));
        }
        if (pt(y) || Jl(y)) return x !== null ? null : p(m, d, y, _, null);
        if (typeof y.then == "function") return r(m, d, Fe(y), _);
        if (y.$$typeof === ll) return r(m, d, Je(m, y), _);
        ke(m, y);
      }
      return null;
    }
    function S(m, d, y, _, x) {
      if (
        (typeof _ == "string" && _ !== "") ||
        typeof _ == "number" ||
        typeof _ == "bigint"
      )
        return ((m = m.get(y) || null), i(d, m, "" + _, x));
      if (typeof _ == "object" && _ !== null) {
        switch (_.$$typeof) {
          case vl:
            return (
              (m = m.get(_.key === null ? y : _.key) || null),
              f(d, m, _, x)
            );
          case ol:
            return (
              (m = m.get(_.key === null ? y : _.key) || null),
              v(d, m, _, x)
            );
          case Kl:
            return ((_ = qa(_)), S(m, d, y, _, x));
        }
        if (pt(_) || Jl(_))
          return ((m = m.get(y) || null), p(d, m, _, x, null));
        if (typeof _.then == "function") return S(m, d, y, Fe(_), x);
        if (_.$$typeof === ll) return S(m, d, y, Je(d, _), x);
        ke(d, _);
      }
      return null;
    }
    function j(m, d, y, _) {
      for (
        var x = null, tl = null, C = d, K = (d = 0), k = null;
        C !== null && K < y.length;
        K++
      ) {
        C.index > K ? ((k = C), (C = null)) : (k = C.sibling);
        var al = r(m, C, y[K], _);
        if (al === null) {
          C === null && (C = k);
          break;
        }
        (l && C && al.alternate === null && t(m, C),
          (d = n(al, d, K)),
          tl === null ? (x = al) : (tl.sibling = al),
          (tl = al),
          (C = k));
      }
      if (K === y.length) return (a(m, C), P && xt(m, K), x);
      if (C === null) {
        for (; K < y.length; K++)
          ((C = z(m, y[K], _)),
            C !== null &&
              ((d = n(C, d, K)),
              tl === null ? (x = C) : (tl.sibling = C),
              (tl = C)));
        return (P && xt(m, K), x);
      }
      for (C = u(C); K < y.length; K++)
        ((k = S(C, m, K, y[K], _)),
          k !== null &&
            (l && k.alternate !== null && C.delete(k.key === null ? K : k.key),
            (d = n(k, d, K)),
            tl === null ? (x = k) : (tl.sibling = k),
            (tl = k)));
      return (
        l &&
          C.forEach(function (pa) {
            return t(m, pa);
          }),
        P && xt(m, K),
        x
      );
    }
    function G(m, d, y, _) {
      if (y == null) throw Error(s(151));
      for (
        var x = null, tl = null, C = d, K = (d = 0), k = null, al = y.next();
        C !== null && !al.done;
        K++, al = y.next()
      ) {
        C.index > K ? ((k = C), (C = null)) : (k = C.sibling);
        var pa = r(m, C, al.value, _);
        if (pa === null) {
          C === null && (C = k);
          break;
        }
        (l && C && pa.alternate === null && t(m, C),
          (d = n(pa, d, K)),
          tl === null ? (x = pa) : (tl.sibling = pa),
          (tl = pa),
          (C = k));
      }
      if (al.done) return (a(m, C), P && xt(m, K), x);
      if (C === null) {
        for (; !al.done; K++, al = y.next())
          ((al = z(m, al.value, _)),
            al !== null &&
              ((d = n(al, d, K)),
              tl === null ? (x = al) : (tl.sibling = al),
              (tl = al)));
        return (P && xt(m, K), x);
      }
      for (C = u(C); !al.done; K++, al = y.next())
        ((al = S(C, m, K, al.value, _)),
          al !== null &&
            (l &&
              al.alternate !== null &&
              C.delete(al.key === null ? K : al.key),
            (d = n(al, d, K)),
            tl === null ? (x = al) : (tl.sibling = al),
            (tl = al)));
      return (
        l &&
          C.forEach(function (tv) {
            return t(m, tv);
          }),
        P && xt(m, K),
        x
      );
    }
    function dl(m, d, y, _) {
      if (
        (typeof y == "object" &&
          y !== null &&
          y.type === Sl &&
          y.key === null &&
          (y = y.props.children),
        typeof y == "object" && y !== null)
      ) {
        switch (y.$$typeof) {
          case vl:
            l: {
              for (var x = y.key; d !== null; ) {
                if (d.key === x) {
                  if (((x = y.type), x === Sl)) {
                    if (d.tag === 7) {
                      (a(m, d.sibling),
                        (_ = e(d, y.props.children)),
                        (_.return = m),
                        (m = _));
                      break l;
                    }
                  } else if (
                    d.elementType === x ||
                    (typeof x == "object" &&
                      x !== null &&
                      x.$$typeof === Kl &&
                      qa(x) === d.type)
                  ) {
                    (a(m, d.sibling),
                      (_ = e(d, y.props)),
                      Wu(_, y),
                      (_.return = m),
                      (m = _));
                    break l;
                  }
                  a(m, d);
                  break;
                } else t(m, d);
                d = d.sibling;
              }
              y.type === Sl
                ? ((_ = Ua(y.props.children, m.mode, _, y.key)),
                  (_.return = m),
                  (m = _))
                : ((_ = Ve(y.type, y.key, y.props, null, m.mode, _)),
                  Wu(_, y),
                  (_.return = m),
                  (m = _));
            }
            return c(m);
          case ol:
            l: {
              for (x = y.key; d !== null; ) {
                if (d.key === x)
                  if (
                    d.tag === 4 &&
                    d.stateNode.containerInfo === y.containerInfo &&
                    d.stateNode.implementation === y.implementation
                  ) {
                    (a(m, d.sibling),
                      (_ = e(d, y.children || [])),
                      (_.return = m),
                      (m = _));
                    break l;
                  } else {
                    a(m, d);
                    break;
                  }
                else t(m, d);
                d = d.sibling;
              }
              ((_ = Tc(y, m.mode, _)), (_.return = m), (m = _));
            }
            return c(m);
          case Kl:
            return ((y = qa(y)), dl(m, d, y, _));
        }
        if (pt(y)) return j(m, d, y, _);
        if (Jl(y)) {
          if (((x = Jl(y)), typeof x != "function")) throw Error(s(150));
          return ((y = x.call(y)), G(m, d, y, _));
        }
        if (typeof y.then == "function") return dl(m, d, Fe(y), _);
        if (y.$$typeof === ll) return dl(m, d, Je(m, y), _);
        ke(m, y);
      }
      return (typeof y == "string" && y !== "") ||
        typeof y == "number" ||
        typeof y == "bigint"
        ? ((y = "" + y),
          d !== null && d.tag === 6
            ? (a(m, d.sibling), (_ = e(d, y)), (_.return = m), (m = _))
            : (a(m, d), (_ = zc(y, m.mode, _)), (_.return = m), (m = _)),
          c(m))
        : a(m, d);
    }
    return function (m, d, y, _) {
      try {
        wu = 0;
        var x = dl(m, d, y, _);
        return ((ou = null), x);
      } catch (C) {
        if (C === du || C === We) throw C;
        var tl = et(29, C, null, m.mode);
        return ((tl.lanes = _), (tl.return = m), tl);
      }
    };
  }
  var Ba = Hs(!0),
    Rs = Hs(!1),
    ua = !1;
  function xc(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null,
    };
  }
  function Bc(l, t) {
    ((l = l.updateQueue),
      t.updateQueue === l &&
        (t.updateQueue = {
          baseState: l.baseState,
          firstBaseUpdate: l.firstBaseUpdate,
          lastBaseUpdate: l.lastBaseUpdate,
          shared: l.shared,
          callbacks: null,
        }));
  }
  function ea(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function na(l, t, a) {
    var u = l.updateQueue;
    if (u === null) return null;
    if (((u = u.shared), (ul & 2) !== 0)) {
      var e = u.pending;
      return (
        e === null ? (t.next = t) : ((t.next = e.next), (e.next = t)),
        (u.pending = t),
        (t = Ze(l)),
        rs(l, null, a),
        t
      );
    }
    return (Qe(l, u, t, a), Ze(l));
  }
  function $u(l, t, a) {
    if (
      ((t = t.updateQueue), t !== null && ((t = t.shared), (a & 4194048) !== 0))
    ) {
      var u = t.lanes;
      ((u &= l.pendingLanes), (a |= u), (t.lanes = a), Tf(l, a));
    }
  }
  function Yc(l, t) {
    var a = l.updateQueue,
      u = l.alternate;
    if (u !== null && ((u = u.updateQueue), a === u)) {
      var e = null,
        n = null;
      if (((a = a.firstBaseUpdate), a !== null)) {
        do {
          var c = {
            lane: a.lane,
            tag: a.tag,
            payload: a.payload,
            callback: null,
            next: null,
          };
          (n === null ? (e = n = c) : (n = n.next = c), (a = a.next));
        } while (a !== null);
        n === null ? (e = n = t) : (n = n.next = t);
      } else e = n = t;
      ((a = {
        baseState: u.baseState,
        firstBaseUpdate: e,
        lastBaseUpdate: n,
        shared: u.shared,
        callbacks: u.callbacks,
      }),
        (l.updateQueue = a));
      return;
    }
    ((l = a.lastBaseUpdate),
      l === null ? (a.firstBaseUpdate = t) : (l.next = t),
      (a.lastBaseUpdate = t));
  }
  var Gc = !1;
  function Fu() {
    if (Gc) {
      var l = su;
      if (l !== null) throw l;
    }
  }
  function ku(l, t, a, u) {
    Gc = !1;
    var e = l.updateQueue;
    ua = !1;
    var n = e.firstBaseUpdate,
      c = e.lastBaseUpdate,
      i = e.shared.pending;
    if (i !== null) {
      e.shared.pending = null;
      var f = i,
        v = f.next;
      ((f.next = null), c === null ? (n = v) : (c.next = v), (c = f));
      var p = l.alternate;
      p !== null &&
        ((p = p.updateQueue),
        (i = p.lastBaseUpdate),
        i !== c &&
          (i === null ? (p.firstBaseUpdate = v) : (i.next = v),
          (p.lastBaseUpdate = f)));
    }
    if (n !== null) {
      var z = e.baseState;
      ((c = 0), (p = v = f = null), (i = n));
      do {
        var r = i.lane & -536870913,
          S = r !== i.lane;
        if (S ? (F & r) === r : (u & r) === r) {
          (r !== 0 && r === fu && (Gc = !0),
            p !== null &&
              (p = p.next =
                {
                  lane: 0,
                  tag: i.tag,
                  payload: i.payload,
                  callback: null,
                  next: null,
                }));
          l: {
            var j = l,
              G = i;
            r = t;
            var dl = a;
            switch (G.tag) {
              case 1:
                if (((j = G.payload), typeof j == "function")) {
                  z = j.call(dl, z, r);
                  break l;
                }
                z = j;
                break l;
              case 3:
                j.flags = (j.flags & -65537) | 128;
              case 0:
                if (
                  ((j = G.payload),
                  (r = typeof j == "function" ? j.call(dl, z, r) : j),
                  r == null)
                )
                  break l;
                z = N({}, z, r);
                break l;
              case 2:
                ua = !0;
            }
          }
          ((r = i.callback),
            r !== null &&
              ((l.flags |= 64),
              S && (l.flags |= 8192),
              (S = e.callbacks),
              S === null ? (e.callbacks = [r]) : S.push(r)));
        } else
          ((S = {
            lane: r,
            tag: i.tag,
            payload: i.payload,
            callback: i.callback,
            next: null,
          }),
            p === null ? ((v = p = S), (f = z)) : (p = p.next = S),
            (c |= r));
        if (((i = i.next), i === null)) {
          if (((i = e.shared.pending), i === null)) break;
          ((S = i),
            (i = S.next),
            (S.next = null),
            (e.lastBaseUpdate = S),
            (e.shared.pending = null));
        }
      } while (!0);
      (p === null && (f = z),
        (e.baseState = f),
        (e.firstBaseUpdate = v),
        (e.lastBaseUpdate = p),
        n === null && (e.shared.lanes = 0),
        (da |= c),
        (l.lanes = c),
        (l.memoizedState = z));
    }
  }
  function Cs(l, t) {
    if (typeof l != "function") throw Error(s(191, l));
    l.call(t);
  }
  function qs(l, t) {
    var a = l.callbacks;
    if (a !== null)
      for (l.callbacks = null, l = 0; l < a.length; l++) Cs(a[l], t);
  }
  var mu = o(null),
    Ie = o(0);
  function xs(l, t) {
    ((l = wt), U(Ie, l), U(mu, t), (wt = l | t.baseLanes));
  }
  function Xc() {
    (U(Ie, wt), U(mu, mu.current));
  }
  function Qc() {
    ((wt = Ie.current), A(mu), A(Ie));
  }
  var nt = o(null),
    gt = null;
  function ca(l) {
    var t = l.alternate;
    (U(_l, _l.current & 1),
      U(nt, l),
      gt === null &&
        (t === null || mu.current !== null || t.memoizedState !== null) &&
        (gt = l));
  }
  function Zc(l) {
    (U(_l, _l.current), U(nt, l), gt === null && (gt = l));
  }
  function Bs(l) {
    l.tag === 22
      ? (U(_l, _l.current), U(nt, l), gt === null && (gt = l))
      : ia();
  }
  function ia() {
    (U(_l, _l.current), U(nt, nt.current));
  }
  function ct(l) {
    (A(nt), gt === l && (gt = null), A(_l));
  }
  var _l = o(0);
  function Pe(l) {
    for (var t = l; t !== null; ) {
      if (t.tag === 13) {
        var a = t.memoizedState;
        if (a !== null && ((a = a.dehydrated), a === null || Wi(a) || $i(a)))
          return t;
      } else if (
        t.tag === 19 &&
        (t.memoizedProps.revealOrder === "forwards" ||
          t.memoizedProps.revealOrder === "backwards" ||
          t.memoizedProps.revealOrder === "unstable_legacy-backwards" ||
          t.memoizedProps.revealOrder === "together")
      ) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        ((t.child.return = t), (t = t.child));
        continue;
      }
      if (t === l) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === l) return null;
        t = t.return;
      }
      ((t.sibling.return = t.return), (t = t.sibling));
    }
    return null;
  }
  var Gt = 0,
    V = null,
    fl = null,
    Al = null,
    ln = !1,
    yu = !1,
    Ya = !1,
    tn = 0,
    Iu = 0,
    vu = null,
    K0 = 0;
  function bl() {
    throw Error(s(321));
  }
  function Vc(l, t) {
    if (t === null) return !1;
    for (var a = 0; a < t.length && a < l.length; a++)
      if (!ut(l[a], t[a])) return !1;
    return !0;
  }
  function Lc(l, t, a, u, e, n) {
    return (
      (Gt = n),
      (V = t),
      (t.memoizedState = null),
      (t.updateQueue = null),
      (t.lanes = 0),
      (E.H = l === null || l.memoizedState === null ? pd : ni),
      (Ya = !1),
      (n = a(u, e)),
      (Ya = !1),
      yu && (n = Gs(t, a, u, e)),
      Ys(l),
      n
    );
  }
  function Ys(l) {
    E.H = te;
    var t = fl !== null && fl.next !== null;
    if (((Gt = 0), (Al = fl = V = null), (ln = !1), (Iu = 0), (vu = null), t))
      throw Error(s(300));
    l === null ||
      Ol ||
      ((l = l.dependencies), l !== null && Ke(l) && (Ol = !0));
  }
  function Gs(l, t, a, u) {
    V = l;
    var e = 0;
    do {
      if ((yu && (vu = null), (Iu = 0), (yu = !1), 25 <= e))
        throw Error(s(301));
      if (((e += 1), (Al = fl = null), l.updateQueue != null)) {
        var n = l.updateQueue;
        ((n.lastEffect = null),
          (n.events = null),
          (n.stores = null),
          n.memoCache != null && (n.memoCache.index = 0));
      }
      ((E.H = Ed), (n = t(a, u)));
    } while (yu);
    return n;
  }
  function J0() {
    var l = E.H,
      t = l.useState()[0];
    return (
      (t = typeof t.then == "function" ? Pu(t) : t),
      (l = l.useState()[0]),
      (fl !== null ? fl.memoizedState : null) !== l && (V.flags |= 1024),
      t
    );
  }
  function Kc() {
    var l = tn !== 0;
    return ((tn = 0), l);
  }
  function Jc(l, t, a) {
    ((t.updateQueue = l.updateQueue), (t.flags &= -2053), (l.lanes &= ~a));
  }
  function wc(l) {
    if (ln) {
      for (l = l.memoizedState; l !== null; ) {
        var t = l.queue;
        (t !== null && (t.pending = null), (l = l.next));
      }
      ln = !1;
    }
    ((Gt = 0), (Al = fl = V = null), (yu = !1), (Iu = tn = 0), (vu = null));
  }
  function Vl() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null,
    };
    return (Al === null ? (V.memoizedState = Al = l) : (Al = Al.next = l), Al);
  }
  function zl() {
    if (fl === null) {
      var l = V.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = fl.next;
    var t = Al === null ? V.memoizedState : Al.next;
    if (t !== null) ((Al = t), (fl = l));
    else {
      if (l === null)
        throw V.alternate === null ? Error(s(467)) : Error(s(310));
      ((fl = l),
        (l = {
          memoizedState: fl.memoizedState,
          baseState: fl.baseState,
          baseQueue: fl.baseQueue,
          queue: fl.queue,
          next: null,
        }),
        Al === null ? (V.memoizedState = Al = l) : (Al = Al.next = l));
    }
    return Al;
  }
  function an() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Pu(l) {
    var t = Iu;
    return (
      (Iu += 1),
      vu === null && (vu = []),
      (l = Ds(vu, l, t)),
      (t = V),
      (Al === null ? t.memoizedState : Al.next) === null &&
        ((t = t.alternate),
        (E.H = t === null || t.memoizedState === null ? pd : ni)),
      l
    );
  }
  function un(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return Pu(l);
      if (l.$$typeof === ll) return Bl(l);
    }
    throw Error(s(438, String(l)));
  }
  function Wc(l) {
    var t = null,
      a = V.updateQueue;
    if ((a !== null && (t = a.memoCache), t == null)) {
      var u = V.alternate;
      u !== null &&
        ((u = u.updateQueue),
        u !== null &&
          ((u = u.memoCache),
          u != null &&
            (t = {
              data: u.data.map(function (e) {
                return e.slice();
              }),
              index: 0,
            })));
    }
    if (
      (t == null && (t = { data: [], index: 0 }),
      a === null && ((a = an()), (V.updateQueue = a)),
      (a.memoCache = t),
      (a = t.data[t.index]),
      a === void 0)
    )
      for (a = t.data[t.index] = Array(l), u = 0; u < l; u++) a[u] = Va;
    return (t.index++, a);
  }
  function Xt(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function en(l) {
    var t = zl();
    return $c(t, fl, l);
  }
  function $c(l, t, a) {
    var u = l.queue;
    if (u === null) throw Error(s(311));
    u.lastRenderedReducer = a;
    var e = l.baseQueue,
      n = u.pending;
    if (n !== null) {
      if (e !== null) {
        var c = e.next;
        ((e.next = n.next), (n.next = c));
      }
      ((t.baseQueue = e = n), (u.pending = null));
    }
    if (((n = l.baseState), e === null)) l.memoizedState = n;
    else {
      t = e.next;
      var i = (c = null),
        f = null,
        v = t,
        p = !1;
      do {
        var z = v.lane & -536870913;
        if (z !== v.lane ? (F & z) === z : (Gt & z) === z) {
          var r = v.revertLane;
          if (r === 0)
            (f !== null &&
              (f = f.next =
                {
                  lane: 0,
                  revertLane: 0,
                  gesture: null,
                  action: v.action,
                  hasEagerState: v.hasEagerState,
                  eagerState: v.eagerState,
                  next: null,
                }),
              z === fu && (p = !0));
          else if ((Gt & r) === r) {
            ((v = v.next), r === fu && (p = !0));
            continue;
          } else
            ((z = {
              lane: 0,
              revertLane: v.revertLane,
              gesture: null,
              action: v.action,
              hasEagerState: v.hasEagerState,
              eagerState: v.eagerState,
              next: null,
            }),
              f === null ? ((i = f = z), (c = n)) : (f = f.next = z),
              (V.lanes |= r),
              (da |= r));
          ((z = v.action),
            Ya && a(n, z),
            (n = v.hasEagerState ? v.eagerState : a(n, z)));
        } else
          ((r = {
            lane: z,
            revertLane: v.revertLane,
            gesture: v.gesture,
            action: v.action,
            hasEagerState: v.hasEagerState,
            eagerState: v.eagerState,
            next: null,
          }),
            f === null ? ((i = f = r), (c = n)) : (f = f.next = r),
            (V.lanes |= z),
            (da |= z));
        v = v.next;
      } while (v !== null && v !== t);
      if (
        (f === null ? (c = n) : (f.next = i),
        !ut(n, l.memoizedState) && ((Ol = !0), p && ((a = su), a !== null)))
      )
        throw a;
      ((l.memoizedState = n),
        (l.baseState = c),
        (l.baseQueue = f),
        (u.lastRenderedState = n));
    }
    return (e === null && (u.lanes = 0), [l.memoizedState, u.dispatch]);
  }
  function Fc(l) {
    var t = zl(),
      a = t.queue;
    if (a === null) throw Error(s(311));
    a.lastRenderedReducer = l;
    var u = a.dispatch,
      e = a.pending,
      n = t.memoizedState;
    if (e !== null) {
      a.pending = null;
      var c = (e = e.next);
      do ((n = l(n, c.action)), (c = c.next));
      while (c !== e);
      (ut(n, t.memoizedState) || (Ol = !0),
        (t.memoizedState = n),
        t.baseQueue === null && (t.baseState = n),
        (a.lastRenderedState = n));
    }
    return [n, u];
  }
  function Xs(l, t, a) {
    var u = V,
      e = zl(),
      n = P;
    if (n) {
      if (a === void 0) throw Error(s(407));
      a = a();
    } else a = t();
    var c = !ut((fl || e).memoizedState, a);
    if (
      (c && ((e.memoizedState = a), (Ol = !0)),
      (e = e.queue),
      Pc(Vs.bind(null, u, e, l), [l]),
      e.getSnapshot !== t || c || (Al !== null && Al.memoizedState.tag & 1))
    ) {
      if (
        ((u.flags |= 2048),
        hu(9, { destroy: void 0 }, Zs.bind(null, u, e, a, t), null),
        yl === null)
      )
        throw Error(s(349));
      n || (Gt & 127) !== 0 || Qs(u, t, a);
    }
    return a;
  }
  function Qs(l, t, a) {
    ((l.flags |= 16384),
      (l = { getSnapshot: t, value: a }),
      (t = V.updateQueue),
      t === null
        ? ((t = an()), (V.updateQueue = t), (t.stores = [l]))
        : ((a = t.stores), a === null ? (t.stores = [l]) : a.push(l)));
  }
  function Zs(l, t, a, u) {
    ((t.value = a), (t.getSnapshot = u), Ls(t) && Ks(l));
  }
  function Vs(l, t, a) {
    return a(function () {
      Ls(t) && Ks(l);
    });
  }
  function Ls(l) {
    var t = l.getSnapshot;
    l = l.value;
    try {
      var a = t();
      return !ut(l, a);
    } catch {
      return !0;
    }
  }
  function Ks(l) {
    var t = Da(l, 2);
    t !== null && Pl(t, l, 2);
  }
  function kc(l) {
    var t = Vl();
    if (typeof l == "function") {
      var a = l;
      if (((l = a()), Ya)) {
        Ft(!0);
        try {
          a();
        } finally {
          Ft(!1);
        }
      }
    }
    return (
      (t.memoizedState = t.baseState = l),
      (t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Xt,
        lastRenderedState: l,
      }),
      t
    );
  }
  function Js(l, t, a, u) {
    return ((l.baseState = a), $c(l, fl, typeof u == "function" ? u : Xt));
  }
  function w0(l, t, a, u, e) {
    if (fn(l)) throw Error(s(485));
    if (((l = t.action), l !== null)) {
      var n = {
        payload: e,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function (c) {
          n.listeners.push(c);
        },
      };
      (E.T !== null ? a(!0) : (n.isTransition = !1),
        u(n),
        (a = t.pending),
        a === null
          ? ((n.next = t.pending = n), ws(t, n))
          : ((n.next = a.next), (t.pending = a.next = n)));
    }
  }
  function ws(l, t) {
    var a = t.action,
      u = t.payload,
      e = l.state;
    if (t.isTransition) {
      var n = E.T,
        c = {};
      E.T = c;
      try {
        var i = a(e, u),
          f = E.S;
        (f !== null && f(c, i), Ws(l, t, i));
      } catch (v) {
        Ic(l, t, v);
      } finally {
        (n !== null && c.types !== null && (n.types = c.types), (E.T = n));
      }
    } else
      try {
        ((n = a(e, u)), Ws(l, t, n));
      } catch (v) {
        Ic(l, t, v);
      }
  }
  function Ws(l, t, a) {
    a !== null && typeof a == "object" && typeof a.then == "function"
      ? a.then(
          function (u) {
            $s(l, t, u);
          },
          function (u) {
            return Ic(l, t, u);
          },
        )
      : $s(l, t, a);
  }
  function $s(l, t, a) {
    ((t.status = "fulfilled"),
      (t.value = a),
      Fs(t),
      (l.state = a),
      (t = l.pending),
      t !== null &&
        ((a = t.next),
        a === t ? (l.pending = null) : ((a = a.next), (t.next = a), ws(l, a))));
  }
  function Ic(l, t, a) {
    var u = l.pending;
    if (((l.pending = null), u !== null)) {
      u = u.next;
      do ((t.status = "rejected"), (t.reason = a), Fs(t), (t = t.next));
      while (t !== u);
    }
    l.action = null;
  }
  function Fs(l) {
    l = l.listeners;
    for (var t = 0; t < l.length; t++) (0, l[t])();
  }
  function ks(l, t) {
    return t;
  }
  function Is(l, t) {
    if (P) {
      var a = yl.formState;
      if (a !== null) {
        l: {
          var u = V;
          if (P) {
            if (hl) {
              t: {
                for (var e = hl, n = rt; e.nodeType !== 8; ) {
                  if (!n) {
                    e = null;
                    break t;
                  }
                  if (((e = St(e.nextSibling)), e === null)) {
                    e = null;
                    break t;
                  }
                }
                ((n = e.data), (e = n === "F!" || n === "F" ? e : null));
              }
              if (e) {
                ((hl = St(e.nextSibling)), (u = e.data === "F!"));
                break l;
              }
            }
            ta(u);
          }
          u = !1;
        }
        u && (t = a[0]);
      }
    }
    return (
      (a = Vl()),
      (a.memoizedState = a.baseState = t),
      (u = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ks,
        lastRenderedState: t,
      }),
      (a.queue = u),
      (a = gd.bind(null, V, u)),
      (u.dispatch = a),
      (u = kc(!1)),
      (n = ei.bind(null, V, !1, u.queue)),
      (u = Vl()),
      (e = { state: t, dispatch: null, action: l, pending: null }),
      (u.queue = e),
      (a = w0.bind(null, V, e, n, a)),
      (e.dispatch = a),
      (u.memoizedState = l),
      [t, a, !1]
    );
  }
  function Ps(l) {
    var t = zl();
    return ld(t, fl, l);
  }
  function ld(l, t, a) {
    if (
      ((t = $c(l, t, ks)[0]),
      (l = en(Xt)[0]),
      typeof t == "object" && t !== null && typeof t.then == "function")
    )
      try {
        var u = Pu(t);
      } catch (c) {
        throw c === du ? We : c;
      }
    else u = t;
    t = zl();
    var e = t.queue,
      n = e.dispatch;
    return (
      a !== t.memoizedState &&
        ((V.flags |= 2048),
        hu(9, { destroy: void 0 }, W0.bind(null, e, a), null)),
      [u, n, l]
    );
  }
  function W0(l, t) {
    l.action = t;
  }
  function td(l) {
    var t = zl(),
      a = fl;
    if (a !== null) return ld(t, a, l);
    (zl(), (t = t.memoizedState), (a = zl()));
    var u = a.queue.dispatch;
    return ((a.memoizedState = l), [t, u, !1]);
  }
  function hu(l, t, a, u) {
    return (
      (l = { tag: l, create: a, deps: u, inst: t, next: null }),
      (t = V.updateQueue),
      t === null && ((t = an()), (V.updateQueue = t)),
      (a = t.lastEffect),
      a === null
        ? (t.lastEffect = l.next = l)
        : ((u = a.next), (a.next = l), (l.next = u), (t.lastEffect = l)),
      l
    );
  }
  function ad() {
    return zl().memoizedState;
  }
  function nn(l, t, a, u) {
    var e = Vl();
    ((V.flags |= l),
      (e.memoizedState = hu(
        1 | t,
        { destroy: void 0 },
        a,
        u === void 0 ? null : u,
      )));
  }
  function cn(l, t, a, u) {
    var e = zl();
    u = u === void 0 ? null : u;
    var n = e.memoizedState.inst;
    fl !== null && u !== null && Vc(u, fl.memoizedState.deps)
      ? (e.memoizedState = hu(t, n, a, u))
      : ((V.flags |= l), (e.memoizedState = hu(1 | t, n, a, u)));
  }
  function ud(l, t) {
    nn(8390656, 8, l, t);
  }
  function Pc(l, t) {
    cn(2048, 8, l, t);
  }
  function $0(l) {
    V.flags |= 4;
    var t = V.updateQueue;
    if (t === null) ((t = an()), (V.updateQueue = t), (t.events = [l]));
    else {
      var a = t.events;
      a === null ? (t.events = [l]) : a.push(l);
    }
  }
  function ed(l) {
    var t = zl().memoizedState;
    return (
      $0({ ref: t, nextImpl: l }),
      function () {
        if ((ul & 2) !== 0) throw Error(s(440));
        return t.impl.apply(void 0, arguments);
      }
    );
  }
  function nd(l, t) {
    return cn(4, 2, l, t);
  }
  function cd(l, t) {
    return cn(4, 4, l, t);
  }
  function id(l, t) {
    if (typeof t == "function") {
      l = l();
      var a = t(l);
      return function () {
        typeof a == "function" ? a() : t(null);
      };
    }
    if (t != null)
      return (
        (l = l()),
        (t.current = l),
        function () {
          t.current = null;
        }
      );
  }
  function fd(l, t, a) {
    ((a = a != null ? a.concat([l]) : null), cn(4, 4, id.bind(null, t, l), a));
  }
  function li() {}
  function sd(l, t) {
    var a = zl();
    t = t === void 0 ? null : t;
    var u = a.memoizedState;
    return t !== null && Vc(t, u[1]) ? u[0] : ((a.memoizedState = [l, t]), l);
  }
  function dd(l, t) {
    var a = zl();
    t = t === void 0 ? null : t;
    var u = a.memoizedState;
    if (t !== null && Vc(t, u[1])) return u[0];
    if (((u = l()), Ya)) {
      Ft(!0);
      try {
        l();
      } finally {
        Ft(!1);
      }
    }
    return ((a.memoizedState = [u, t]), u);
  }
  function ti(l, t, a) {
    return a === void 0 || ((Gt & 1073741824) !== 0 && (F & 261930) === 0)
      ? (l.memoizedState = t)
      : ((l.memoizedState = a), (l = mo()), (V.lanes |= l), (da |= l), a);
  }
  function od(l, t, a, u) {
    return ut(a, t)
      ? a
      : mu.current !== null
        ? ((l = ti(l, a, u)), ut(l, t) || (Ol = !0), l)
        : (Gt & 42) === 0 || ((Gt & 1073741824) !== 0 && (F & 261930) === 0)
          ? ((Ol = !0), (l.memoizedState = a))
          : ((l = mo()), (V.lanes |= l), (da |= l), t);
  }
  function md(l, t, a, u, e) {
    var n = D.p;
    D.p = n !== 0 && 8 > n ? n : 8;
    var c = E.T,
      i = {};
    ((E.T = i), ei(l, !1, t, a));
    try {
      var f = e(),
        v = E.S;
      if (
        (v !== null && v(i, f),
        f !== null && typeof f == "object" && typeof f.then == "function")
      ) {
        var p = L0(f, u);
        le(l, t, p, st(l));
      } else le(l, t, u, st(l));
    } catch (z) {
      le(l, t, { then: function () {}, status: "rejected", reason: z }, st());
    } finally {
      ((D.p = n),
        c !== null && i.types !== null && (c.types = i.types),
        (E.T = c));
    }
  }
  function F0() {}
  function ai(l, t, a, u) {
    if (l.tag !== 5) throw Error(s(476));
    var e = yd(l).queue;
    md(
      l,
      e,
      t,
      X,
      a === null
        ? F0
        : function () {
            return (vd(l), a(u));
          },
    );
  }
  function yd(l) {
    var t = l.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: X,
      baseState: X,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Xt,
        lastRenderedState: X,
      },
      next: null,
    };
    var a = {};
    return (
      (t.next = {
        memoizedState: a,
        baseState: a,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Xt,
          lastRenderedState: a,
        },
        next: null,
      }),
      (l.memoizedState = t),
      (l = l.alternate),
      l !== null && (l.memoizedState = t),
      t
    );
  }
  function vd(l) {
    var t = yd(l);
    (t.next === null && (t = l.alternate.memoizedState),
      le(l, t.next.queue, {}, st()));
  }
  function ui() {
    return Bl(ge);
  }
  function hd() {
    return zl().memoizedState;
  }
  function rd() {
    return zl().memoizedState;
  }
  function k0(l) {
    for (var t = l.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var a = st();
          l = ea(a);
          var u = na(t, l, a);
          (u !== null && (Pl(u, t, a), $u(u, t, a)),
            (t = { cache: Hc() }),
            (l.payload = t));
          return;
      }
      t = t.return;
    }
  }
  function I0(l, t, a) {
    var u = st();
    ((a = {
      lane: u,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
      fn(l)
        ? Sd(t, a)
        : ((a = Ec(l, t, a, u)), a !== null && (Pl(a, l, u), bd(a, t, u))));
  }
  function gd(l, t, a) {
    var u = st();
    le(l, t, a, u);
  }
  function le(l, t, a, u) {
    var e = {
      lane: u,
      revertLane: 0,
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    };
    if (fn(l)) Sd(t, e);
    else {
      var n = l.alternate;
      if (
        l.lanes === 0 &&
        (n === null || n.lanes === 0) &&
        ((n = t.lastRenderedReducer), n !== null)
      )
        try {
          var c = t.lastRenderedState,
            i = n(c, a);
          if (((e.hasEagerState = !0), (e.eagerState = i), ut(i, c)))
            return (Qe(l, t, e, 0), yl === null && Xe(), !1);
        } catch {}
      if (((a = Ec(l, t, e, u)), a !== null))
        return (Pl(a, l, u), bd(a, t, u), !0);
    }
    return !1;
  }
  function ei(l, t, a, u) {
    if (
      ((u = {
        lane: 2,
        revertLane: xi(),
        gesture: null,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      }),
      fn(l))
    ) {
      if (t) throw Error(s(479));
    } else ((t = Ec(l, a, u, 2)), t !== null && Pl(t, l, 2));
  }
  function fn(l) {
    var t = l.alternate;
    return l === V || (t !== null && t === V);
  }
  function Sd(l, t) {
    yu = ln = !0;
    var a = l.pending;
    (a === null ? (t.next = t) : ((t.next = a.next), (a.next = t)),
      (l.pending = t));
  }
  function bd(l, t, a) {
    if ((a & 4194048) !== 0) {
      var u = t.lanes;
      ((u &= l.pendingLanes), (a |= u), (t.lanes = a), Tf(l, a));
    }
  }
  var te = {
    readContext: Bl,
    use: un,
    useCallback: bl,
    useContext: bl,
    useEffect: bl,
    useImperativeHandle: bl,
    useLayoutEffect: bl,
    useInsertionEffect: bl,
    useMemo: bl,
    useReducer: bl,
    useRef: bl,
    useState: bl,
    useDebugValue: bl,
    useDeferredValue: bl,
    useTransition: bl,
    useSyncExternalStore: bl,
    useId: bl,
    useHostTransitionStatus: bl,
    useFormState: bl,
    useActionState: bl,
    useOptimistic: bl,
    useMemoCache: bl,
    useCacheRefresh: bl,
  };
  te.useEffectEvent = bl;
  var pd = {
      readContext: Bl,
      use: un,
      useCallback: function (l, t) {
        return ((Vl().memoizedState = [l, t === void 0 ? null : t]), l);
      },
      useContext: Bl,
      useEffect: ud,
      useImperativeHandle: function (l, t, a) {
        ((a = a != null ? a.concat([l]) : null),
          nn(4194308, 4, id.bind(null, t, l), a));
      },
      useLayoutEffect: function (l, t) {
        return nn(4194308, 4, l, t);
      },
      useInsertionEffect: function (l, t) {
        nn(4, 2, l, t);
      },
      useMemo: function (l, t) {
        var a = Vl();
        t = t === void 0 ? null : t;
        var u = l();
        if (Ya) {
          Ft(!0);
          try {
            l();
          } finally {
            Ft(!1);
          }
        }
        return ((a.memoizedState = [u, t]), u);
      },
      useReducer: function (l, t, a) {
        var u = Vl();
        if (a !== void 0) {
          var e = a(t);
          if (Ya) {
            Ft(!0);
            try {
              a(t);
            } finally {
              Ft(!1);
            }
          }
        } else e = t;
        return (
          (u.memoizedState = u.baseState = e),
          (l = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: l,
            lastRenderedState: e,
          }),
          (u.queue = l),
          (l = l.dispatch = I0.bind(null, V, l)),
          [u.memoizedState, l]
        );
      },
      useRef: function (l) {
        var t = Vl();
        return ((l = { current: l }), (t.memoizedState = l));
      },
      useState: function (l) {
        l = kc(l);
        var t = l.queue,
          a = gd.bind(null, V, t);
        return ((t.dispatch = a), [l.memoizedState, a]);
      },
      useDebugValue: li,
      useDeferredValue: function (l, t) {
        var a = Vl();
        return ti(a, l, t);
      },
      useTransition: function () {
        var l = kc(!1);
        return (
          (l = md.bind(null, V, l.queue, !0, !1)),
          (Vl().memoizedState = l),
          [!1, l]
        );
      },
      useSyncExternalStore: function (l, t, a) {
        var u = V,
          e = Vl();
        if (P) {
          if (a === void 0) throw Error(s(407));
          a = a();
        } else {
          if (((a = t()), yl === null)) throw Error(s(349));
          (F & 127) !== 0 || Qs(u, t, a);
        }
        e.memoizedState = a;
        var n = { value: a, getSnapshot: t };
        return (
          (e.queue = n),
          ud(Vs.bind(null, u, n, l), [l]),
          (u.flags |= 2048),
          hu(9, { destroy: void 0 }, Zs.bind(null, u, n, a, t), null),
          a
        );
      },
      useId: function () {
        var l = Vl(),
          t = yl.identifierPrefix;
        if (P) {
          var a = Nt,
            u = Mt;
          ((a = (u & ~(1 << (32 - at(u) - 1))).toString(32) + a),
            (t = "_" + t + "R_" + a),
            (a = tn++),
            0 < a && (t += "H" + a.toString(32)),
            (t += "_"));
        } else ((a = K0++), (t = "_" + t + "r_" + a.toString(32) + "_"));
        return (l.memoizedState = t);
      },
      useHostTransitionStatus: ui,
      useFormState: Is,
      useActionState: Is,
      useOptimistic: function (l) {
        var t = Vl();
        t.memoizedState = t.baseState = l;
        var a = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: null,
          lastRenderedState: null,
        };
        return (
          (t.queue = a),
          (t = ei.bind(null, V, !0, a)),
          (a.dispatch = t),
          [l, t]
        );
      },
      useMemoCache: Wc,
      useCacheRefresh: function () {
        return (Vl().memoizedState = k0.bind(null, V));
      },
      useEffectEvent: function (l) {
        var t = Vl(),
          a = { impl: l };
        return (
          (t.memoizedState = a),
          function () {
            if ((ul & 2) !== 0) throw Error(s(440));
            return a.impl.apply(void 0, arguments);
          }
        );
      },
    },
    ni = {
      readContext: Bl,
      use: un,
      useCallback: sd,
      useContext: Bl,
      useEffect: Pc,
      useImperativeHandle: fd,
      useInsertionEffect: nd,
      useLayoutEffect: cd,
      useMemo: dd,
      useReducer: en,
      useRef: ad,
      useState: function () {
        return en(Xt);
      },
      useDebugValue: li,
      useDeferredValue: function (l, t) {
        var a = zl();
        return od(a, fl.memoizedState, l, t);
      },
      useTransition: function () {
        var l = en(Xt)[0],
          t = zl().memoizedState;
        return [typeof l == "boolean" ? l : Pu(l), t];
      },
      useSyncExternalStore: Xs,
      useId: hd,
      useHostTransitionStatus: ui,
      useFormState: Ps,
      useActionState: Ps,
      useOptimistic: function (l, t) {
        var a = zl();
        return Js(a, fl, l, t);
      },
      useMemoCache: Wc,
      useCacheRefresh: rd,
    };
  ni.useEffectEvent = ed;
  var Ed = {
    readContext: Bl,
    use: un,
    useCallback: sd,
    useContext: Bl,
    useEffect: Pc,
    useImperativeHandle: fd,
    useInsertionEffect: nd,
    useLayoutEffect: cd,
    useMemo: dd,
    useReducer: Fc,
    useRef: ad,
    useState: function () {
      return Fc(Xt);
    },
    useDebugValue: li,
    useDeferredValue: function (l, t) {
      var a = zl();
      return fl === null ? ti(a, l, t) : od(a, fl.memoizedState, l, t);
    },
    useTransition: function () {
      var l = Fc(Xt)[0],
        t = zl().memoizedState;
      return [typeof l == "boolean" ? l : Pu(l), t];
    },
    useSyncExternalStore: Xs,
    useId: hd,
    useHostTransitionStatus: ui,
    useFormState: td,
    useActionState: td,
    useOptimistic: function (l, t) {
      var a = zl();
      return fl !== null
        ? Js(a, fl, l, t)
        : ((a.baseState = l), [l, a.queue.dispatch]);
    },
    useMemoCache: Wc,
    useCacheRefresh: rd,
  };
  Ed.useEffectEvent = ed;
  function ci(l, t, a, u) {
    ((t = l.memoizedState),
      (a = a(u, t)),
      (a = a == null ? t : N({}, t, a)),
      (l.memoizedState = a),
      l.lanes === 0 && (l.updateQueue.baseState = a));
  }
  var ii = {
    enqueueSetState: function (l, t, a) {
      l = l._reactInternals;
      var u = st(),
        e = ea(u);
      ((e.payload = t),
        a != null && (e.callback = a),
        (t = na(l, e, u)),
        t !== null && (Pl(t, l, u), $u(t, l, u)));
    },
    enqueueReplaceState: function (l, t, a) {
      l = l._reactInternals;
      var u = st(),
        e = ea(u);
      ((e.tag = 1),
        (e.payload = t),
        a != null && (e.callback = a),
        (t = na(l, e, u)),
        t !== null && (Pl(t, l, u), $u(t, l, u)));
    },
    enqueueForceUpdate: function (l, t) {
      l = l._reactInternals;
      var a = st(),
        u = ea(a);
      ((u.tag = 2),
        t != null && (u.callback = t),
        (t = na(l, u, a)),
        t !== null && (Pl(t, l, a), $u(t, l, a)));
    },
  };
  function _d(l, t, a, u, e, n, c) {
    return (
      (l = l.stateNode),
      typeof l.shouldComponentUpdate == "function"
        ? l.shouldComponentUpdate(u, n, c)
        : t.prototype && t.prototype.isPureReactComponent
          ? !Qu(a, u) || !Qu(e, n)
          : !0
    );
  }
  function zd(l, t, a, u) {
    ((l = t.state),
      typeof t.componentWillReceiveProps == "function" &&
        t.componentWillReceiveProps(a, u),
      typeof t.UNSAFE_componentWillReceiveProps == "function" &&
        t.UNSAFE_componentWillReceiveProps(a, u),
      t.state !== l && ii.enqueueReplaceState(t, t.state, null));
  }
  function Ga(l, t) {
    var a = t;
    if ("ref" in t) {
      a = {};
      for (var u in t) u !== "ref" && (a[u] = t[u]);
    }
    if ((l = l.defaultProps)) {
      a === t && (a = N({}, a));
      for (var e in l) a[e] === void 0 && (a[e] = l[e]);
    }
    return a;
  }
  function Td(l) {
    Ge(l);
  }
  function Ad(l) {
    console.error(l);
  }
  function Od(l) {
    Ge(l);
  }
  function sn(l, t) {
    try {
      var a = l.onUncaughtError;
      a(t.value, { componentStack: t.stack });
    } catch (u) {
      setTimeout(function () {
        throw u;
      });
    }
  }
  function Md(l, t, a) {
    try {
      var u = l.onCaughtError;
      u(a.value, {
        componentStack: a.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null,
      });
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function fi(l, t, a) {
    return (
      (a = ea(a)),
      (a.tag = 3),
      (a.payload = { element: null }),
      (a.callback = function () {
        sn(l, t);
      }),
      a
    );
  }
  function Nd(l) {
    return ((l = ea(l)), (l.tag = 3), l);
  }
  function Dd(l, t, a, u) {
    var e = a.type.getDerivedStateFromError;
    if (typeof e == "function") {
      var n = u.value;
      ((l.payload = function () {
        return e(n);
      }),
        (l.callback = function () {
          Md(t, a, u);
        }));
    }
    var c = a.stateNode;
    c !== null &&
      typeof c.componentDidCatch == "function" &&
      (l.callback = function () {
        (Md(t, a, u),
          typeof e != "function" &&
            (oa === null ? (oa = new Set([this])) : oa.add(this)));
        var i = u.stack;
        this.componentDidCatch(u.value, {
          componentStack: i !== null ? i : "",
        });
      });
  }
  function P0(l, t, a, u, e) {
    if (
      ((a.flags |= 32768),
      u !== null && typeof u == "object" && typeof u.then == "function")
    ) {
      if (
        ((t = a.alternate),
        t !== null && iu(t, a, e, !0),
        (a = nt.current),
        a !== null)
      ) {
        switch (a.tag) {
          case 31:
          case 13:
            return (
              gt === null ? En() : a.alternate === null && pl === 0 && (pl = 3),
              (a.flags &= -257),
              (a.flags |= 65536),
              (a.lanes = e),
              u === $e
                ? (a.flags |= 16384)
                : ((t = a.updateQueue),
                  t === null ? (a.updateQueue = new Set([u])) : t.add(u),
                  Ri(l, u, e)),
              !1
            );
          case 22:
            return (
              (a.flags |= 65536),
              u === $e
                ? (a.flags |= 16384)
                : ((t = a.updateQueue),
                  t === null
                    ? ((t = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([u]),
                      }),
                      (a.updateQueue = t))
                    : ((a = t.retryQueue),
                      a === null ? (t.retryQueue = new Set([u])) : a.add(u)),
                  Ri(l, u, e)),
              !1
            );
        }
        throw Error(s(435, a.tag));
      }
      return (Ri(l, u, e), En(), !1);
    }
    if (P)
      return (
        (t = nt.current),
        t !== null
          ? ((t.flags & 65536) === 0 && (t.flags |= 256),
            (t.flags |= 65536),
            (t.lanes = e),
            u !== Mc && ((l = Error(s(422), { cause: u })), Lu(yt(l, a))))
          : (u !== Mc && ((t = Error(s(423), { cause: u })), Lu(yt(t, a))),
            (l = l.current.alternate),
            (l.flags |= 65536),
            (e &= -e),
            (l.lanes |= e),
            (u = yt(u, a)),
            (e = fi(l.stateNode, u, e)),
            Yc(l, e),
            pl !== 4 && (pl = 2)),
        !1
      );
    var n = Error(s(520), { cause: u });
    if (
      ((n = yt(n, a)),
      se === null ? (se = [n]) : se.push(n),
      pl !== 4 && (pl = 2),
      t === null)
    )
      return !0;
    ((u = yt(u, a)), (a = t));
    do {
      switch (a.tag) {
        case 3:
          return (
            (a.flags |= 65536),
            (l = e & -e),
            (a.lanes |= l),
            (l = fi(a.stateNode, u, l)),
            Yc(a, l),
            !1
          );
        case 1:
          if (
            ((t = a.type),
            (n = a.stateNode),
            (a.flags & 128) === 0 &&
              (typeof t.getDerivedStateFromError == "function" ||
                (n !== null &&
                  typeof n.componentDidCatch == "function" &&
                  (oa === null || !oa.has(n)))))
          )
            return (
              (a.flags |= 65536),
              (e &= -e),
              (a.lanes |= e),
              (e = Nd(e)),
              Dd(e, l, a, u),
              Yc(a, e),
              !1
            );
      }
      a = a.return;
    } while (a !== null);
    return !1;
  }
  var si = Error(s(461)),
    Ol = !1;
  function Yl(l, t, a, u) {
    t.child = l === null ? Rs(t, null, a, u) : Ba(t, l.child, a, u);
  }
  function Ud(l, t, a, u, e) {
    a = a.render;
    var n = t.ref;
    if ("ref" in u) {
      var c = {};
      for (var i in u) i !== "ref" && (c[i] = u[i]);
    } else c = u;
    return (
      Ra(t),
      (u = Lc(l, t, a, c, n, e)),
      (i = Kc()),
      l !== null && !Ol
        ? (Jc(l, t, e), Qt(l, t, e))
        : (P && i && Ac(t), (t.flags |= 1), Yl(l, t, u, e), t.child)
    );
  }
  function jd(l, t, a, u, e) {
    if (l === null) {
      var n = a.type;
      return typeof n == "function" &&
        !_c(n) &&
        n.defaultProps === void 0 &&
        a.compare === null
        ? ((t.tag = 15), (t.type = n), Hd(l, t, n, u, e))
        : ((l = Ve(a.type, null, u, t, t.mode, e)),
          (l.ref = t.ref),
          (l.return = t),
          (t.child = l));
    }
    if (((n = l.child), !gi(l, e))) {
      var c = n.memoizedProps;
      if (
        ((a = a.compare), (a = a !== null ? a : Qu), a(c, u) && l.ref === t.ref)
      )
        return Qt(l, t, e);
    }
    return (
      (t.flags |= 1),
      (l = qt(n, u)),
      (l.ref = t.ref),
      (l.return = t),
      (t.child = l)
    );
  }
  function Hd(l, t, a, u, e) {
    if (l !== null) {
      var n = l.memoizedProps;
      if (Qu(n, u) && l.ref === t.ref)
        if (((Ol = !1), (t.pendingProps = u = n), gi(l, e)))
          (l.flags & 131072) !== 0 && (Ol = !0);
        else return ((t.lanes = l.lanes), Qt(l, t, e));
    }
    return di(l, t, a, u, e);
  }
  function Rd(l, t, a, u) {
    var e = u.children,
      n = l !== null ? l.memoizedState : null;
    if (
      (l === null &&
        t.stateNode === null &&
        (t.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      u.mode === "hidden")
    ) {
      if ((t.flags & 128) !== 0) {
        if (((n = n !== null ? n.baseLanes | a : a), l !== null)) {
          for (u = t.child = l.child, e = 0; u !== null; )
            ((e = e | u.lanes | u.childLanes), (u = u.sibling));
          u = e & ~n;
        } else ((u = 0), (t.child = null));
        return Cd(l, t, n, a, u);
      }
      if ((a & 536870912) !== 0)
        ((t.memoizedState = { baseLanes: 0, cachePool: null }),
          l !== null && we(t, n !== null ? n.cachePool : null),
          n !== null ? xs(t, n) : Xc(),
          Bs(t));
      else
        return (
          (u = t.lanes = 536870912),
          Cd(l, t, n !== null ? n.baseLanes | a : a, a, u)
        );
    } else
      n !== null
        ? (we(t, n.cachePool), xs(t, n), ia(), (t.memoizedState = null))
        : (l !== null && we(t, null), Xc(), ia());
    return (Yl(l, t, e, a), t.child);
  }
  function ae(l, t) {
    return (
      (l !== null && l.tag === 22) ||
        t.stateNode !== null ||
        (t.stateNode = {
          _visibility: 1,
          _pendingMarkers: null,
          _retryCache: null,
          _transitions: null,
        }),
      t.sibling
    );
  }
  function Cd(l, t, a, u, e) {
    var n = Cc();
    return (
      (n = n === null ? null : { parent: Tl._currentValue, pool: n }),
      (t.memoizedState = { baseLanes: a, cachePool: n }),
      l !== null && we(t, null),
      Xc(),
      Bs(t),
      l !== null && iu(l, t, u, !0),
      (t.childLanes = e),
      null
    );
  }
  function dn(l, t) {
    return (
      (t = mn({ mode: t.mode, children: t.children }, l.mode)),
      (t.ref = l.ref),
      (l.child = t),
      (t.return = l),
      t
    );
  }
  function qd(l, t, a) {
    return (
      Ba(t, l.child, null, a),
      (l = dn(t, t.pendingProps)),
      (l.flags |= 2),
      ct(t),
      (t.memoizedState = null),
      l
    );
  }
  function ly(l, t, a) {
    var u = t.pendingProps,
      e = (t.flags & 128) !== 0;
    if (((t.flags &= -129), l === null)) {
      if (P) {
        if (u.mode === "hidden")
          return ((l = dn(t, u)), (t.lanes = 536870912), ae(null, l));
        if (
          (Zc(t),
          (l = hl)
            ? ((l = Wo(l, rt)),
              (l = l !== null && l.data === "&" ? l : null),
              l !== null &&
                ((t.memoizedState = {
                  dehydrated: l,
                  treeContext: Pt !== null ? { id: Mt, overflow: Nt } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (a = Ss(l)),
                (a.return = t),
                (t.child = a),
                (xl = t),
                (hl = null)))
            : (l = null),
          l === null)
        )
          throw ta(t);
        return ((t.lanes = 536870912), null);
      }
      return dn(t, u);
    }
    var n = l.memoizedState;
    if (n !== null) {
      var c = n.dehydrated;
      if ((Zc(t), e))
        if (t.flags & 256) ((t.flags &= -257), (t = qd(l, t, a)));
        else if (t.memoizedState !== null)
          ((t.child = l.child), (t.flags |= 128), (t = null));
        else throw Error(s(558));
      else if (
        (Ol || iu(l, t, a, !1), (e = (a & l.childLanes) !== 0), Ol || e)
      ) {
        if (
          ((u = yl),
          u !== null && ((c = Af(u, a)), c !== 0 && c !== n.retryLane))
        )
          throw ((n.retryLane = c), Da(l, c), Pl(u, l, c), si);
        (En(), (t = qd(l, t, a)));
      } else
        ((l = n.treeContext),
          (hl = St(c.nextSibling)),
          (xl = t),
          (P = !0),
          (la = null),
          (rt = !1),
          l !== null && Es(t, l),
          (t = dn(t, u)),
          (t.flags |= 4096));
      return t;
    }
    return (
      (l = qt(l.child, { mode: u.mode, children: u.children })),
      (l.ref = t.ref),
      (t.child = l),
      (l.return = t),
      l
    );
  }
  function on(l, t) {
    var a = t.ref;
    if (a === null) l !== null && l.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof a != "function" && typeof a != "object") throw Error(s(284));
      (l === null || l.ref !== a) && (t.flags |= 4194816);
    }
  }
  function di(l, t, a, u, e) {
    return (
      Ra(t),
      (a = Lc(l, t, a, u, void 0, e)),
      (u = Kc()),
      l !== null && !Ol
        ? (Jc(l, t, e), Qt(l, t, e))
        : (P && u && Ac(t), (t.flags |= 1), Yl(l, t, a, e), t.child)
    );
  }
  function xd(l, t, a, u, e, n) {
    return (
      Ra(t),
      (t.updateQueue = null),
      (a = Gs(t, u, a, e)),
      Ys(l),
      (u = Kc()),
      l !== null && !Ol
        ? (Jc(l, t, n), Qt(l, t, n))
        : (P && u && Ac(t), (t.flags |= 1), Yl(l, t, a, n), t.child)
    );
  }
  function Bd(l, t, a, u, e) {
    if ((Ra(t), t.stateNode === null)) {
      var n = uu,
        c = a.contextType;
      (typeof c == "object" && c !== null && (n = Bl(c)),
        (n = new a(u, n)),
        (t.memoizedState =
          n.state !== null && n.state !== void 0 ? n.state : null),
        (n.updater = ii),
        (t.stateNode = n),
        (n._reactInternals = t),
        (n = t.stateNode),
        (n.props = u),
        (n.state = t.memoizedState),
        (n.refs = {}),
        xc(t),
        (c = a.contextType),
        (n.context = typeof c == "object" && c !== null ? Bl(c) : uu),
        (n.state = t.memoizedState),
        (c = a.getDerivedStateFromProps),
        typeof c == "function" && (ci(t, a, c, u), (n.state = t.memoizedState)),
        typeof a.getDerivedStateFromProps == "function" ||
          typeof n.getSnapshotBeforeUpdate == "function" ||
          (typeof n.UNSAFE_componentWillMount != "function" &&
            typeof n.componentWillMount != "function") ||
          ((c = n.state),
          typeof n.componentWillMount == "function" && n.componentWillMount(),
          typeof n.UNSAFE_componentWillMount == "function" &&
            n.UNSAFE_componentWillMount(),
          c !== n.state && ii.enqueueReplaceState(n, n.state, null),
          ku(t, u, n, e),
          Fu(),
          (n.state = t.memoizedState)),
        typeof n.componentDidMount == "function" && (t.flags |= 4194308),
        (u = !0));
    } else if (l === null) {
      n = t.stateNode;
      var i = t.memoizedProps,
        f = Ga(a, i);
      n.props = f;
      var v = n.context,
        p = a.contextType;
      ((c = uu), typeof p == "object" && p !== null && (c = Bl(p)));
      var z = a.getDerivedStateFromProps;
      ((p =
        typeof z == "function" ||
        typeof n.getSnapshotBeforeUpdate == "function"),
        (i = t.pendingProps !== i),
        p ||
          (typeof n.UNSAFE_componentWillReceiveProps != "function" &&
            typeof n.componentWillReceiveProps != "function") ||
          ((i || v !== c) && zd(t, n, u, c)),
        (ua = !1));
      var r = t.memoizedState;
      ((n.state = r),
        ku(t, u, n, e),
        Fu(),
        (v = t.memoizedState),
        i || r !== v || ua
          ? (typeof z == "function" && (ci(t, a, z, u), (v = t.memoizedState)),
            (f = ua || _d(t, a, f, u, r, v, c))
              ? (p ||
                  (typeof n.UNSAFE_componentWillMount != "function" &&
                    typeof n.componentWillMount != "function") ||
                  (typeof n.componentWillMount == "function" &&
                    n.componentWillMount(),
                  typeof n.UNSAFE_componentWillMount == "function" &&
                    n.UNSAFE_componentWillMount()),
                typeof n.componentDidMount == "function" &&
                  (t.flags |= 4194308))
              : (typeof n.componentDidMount == "function" &&
                  (t.flags |= 4194308),
                (t.memoizedProps = u),
                (t.memoizedState = v)),
            (n.props = u),
            (n.state = v),
            (n.context = c),
            (u = f))
          : (typeof n.componentDidMount == "function" && (t.flags |= 4194308),
            (u = !1)));
    } else {
      ((n = t.stateNode),
        Bc(l, t),
        (c = t.memoizedProps),
        (p = Ga(a, c)),
        (n.props = p),
        (z = t.pendingProps),
        (r = n.context),
        (v = a.contextType),
        (f = uu),
        typeof v == "object" && v !== null && (f = Bl(v)),
        (i = a.getDerivedStateFromProps),
        (v =
          typeof i == "function" ||
          typeof n.getSnapshotBeforeUpdate == "function") ||
          (typeof n.UNSAFE_componentWillReceiveProps != "function" &&
            typeof n.componentWillReceiveProps != "function") ||
          ((c !== z || r !== f) && zd(t, n, u, f)),
        (ua = !1),
        (r = t.memoizedState),
        (n.state = r),
        ku(t, u, n, e),
        Fu());
      var S = t.memoizedState;
      c !== z ||
      r !== S ||
      ua ||
      (l !== null && l.dependencies !== null && Ke(l.dependencies))
        ? (typeof i == "function" && (ci(t, a, i, u), (S = t.memoizedState)),
          (p =
            ua ||
            _d(t, a, p, u, r, S, f) ||
            (l !== null && l.dependencies !== null && Ke(l.dependencies)))
            ? (v ||
                (typeof n.UNSAFE_componentWillUpdate != "function" &&
                  typeof n.componentWillUpdate != "function") ||
                (typeof n.componentWillUpdate == "function" &&
                  n.componentWillUpdate(u, S, f),
                typeof n.UNSAFE_componentWillUpdate == "function" &&
                  n.UNSAFE_componentWillUpdate(u, S, f)),
              typeof n.componentDidUpdate == "function" && (t.flags |= 4),
              typeof n.getSnapshotBeforeUpdate == "function" &&
                (t.flags |= 1024))
            : (typeof n.componentDidUpdate != "function" ||
                (c === l.memoizedProps && r === l.memoizedState) ||
                (t.flags |= 4),
              typeof n.getSnapshotBeforeUpdate != "function" ||
                (c === l.memoizedProps && r === l.memoizedState) ||
                (t.flags |= 1024),
              (t.memoizedProps = u),
              (t.memoizedState = S)),
          (n.props = u),
          (n.state = S),
          (n.context = f),
          (u = p))
        : (typeof n.componentDidUpdate != "function" ||
            (c === l.memoizedProps && r === l.memoizedState) ||
            (t.flags |= 4),
          typeof n.getSnapshotBeforeUpdate != "function" ||
            (c === l.memoizedProps && r === l.memoizedState) ||
            (t.flags |= 1024),
          (u = !1));
    }
    return (
      (n = u),
      on(l, t),
      (u = (t.flags & 128) !== 0),
      n || u
        ? ((n = t.stateNode),
          (a =
            u && typeof a.getDerivedStateFromError != "function"
              ? null
              : n.render()),
          (t.flags |= 1),
          l !== null && u
            ? ((t.child = Ba(t, l.child, null, e)),
              (t.child = Ba(t, null, a, e)))
            : Yl(l, t, a, e),
          (t.memoizedState = n.state),
          (l = t.child))
        : (l = Qt(l, t, e)),
      l
    );
  }
  function Yd(l, t, a, u) {
    return (ja(), (t.flags |= 256), Yl(l, t, a, u), t.child);
  }
  var oi = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null,
  };
  function mi(l) {
    return { baseLanes: l, cachePool: Ms() };
  }
  function yi(l, t, a) {
    return ((l = l !== null ? l.childLanes & ~a : 0), t && (l |= ft), l);
  }
  function Gd(l, t, a) {
    var u = t.pendingProps,
      e = !1,
      n = (t.flags & 128) !== 0,
      c;
    if (
      ((c = n) ||
        (c =
          l !== null && l.memoizedState === null ? !1 : (_l.current & 2) !== 0),
      c && ((e = !0), (t.flags &= -129)),
      (c = (t.flags & 32) !== 0),
      (t.flags &= -33),
      l === null)
    ) {
      if (P) {
        if (
          (e ? ca(t) : ia(),
          (l = hl)
            ? ((l = Wo(l, rt)),
              (l = l !== null && l.data !== "&" ? l : null),
              l !== null &&
                ((t.memoizedState = {
                  dehydrated: l,
                  treeContext: Pt !== null ? { id: Mt, overflow: Nt } : null,
                  retryLane: 536870912,
                  hydrationErrors: null,
                }),
                (a = Ss(l)),
                (a.return = t),
                (t.child = a),
                (xl = t),
                (hl = null)))
            : (l = null),
          l === null)
        )
          throw ta(t);
        return ($i(l) ? (t.lanes = 32) : (t.lanes = 536870912), null);
      }
      var i = u.children;
      return (
        (u = u.fallback),
        e
          ? (ia(),
            (e = t.mode),
            (i = mn({ mode: "hidden", children: i }, e)),
            (u = Ua(u, e, a, null)),
            (i.return = t),
            (u.return = t),
            (i.sibling = u),
            (t.child = i),
            (u = t.child),
            (u.memoizedState = mi(a)),
            (u.childLanes = yi(l, c, a)),
            (t.memoizedState = oi),
            ae(null, u))
          : (ca(t), vi(t, i))
      );
    }
    var f = l.memoizedState;
    if (f !== null && ((i = f.dehydrated), i !== null)) {
      if (n)
        t.flags & 256
          ? (ca(t), (t.flags &= -257), (t = hi(l, t, a)))
          : t.memoizedState !== null
            ? (ia(), (t.child = l.child), (t.flags |= 128), (t = null))
            : (ia(),
              (i = u.fallback),
              (e = t.mode),
              (u = mn({ mode: "visible", children: u.children }, e)),
              (i = Ua(i, e, a, null)),
              (i.flags |= 2),
              (u.return = t),
              (i.return = t),
              (u.sibling = i),
              (t.child = u),
              Ba(t, l.child, null, a),
              (u = t.child),
              (u.memoizedState = mi(a)),
              (u.childLanes = yi(l, c, a)),
              (t.memoizedState = oi),
              (t = ae(null, u)));
      else if ((ca(t), $i(i))) {
        if (((c = i.nextSibling && i.nextSibling.dataset), c)) var v = c.dgst;
        ((c = v),
          (u = Error(s(419))),
          (u.stack = ""),
          (u.digest = c),
          Lu({ value: u, source: null, stack: null }),
          (t = hi(l, t, a)));
      } else if (
        (Ol || iu(l, t, a, !1), (c = (a & l.childLanes) !== 0), Ol || c)
      ) {
        if (
          ((c = yl),
          c !== null && ((u = Af(c, a)), u !== 0 && u !== f.retryLane))
        )
          throw ((f.retryLane = u), Da(l, u), Pl(c, l, u), si);
        (Wi(i) || En(), (t = hi(l, t, a)));
      } else
        Wi(i)
          ? ((t.flags |= 192), (t.child = l.child), (t = null))
          : ((l = f.treeContext),
            (hl = St(i.nextSibling)),
            (xl = t),
            (P = !0),
            (la = null),
            (rt = !1),
            l !== null && Es(t, l),
            (t = vi(t, u.children)),
            (t.flags |= 4096));
      return t;
    }
    return e
      ? (ia(),
        (i = u.fallback),
        (e = t.mode),
        (f = l.child),
        (v = f.sibling),
        (u = qt(f, { mode: "hidden", children: u.children })),
        (u.subtreeFlags = f.subtreeFlags & 65011712),
        v !== null ? (i = qt(v, i)) : ((i = Ua(i, e, a, null)), (i.flags |= 2)),
        (i.return = t),
        (u.return = t),
        (u.sibling = i),
        (t.child = u),
        ae(null, u),
        (u = t.child),
        (i = l.child.memoizedState),
        i === null
          ? (i = mi(a))
          : ((e = i.cachePool),
            e !== null
              ? ((f = Tl._currentValue),
                (e = e.parent !== f ? { parent: f, pool: f } : e))
              : (e = Ms()),
            (i = { baseLanes: i.baseLanes | a, cachePool: e })),
        (u.memoizedState = i),
        (u.childLanes = yi(l, c, a)),
        (t.memoizedState = oi),
        ae(l.child, u))
      : (ca(t),
        (a = l.child),
        (l = a.sibling),
        (a = qt(a, { mode: "visible", children: u.children })),
        (a.return = t),
        (a.sibling = null),
        l !== null &&
          ((c = t.deletions),
          c === null ? ((t.deletions = [l]), (t.flags |= 16)) : c.push(l)),
        (t.child = a),
        (t.memoizedState = null),
        a);
  }
  function vi(l, t) {
    return (
      (t = mn({ mode: "visible", children: t }, l.mode)),
      (t.return = l),
      (l.child = t)
    );
  }
  function mn(l, t) {
    return ((l = et(22, l, null, t)), (l.lanes = 0), l);
  }
  function hi(l, t, a) {
    return (
      Ba(t, l.child, null, a),
      (l = vi(t, t.pendingProps.children)),
      (l.flags |= 2),
      (t.memoizedState = null),
      l
    );
  }
  function Xd(l, t, a) {
    l.lanes |= t;
    var u = l.alternate;
    (u !== null && (u.lanes |= t), Uc(l.return, t, a));
  }
  function ri(l, t, a, u, e, n) {
    var c = l.memoizedState;
    c === null
      ? (l.memoizedState = {
          isBackwards: t,
          rendering: null,
          renderingStartTime: 0,
          last: u,
          tail: a,
          tailMode: e,
          treeForkCount: n,
        })
      : ((c.isBackwards = t),
        (c.rendering = null),
        (c.renderingStartTime = 0),
        (c.last = u),
        (c.tail = a),
        (c.tailMode = e),
        (c.treeForkCount = n));
  }
  function Qd(l, t, a) {
    var u = t.pendingProps,
      e = u.revealOrder,
      n = u.tail;
    u = u.children;
    var c = _l.current,
      i = (c & 2) !== 0;
    if (
      (i ? ((c = (c & 1) | 2), (t.flags |= 128)) : (c &= 1),
      U(_l, c),
      Yl(l, t, u, a),
      (u = P ? Vu : 0),
      !i && l !== null && (l.flags & 128) !== 0)
    )
      l: for (l = t.child; l !== null; ) {
        if (l.tag === 13) l.memoizedState !== null && Xd(l, a, t);
        else if (l.tag === 19) Xd(l, a, t);
        else if (l.child !== null) {
          ((l.child.return = l), (l = l.child));
          continue;
        }
        if (l === t) break l;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t) break l;
          l = l.return;
        }
        ((l.sibling.return = l.return), (l = l.sibling));
      }
    switch (e) {
      case "forwards":
        for (a = t.child, e = null; a !== null; )
          ((l = a.alternate),
            l !== null && Pe(l) === null && (e = a),
            (a = a.sibling));
        ((a = e),
          a === null
            ? ((e = t.child), (t.child = null))
            : ((e = a.sibling), (a.sibling = null)),
          ri(t, !1, e, a, n, u));
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (a = null, e = t.child, t.child = null; e !== null; ) {
          if (((l = e.alternate), l !== null && Pe(l) === null)) {
            t.child = e;
            break;
          }
          ((l = e.sibling), (e.sibling = a), (a = e), (e = l));
        }
        ri(t, !0, a, null, n, u);
        break;
      case "together":
        ri(t, !1, null, null, void 0, u);
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Qt(l, t, a) {
    if (
      (l !== null && (t.dependencies = l.dependencies),
      (da |= t.lanes),
      (a & t.childLanes) === 0)
    )
      if (l !== null) {
        if ((iu(l, t, a, !1), (a & t.childLanes) === 0)) return null;
      } else return null;
    if (l !== null && t.child !== l.child) throw Error(s(153));
    if (t.child !== null) {
      for (
        l = t.child, a = qt(l, l.pendingProps), t.child = a, a.return = t;
        l.sibling !== null;

      )
        ((l = l.sibling),
          (a = a.sibling = qt(l, l.pendingProps)),
          (a.return = t));
      a.sibling = null;
    }
    return t.child;
  }
  function gi(l, t) {
    return (l.lanes & t) !== 0
      ? !0
      : ((l = l.dependencies), !!(l !== null && Ke(l)));
  }
  function ty(l, t, a) {
    switch (t.tag) {
      case 3:
        (Zl(t, t.stateNode.containerInfo),
          aa(t, Tl, l.memoizedState.cache),
          ja());
        break;
      case 27:
      case 5:
        Nu(t);
        break;
      case 4:
        Zl(t, t.stateNode.containerInfo);
        break;
      case 10:
        aa(t, t.type, t.memoizedProps.value);
        break;
      case 31:
        if (t.memoizedState !== null) return ((t.flags |= 128), Zc(t), null);
        break;
      case 13:
        var u = t.memoizedState;
        if (u !== null)
          return u.dehydrated !== null
            ? (ca(t), (t.flags |= 128), null)
            : (a & t.child.childLanes) !== 0
              ? Gd(l, t, a)
              : (ca(t), (l = Qt(l, t, a)), l !== null ? l.sibling : null);
        ca(t);
        break;
      case 19:
        var e = (l.flags & 128) !== 0;
        if (
          ((u = (a & t.childLanes) !== 0),
          u || (iu(l, t, a, !1), (u = (a & t.childLanes) !== 0)),
          e)
        ) {
          if (u) return Qd(l, t, a);
          t.flags |= 128;
        }
        if (
          ((e = t.memoizedState),
          e !== null &&
            ((e.rendering = null), (e.tail = null), (e.lastEffect = null)),
          U(_l, _l.current),
          u)
        )
          break;
        return null;
      case 22:
        return ((t.lanes = 0), Rd(l, t, a, t.pendingProps));
      case 24:
        aa(t, Tl, l.memoizedState.cache);
    }
    return Qt(l, t, a);
  }
  function Zd(l, t, a) {
    if (l !== null)
      if (l.memoizedProps !== t.pendingProps) Ol = !0;
      else {
        if (!gi(l, a) && (t.flags & 128) === 0) return ((Ol = !1), ty(l, t, a));
        Ol = (l.flags & 131072) !== 0;
      }
    else ((Ol = !1), P && (t.flags & 1048576) !== 0 && ps(t, Vu, t.index));
    switch (((t.lanes = 0), t.tag)) {
      case 16:
        l: {
          var u = t.pendingProps;
          if (((l = qa(t.elementType)), (t.type = l), typeof l == "function"))
            _c(l)
              ? ((u = Ga(l, u)), (t.tag = 1), (t = Bd(null, t, l, u, a)))
              : ((t.tag = 0), (t = di(null, t, l, u, a)));
          else {
            if (l != null) {
              var e = l.$$typeof;
              if (e === Xl) {
                ((t.tag = 11), (t = Ud(null, t, l, u, a)));
                break l;
              } else if (e === I) {
                ((t.tag = 14), (t = jd(null, t, l, u, a)));
                break l;
              }
            }
            throw ((t = jt(l) || l), Error(s(306, t, "")));
          }
        }
        return t;
      case 0:
        return di(l, t, t.type, t.pendingProps, a);
      case 1:
        return ((u = t.type), (e = Ga(u, t.pendingProps)), Bd(l, t, u, e, a));
      case 3:
        l: {
          if ((Zl(t, t.stateNode.containerInfo), l === null))
            throw Error(s(387));
          u = t.pendingProps;
          var n = t.memoizedState;
          ((e = n.element), Bc(l, t), ku(t, u, null, a));
          var c = t.memoizedState;
          if (
            ((u = c.cache),
            aa(t, Tl, u),
            u !== n.cache && jc(t, [Tl], a, !0),
            Fu(),
            (u = c.element),
            n.isDehydrated)
          )
            if (
              ((n = { element: u, isDehydrated: !1, cache: c.cache }),
              (t.updateQueue.baseState = n),
              (t.memoizedState = n),
              t.flags & 256)
            ) {
              t = Yd(l, t, u, a);
              break l;
            } else if (u !== e) {
              ((e = yt(Error(s(424)), t)), Lu(e), (t = Yd(l, t, u, a)));
              break l;
            } else
              for (
                l = t.stateNode.containerInfo,
                  l.nodeType === 9
                    ? (l = l.body)
                    : (l = l.nodeName === "HTML" ? l.ownerDocument.body : l),
                  hl = St(l.firstChild),
                  xl = t,
                  P = !0,
                  la = null,
                  rt = !0,
                  a = Rs(t, null, u, a),
                  t.child = a;
                a;

              )
                ((a.flags = (a.flags & -3) | 4096), (a = a.sibling));
          else {
            if ((ja(), u === e)) {
              t = Qt(l, t, a);
              break l;
            }
            Yl(l, t, u, a);
          }
          t = t.child;
        }
        return t;
      case 26:
        return (
          on(l, t),
          l === null
            ? (a = lm(t.type, null, t.pendingProps, null))
              ? (t.memoizedState = a)
              : P ||
                ((a = t.type),
                (l = t.pendingProps),
                (u = Nn(w.current).createElement(a)),
                (u[ql] = t),
                (u[wl] = l),
                Gl(u, a, l),
                Rl(u),
                (t.stateNode = u))
            : (t.memoizedState = lm(
                t.type,
                l.memoizedProps,
                t.pendingProps,
                l.memoizedState,
              )),
          null
        );
      case 27:
        return (
          Nu(t),
          l === null &&
            P &&
            ((u = t.stateNode = ko(t.type, t.pendingProps, w.current)),
            (xl = t),
            (rt = !0),
            (e = hl),
            ha(t.type) ? ((Fi = e), (hl = St(u.firstChild))) : (hl = e)),
          Yl(l, t, t.pendingProps.children, a),
          on(l, t),
          l === null && (t.flags |= 4194304),
          t.child
        );
      case 5:
        return (
          l === null &&
            P &&
            ((e = u = hl) &&
              ((u = jy(u, t.type, t.pendingProps, rt)),
              u !== null
                ? ((t.stateNode = u),
                  (xl = t),
                  (hl = St(u.firstChild)),
                  (rt = !1),
                  (e = !0))
                : (e = !1)),
            e || ta(t)),
          Nu(t),
          (e = t.type),
          (n = t.pendingProps),
          (c = l !== null ? l.memoizedProps : null),
          (u = n.children),
          Ki(e, n) ? (u = null) : c !== null && Ki(e, c) && (t.flags |= 32),
          t.memoizedState !== null &&
            ((e = Lc(l, t, J0, null, null, a)), (ge._currentValue = e)),
          on(l, t),
          Yl(l, t, u, a),
          t.child
        );
      case 6:
        return (
          l === null &&
            P &&
            ((l = a = hl) &&
              ((a = Hy(a, t.pendingProps, rt)),
              a !== null
                ? ((t.stateNode = a), (xl = t), (hl = null), (l = !0))
                : (l = !1)),
            l || ta(t)),
          null
        );
      case 13:
        return Gd(l, t, a);
      case 4:
        return (
          Zl(t, t.stateNode.containerInfo),
          (u = t.pendingProps),
          l === null ? (t.child = Ba(t, null, u, a)) : Yl(l, t, u, a),
          t.child
        );
      case 11:
        return Ud(l, t, t.type, t.pendingProps, a);
      case 7:
        return (Yl(l, t, t.pendingProps, a), t.child);
      case 8:
        return (Yl(l, t, t.pendingProps.children, a), t.child);
      case 12:
        return (Yl(l, t, t.pendingProps.children, a), t.child);
      case 10:
        return (
          (u = t.pendingProps),
          aa(t, t.type, u.value),
          Yl(l, t, u.children, a),
          t.child
        );
      case 9:
        return (
          (e = t.type._context),
          (u = t.pendingProps.children),
          Ra(t),
          (e = Bl(e)),
          (u = u(e)),
          (t.flags |= 1),
          Yl(l, t, u, a),
          t.child
        );
      case 14:
        return jd(l, t, t.type, t.pendingProps, a);
      case 15:
        return Hd(l, t, t.type, t.pendingProps, a);
      case 19:
        return Qd(l, t, a);
      case 31:
        return ly(l, t, a);
      case 22:
        return Rd(l, t, a, t.pendingProps);
      case 24:
        return (
          Ra(t),
          (u = Bl(Tl)),
          l === null
            ? ((e = Cc()),
              e === null &&
                ((e = yl),
                (n = Hc()),
                (e.pooledCache = n),
                n.refCount++,
                n !== null && (e.pooledCacheLanes |= a),
                (e = n)),
              (t.memoizedState = { parent: u, cache: e }),
              xc(t),
              aa(t, Tl, e))
            : ((l.lanes & a) !== 0 && (Bc(l, t), ku(t, null, null, a), Fu()),
              (e = l.memoizedState),
              (n = t.memoizedState),
              e.parent !== u
                ? ((e = { parent: u, cache: u }),
                  (t.memoizedState = e),
                  t.lanes === 0 &&
                    (t.memoizedState = t.updateQueue.baseState = e),
                  aa(t, Tl, u))
                : ((u = n.cache),
                  aa(t, Tl, u),
                  u !== e.cache && jc(t, [Tl], a, !0))),
          Yl(l, t, t.pendingProps.children, a),
          t.child
        );
      case 29:
        throw t.pendingProps;
    }
    throw Error(s(156, t.tag));
  }
  function Zt(l) {
    l.flags |= 4;
  }
  function Si(l, t, a, u, e) {
    if (((t = (l.mode & 32) !== 0) && (t = !1), t)) {
      if (((l.flags |= 16777216), (e & 335544128) === e))
        if (l.stateNode.complete) l.flags |= 8192;
        else if (ro()) l.flags |= 8192;
        else throw ((xa = $e), qc);
    } else l.flags &= -16777217;
  }
  function Vd(l, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (((l.flags |= 16777216), !nm(t)))
      if (ro()) l.flags |= 8192;
      else throw ((xa = $e), qc);
  }
  function yn(l, t) {
    (t !== null && (l.flags |= 4),
      l.flags & 16384 &&
        ((t = l.tag !== 22 ? _f() : 536870912), (l.lanes |= t), (bu |= t)));
  }
  function ue(l, t) {
    if (!P)
      switch (l.tailMode) {
        case "hidden":
          t = l.tail;
          for (var a = null; t !== null; )
            (t.alternate !== null && (a = t), (t = t.sibling));
          a === null ? (l.tail = null) : (a.sibling = null);
          break;
        case "collapsed":
          a = l.tail;
          for (var u = null; a !== null; )
            (a.alternate !== null && (u = a), (a = a.sibling));
          u === null
            ? t || l.tail === null
              ? (l.tail = null)
              : (l.tail.sibling = null)
            : (u.sibling = null);
      }
  }
  function rl(l) {
    var t = l.alternate !== null && l.alternate.child === l.child,
      a = 0,
      u = 0;
    if (t)
      for (var e = l.child; e !== null; )
        ((a |= e.lanes | e.childLanes),
          (u |= e.subtreeFlags & 65011712),
          (u |= e.flags & 65011712),
          (e.return = l),
          (e = e.sibling));
    else
      for (e = l.child; e !== null; )
        ((a |= e.lanes | e.childLanes),
          (u |= e.subtreeFlags),
          (u |= e.flags),
          (e.return = l),
          (e = e.sibling));
    return ((l.subtreeFlags |= u), (l.childLanes = a), t);
  }
  function ay(l, t, a) {
    var u = t.pendingProps;
    switch ((Oc(t), t.tag)) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return (rl(t), null);
      case 1:
        return (rl(t), null);
      case 3:
        return (
          (a = t.stateNode),
          (u = null),
          l !== null && (u = l.memoizedState.cache),
          t.memoizedState.cache !== u && (t.flags |= 2048),
          Yt(Tl),
          El(),
          a.pendingContext &&
            ((a.context = a.pendingContext), (a.pendingContext = null)),
          (l === null || l.child === null) &&
            (cu(t)
              ? Zt(t)
              : l === null ||
                (l.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                ((t.flags |= 1024), Nc())),
          rl(t),
          null
        );
      case 26:
        var e = t.type,
          n = t.memoizedState;
        return (
          l === null
            ? (Zt(t),
              n !== null ? (rl(t), Vd(t, n)) : (rl(t), Si(t, e, null, u, a)))
            : n
              ? n !== l.memoizedState
                ? (Zt(t), rl(t), Vd(t, n))
                : (rl(t), (t.flags &= -16777217))
              : ((l = l.memoizedProps),
                l !== u && Zt(t),
                rl(t),
                Si(t, e, l, u, a)),
          null
        );
      case 27:
        if (
          (ze(t),
          (a = w.current),
          (e = t.type),
          l !== null && t.stateNode != null)
        )
          l.memoizedProps !== u && Zt(t);
        else {
          if (!u) {
            if (t.stateNode === null) throw Error(s(166));
            return (rl(t), null);
          }
          ((l = H.current),
            cu(t) ? _s(t) : ((l = ko(e, u, a)), (t.stateNode = l), Zt(t)));
        }
        return (rl(t), null);
      case 5:
        if ((ze(t), (e = t.type), l !== null && t.stateNode != null))
          l.memoizedProps !== u && Zt(t);
        else {
          if (!u) {
            if (t.stateNode === null) throw Error(s(166));
            return (rl(t), null);
          }
          if (((n = H.current), cu(t))) _s(t);
          else {
            var c = Nn(w.current);
            switch (n) {
              case 1:
                n = c.createElementNS("http://www.w3.org/2000/svg", e);
                break;
              case 2:
                n = c.createElementNS("http://www.w3.org/1998/Math/MathML", e);
                break;
              default:
                switch (e) {
                  case "svg":
                    n = c.createElementNS("http://www.w3.org/2000/svg", e);
                    break;
                  case "math":
                    n = c.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      e,
                    );
                    break;
                  case "script":
                    ((n = c.createElement("div")),
                      (n.innerHTML = "<script><\/script>"),
                      (n = n.removeChild(n.firstChild)));
                    break;
                  case "select":
                    ((n =
                      typeof u.is == "string"
                        ? c.createElement("select", { is: u.is })
                        : c.createElement("select")),
                      u.multiple
                        ? (n.multiple = !0)
                        : u.size && (n.size = u.size));
                    break;
                  default:
                    n =
                      typeof u.is == "string"
                        ? c.createElement(e, { is: u.is })
                        : c.createElement(e);
                }
            }
            ((n[ql] = t), (n[wl] = u));
            l: for (c = t.child; c !== null; ) {
              if (c.tag === 5 || c.tag === 6) n.appendChild(c.stateNode);
              else if (c.tag !== 4 && c.tag !== 27 && c.child !== null) {
                ((c.child.return = c), (c = c.child));
                continue;
              }
              if (c === t) break l;
              for (; c.sibling === null; ) {
                if (c.return === null || c.return === t) break l;
                c = c.return;
              }
              ((c.sibling.return = c.return), (c = c.sibling));
            }
            t.stateNode = n;
            l: switch ((Gl(n, e, u), e)) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                u = !!u.autoFocus;
                break l;
              case "img":
                u = !0;
                break l;
              default:
                u = !1;
            }
            u && Zt(t);
          }
        }
        return (
          rl(t),
          Si(t, t.type, l === null ? null : l.memoizedProps, t.pendingProps, a),
          null
        );
      case 6:
        if (l && t.stateNode != null) l.memoizedProps !== u && Zt(t);
        else {
          if (typeof u != "string" && t.stateNode === null) throw Error(s(166));
          if (((l = w.current), cu(t))) {
            if (
              ((l = t.stateNode),
              (a = t.memoizedProps),
              (u = null),
              (e = xl),
              e !== null)
            )
              switch (e.tag) {
                case 27:
                case 5:
                  u = e.memoizedProps;
              }
            ((l[ql] = t),
              (l = !!(
                l.nodeValue === a ||
                (u !== null && u.suppressHydrationWarning === !0) ||
                Xo(l.nodeValue, a)
              )),
              l || ta(t, !0));
          } else
            ((l = Nn(l).createTextNode(u)), (l[ql] = t), (t.stateNode = l));
        }
        return (rl(t), null);
      case 31:
        if (((a = t.memoizedState), l === null || l.memoizedState !== null)) {
          if (((u = cu(t)), a !== null)) {
            if (l === null) {
              if (!u) throw Error(s(318));
              if (
                ((l = t.memoizedState),
                (l = l !== null ? l.dehydrated : null),
                !l)
              )
                throw Error(s(557));
              l[ql] = t;
            } else
              (ja(),
                (t.flags & 128) === 0 && (t.memoizedState = null),
                (t.flags |= 4));
            (rl(t), (l = !1));
          } else
            ((a = Nc()),
              l !== null &&
                l.memoizedState !== null &&
                (l.memoizedState.hydrationErrors = a),
              (l = !0));
          if (!l) return t.flags & 256 ? (ct(t), t) : (ct(t), null);
          if ((t.flags & 128) !== 0) throw Error(s(558));
        }
        return (rl(t), null);
      case 13:
        if (
          ((u = t.memoizedState),
          l === null ||
            (l.memoizedState !== null && l.memoizedState.dehydrated !== null))
        ) {
          if (((e = cu(t)), u !== null && u.dehydrated !== null)) {
            if (l === null) {
              if (!e) throw Error(s(318));
              if (
                ((e = t.memoizedState),
                (e = e !== null ? e.dehydrated : null),
                !e)
              )
                throw Error(s(317));
              e[ql] = t;
            } else
              (ja(),
                (t.flags & 128) === 0 && (t.memoizedState = null),
                (t.flags |= 4));
            (rl(t), (e = !1));
          } else
            ((e = Nc()),
              l !== null &&
                l.memoizedState !== null &&
                (l.memoizedState.hydrationErrors = e),
              (e = !0));
          if (!e) return t.flags & 256 ? (ct(t), t) : (ct(t), null);
        }
        return (
          ct(t),
          (t.flags & 128) !== 0
            ? ((t.lanes = a), t)
            : ((a = u !== null),
              (l = l !== null && l.memoizedState !== null),
              a &&
                ((u = t.child),
                (e = null),
                u.alternate !== null &&
                  u.alternate.memoizedState !== null &&
                  u.alternate.memoizedState.cachePool !== null &&
                  (e = u.alternate.memoizedState.cachePool.pool),
                (n = null),
                u.memoizedState !== null &&
                  u.memoizedState.cachePool !== null &&
                  (n = u.memoizedState.cachePool.pool),
                n !== e && (u.flags |= 2048)),
              a !== l && a && (t.child.flags |= 8192),
              yn(t, t.updateQueue),
              rl(t),
              null)
        );
      case 4:
        return (El(), l === null && Xi(t.stateNode.containerInfo), rl(t), null);
      case 10:
        return (Yt(t.type), rl(t), null);
      case 19:
        if ((A(_l), (u = t.memoizedState), u === null)) return (rl(t), null);
        if (((e = (t.flags & 128) !== 0), (n = u.rendering), n === null))
          if (e) ue(u, !1);
          else {
            if (pl !== 0 || (l !== null && (l.flags & 128) !== 0))
              for (l = t.child; l !== null; ) {
                if (((n = Pe(l)), n !== null)) {
                  for (
                    t.flags |= 128,
                      ue(u, !1),
                      l = n.updateQueue,
                      t.updateQueue = l,
                      yn(t, l),
                      t.subtreeFlags = 0,
                      l = a,
                      a = t.child;
                    a !== null;

                  )
                    (gs(a, l), (a = a.sibling));
                  return (
                    U(_l, (_l.current & 1) | 2),
                    P && xt(t, u.treeForkCount),
                    t.child
                  );
                }
                l = l.sibling;
              }
            u.tail !== null &&
              lt() > Sn &&
              ((t.flags |= 128), (e = !0), ue(u, !1), (t.lanes = 4194304));
          }
        else {
          if (!e)
            if (((l = Pe(n)), l !== null)) {
              if (
                ((t.flags |= 128),
                (e = !0),
                (l = l.updateQueue),
                (t.updateQueue = l),
                yn(t, l),
                ue(u, !0),
                u.tail === null &&
                  u.tailMode === "hidden" &&
                  !n.alternate &&
                  !P)
              )
                return (rl(t), null);
            } else
              2 * lt() - u.renderingStartTime > Sn &&
                a !== 536870912 &&
                ((t.flags |= 128), (e = !0), ue(u, !1), (t.lanes = 4194304));
          u.isBackwards
            ? ((n.sibling = t.child), (t.child = n))
            : ((l = u.last),
              l !== null ? (l.sibling = n) : (t.child = n),
              (u.last = n));
        }
        return u.tail !== null
          ? ((l = u.tail),
            (u.rendering = l),
            (u.tail = l.sibling),
            (u.renderingStartTime = lt()),
            (l.sibling = null),
            (a = _l.current),
            U(_l, e ? (a & 1) | 2 : a & 1),
            P && xt(t, u.treeForkCount),
            l)
          : (rl(t), null);
      case 22:
      case 23:
        return (
          ct(t),
          Qc(),
          (u = t.memoizedState !== null),
          l !== null
            ? (l.memoizedState !== null) !== u && (t.flags |= 8192)
            : u && (t.flags |= 8192),
          u
            ? (a & 536870912) !== 0 &&
              (t.flags & 128) === 0 &&
              (rl(t), t.subtreeFlags & 6 && (t.flags |= 8192))
            : rl(t),
          (a = t.updateQueue),
          a !== null && yn(t, a.retryQueue),
          (a = null),
          l !== null &&
            l.memoizedState !== null &&
            l.memoizedState.cachePool !== null &&
            (a = l.memoizedState.cachePool.pool),
          (u = null),
          t.memoizedState !== null &&
            t.memoizedState.cachePool !== null &&
            (u = t.memoizedState.cachePool.pool),
          u !== a && (t.flags |= 2048),
          l !== null && A(Ca),
          null
        );
      case 24:
        return (
          (a = null),
          l !== null && (a = l.memoizedState.cache),
          t.memoizedState.cache !== a && (t.flags |= 2048),
          Yt(Tl),
          rl(t),
          null
        );
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(s(156, t.tag));
  }
  function uy(l, t) {
    switch ((Oc(t), t.tag)) {
      case 1:
        return (
          (l = t.flags),
          l & 65536 ? ((t.flags = (l & -65537) | 128), t) : null
        );
      case 3:
        return (
          Yt(Tl),
          El(),
          (l = t.flags),
          (l & 65536) !== 0 && (l & 128) === 0
            ? ((t.flags = (l & -65537) | 128), t)
            : null
        );
      case 26:
      case 27:
      case 5:
        return (ze(t), null);
      case 31:
        if (t.memoizedState !== null) {
          if ((ct(t), t.alternate === null)) throw Error(s(340));
          ja();
        }
        return (
          (l = t.flags),
          l & 65536 ? ((t.flags = (l & -65537) | 128), t) : null
        );
      case 13:
        if (
          (ct(t), (l = t.memoizedState), l !== null && l.dehydrated !== null)
        ) {
          if (t.alternate === null) throw Error(s(340));
          ja();
        }
        return (
          (l = t.flags),
          l & 65536 ? ((t.flags = (l & -65537) | 128), t) : null
        );
      case 19:
        return (A(_l), null);
      case 4:
        return (El(), null);
      case 10:
        return (Yt(t.type), null);
      case 22:
      case 23:
        return (
          ct(t),
          Qc(),
          l !== null && A(Ca),
          (l = t.flags),
          l & 65536 ? ((t.flags = (l & -65537) | 128), t) : null
        );
      case 24:
        return (Yt(Tl), null);
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Ld(l, t) {
    switch ((Oc(t), t.tag)) {
      case 3:
        (Yt(Tl), El());
        break;
      case 26:
      case 27:
      case 5:
        ze(t);
        break;
      case 4:
        El();
        break;
      case 31:
        t.memoizedState !== null && ct(t);
        break;
      case 13:
        ct(t);
        break;
      case 19:
        A(_l);
        break;
      case 10:
        Yt(t.type);
        break;
      case 22:
      case 23:
        (ct(t), Qc(), l !== null && A(Ca));
        break;
      case 24:
        Yt(Tl);
    }
  }
  function ee(l, t) {
    try {
      var a = t.updateQueue,
        u = a !== null ? a.lastEffect : null;
      if (u !== null) {
        var e = u.next;
        a = e;
        do {
          if ((a.tag & l) === l) {
            u = void 0;
            var n = a.create,
              c = a.inst;
            ((u = n()), (c.destroy = u));
          }
          a = a.next;
        } while (a !== e);
      }
    } catch (i) {
      cl(t, t.return, i);
    }
  }
  function fa(l, t, a) {
    try {
      var u = t.updateQueue,
        e = u !== null ? u.lastEffect : null;
      if (e !== null) {
        var n = e.next;
        u = n;
        do {
          if ((u.tag & l) === l) {
            var c = u.inst,
              i = c.destroy;
            if (i !== void 0) {
              ((c.destroy = void 0), (e = t));
              var f = a,
                v = i;
              try {
                v();
              } catch (p) {
                cl(e, f, p);
              }
            }
          }
          u = u.next;
        } while (u !== n);
      }
    } catch (p) {
      cl(t, t.return, p);
    }
  }
  function Kd(l) {
    var t = l.updateQueue;
    if (t !== null) {
      var a = l.stateNode;
      try {
        qs(t, a);
      } catch (u) {
        cl(l, l.return, u);
      }
    }
  }
  function Jd(l, t, a) {
    ((a.props = Ga(l.type, l.memoizedProps)), (a.state = l.memoizedState));
    try {
      a.componentWillUnmount();
    } catch (u) {
      cl(l, t, u);
    }
  }
  function ne(l, t) {
    try {
      var a = l.ref;
      if (a !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var u = l.stateNode;
            break;
          case 30:
            u = l.stateNode;
            break;
          default:
            u = l.stateNode;
        }
        typeof a == "function" ? (l.refCleanup = a(u)) : (a.current = u);
      }
    } catch (e) {
      cl(l, t, e);
    }
  }
  function Dt(l, t) {
    var a = l.ref,
      u = l.refCleanup;
    if (a !== null)
      if (typeof u == "function")
        try {
          u();
        } catch (e) {
          cl(l, t, e);
        } finally {
          ((l.refCleanup = null),
            (l = l.alternate),
            l != null && (l.refCleanup = null));
        }
      else if (typeof a == "function")
        try {
          a(null);
        } catch (e) {
          cl(l, t, e);
        }
      else a.current = null;
  }
  function wd(l) {
    var t = l.type,
      a = l.memoizedProps,
      u = l.stateNode;
    try {
      l: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          a.autoFocus && u.focus();
          break l;
        case "img":
          a.src ? (u.src = a.src) : a.srcSet && (u.srcset = a.srcSet);
      }
    } catch (e) {
      cl(l, l.return, e);
    }
  }
  function bi(l, t, a) {
    try {
      var u = l.stateNode;
      (Ay(u, l.type, a, t), (u[wl] = t));
    } catch (e) {
      cl(l, l.return, e);
    }
  }
  function Wd(l) {
    return (
      l.tag === 5 ||
      l.tag === 3 ||
      l.tag === 26 ||
      (l.tag === 27 && ha(l.type)) ||
      l.tag === 4
    );
  }
  function pi(l) {
    l: for (;;) {
      for (; l.sibling === null; ) {
        if (l.return === null || Wd(l.return)) return null;
        l = l.return;
      }
      for (
        l.sibling.return = l.return, l = l.sibling;
        l.tag !== 5 && l.tag !== 6 && l.tag !== 18;

      ) {
        if (
          (l.tag === 27 && ha(l.type)) ||
          l.flags & 2 ||
          l.child === null ||
          l.tag === 4
        )
          continue l;
        ((l.child.return = l), (l = l.child));
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function Ei(l, t, a) {
    var u = l.tag;
    if (u === 5 || u === 6)
      ((l = l.stateNode),
        t
          ? (a.nodeType === 9
              ? a.body
              : a.nodeName === "HTML"
                ? a.ownerDocument.body
                : a
            ).insertBefore(l, t)
          : ((t =
              a.nodeType === 9
                ? a.body
                : a.nodeName === "HTML"
                  ? a.ownerDocument.body
                  : a),
            t.appendChild(l),
            (a = a._reactRootContainer),
            a != null || t.onclick !== null || (t.onclick = Rt)));
    else if (
      u !== 4 &&
      (u === 27 && ha(l.type) && ((a = l.stateNode), (t = null)),
      (l = l.child),
      l !== null)
    )
      for (Ei(l, t, a), l = l.sibling; l !== null; )
        (Ei(l, t, a), (l = l.sibling));
  }
  function vn(l, t, a) {
    var u = l.tag;
    if (u === 5 || u === 6)
      ((l = l.stateNode), t ? a.insertBefore(l, t) : a.appendChild(l));
    else if (
      u !== 4 &&
      (u === 27 && ha(l.type) && (a = l.stateNode), (l = l.child), l !== null)
    )
      for (vn(l, t, a), l = l.sibling; l !== null; )
        (vn(l, t, a), (l = l.sibling));
  }
  function $d(l) {
    var t = l.stateNode,
      a = l.memoizedProps;
    try {
      for (var u = l.type, e = t.attributes; e.length; )
        t.removeAttributeNode(e[0]);
      (Gl(t, u, a), (t[ql] = l), (t[wl] = a));
    } catch (n) {
      cl(l, l.return, n);
    }
  }
  var Vt = !1,
    Ml = !1,
    _i = !1,
    Fd = typeof WeakSet == "function" ? WeakSet : Set,
    Cl = null;
  function ey(l, t) {
    if (((l = l.containerInfo), (Vi = qn), (l = fs(l)), hc(l))) {
      if ("selectionStart" in l)
        var a = { start: l.selectionStart, end: l.selectionEnd };
      else
        l: {
          a = ((a = l.ownerDocument) && a.defaultView) || window;
          var u = a.getSelection && a.getSelection();
          if (u && u.rangeCount !== 0) {
            a = u.anchorNode;
            var e = u.anchorOffset,
              n = u.focusNode;
            u = u.focusOffset;
            try {
              (a.nodeType, n.nodeType);
            } catch {
              a = null;
              break l;
            }
            var c = 0,
              i = -1,
              f = -1,
              v = 0,
              p = 0,
              z = l,
              r = null;
            t: for (;;) {
              for (
                var S;
                z !== a || (e !== 0 && z.nodeType !== 3) || (i = c + e),
                  z !== n || (u !== 0 && z.nodeType !== 3) || (f = c + u),
                  z.nodeType === 3 && (c += z.nodeValue.length),
                  (S = z.firstChild) !== null;

              )
                ((r = z), (z = S));
              for (;;) {
                if (z === l) break t;
                if (
                  (r === a && ++v === e && (i = c),
                  r === n && ++p === u && (f = c),
                  (S = z.nextSibling) !== null)
                )
                  break;
                ((z = r), (r = z.parentNode));
              }
              z = S;
            }
            a = i === -1 || f === -1 ? null : { start: i, end: f };
          } else a = null;
        }
      a = a || { start: 0, end: 0 };
    } else a = null;
    for (
      Li = { focusedElem: l, selectionRange: a }, qn = !1, Cl = t;
      Cl !== null;

    )
      if (
        ((t = Cl), (l = t.child), (t.subtreeFlags & 1028) !== 0 && l !== null)
      )
        ((l.return = t), (Cl = l));
      else
        for (; Cl !== null; ) {
          switch (((t = Cl), (n = t.alternate), (l = t.flags), t.tag)) {
            case 0:
              if (
                (l & 4) !== 0 &&
                ((l = t.updateQueue),
                (l = l !== null ? l.events : null),
                l !== null)
              )
                for (a = 0; a < l.length; a++)
                  ((e = l[a]), (e.ref.impl = e.nextImpl));
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && n !== null) {
                ((l = void 0),
                  (a = t),
                  (e = n.memoizedProps),
                  (n = n.memoizedState),
                  (u = a.stateNode));
                try {
                  var j = Ga(a.type, e);
                  ((l = u.getSnapshotBeforeUpdate(j, n)),
                    (u.__reactInternalSnapshotBeforeUpdate = l));
                } catch (G) {
                  cl(a, a.return, G);
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (
                  ((l = t.stateNode.containerInfo), (a = l.nodeType), a === 9)
                )
                  wi(l);
                else if (a === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      wi(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(s(163));
          }
          if (((l = t.sibling), l !== null)) {
            ((l.return = t.return), (Cl = l));
            break;
          }
          Cl = t.return;
        }
  }
  function kd(l, t, a) {
    var u = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        (Kt(l, a), u & 4 && ee(5, a));
        break;
      case 1:
        if ((Kt(l, a), u & 4))
          if (((l = a.stateNode), t === null))
            try {
              l.componentDidMount();
            } catch (c) {
              cl(a, a.return, c);
            }
          else {
            var e = Ga(a.type, t.memoizedProps);
            t = t.memoizedState;
            try {
              l.componentDidUpdate(e, t, l.__reactInternalSnapshotBeforeUpdate);
            } catch (c) {
              cl(a, a.return, c);
            }
          }
        (u & 64 && Kd(a), u & 512 && ne(a, a.return));
        break;
      case 3:
        if ((Kt(l, a), u & 64 && ((l = a.updateQueue), l !== null))) {
          if (((t = null), a.child !== null))
            switch (a.child.tag) {
              case 27:
              case 5:
                t = a.child.stateNode;
                break;
              case 1:
                t = a.child.stateNode;
            }
          try {
            qs(l, t);
          } catch (c) {
            cl(a, a.return, c);
          }
        }
        break;
      case 27:
        t === null && u & 4 && $d(a);
      case 26:
      case 5:
        (Kt(l, a), t === null && u & 4 && wd(a), u & 512 && ne(a, a.return));
        break;
      case 12:
        Kt(l, a);
        break;
      case 31:
        (Kt(l, a), u & 4 && lo(l, a));
        break;
      case 13:
        (Kt(l, a),
          u & 4 && to(l, a),
          u & 64 &&
            ((l = a.memoizedState),
            l !== null &&
              ((l = l.dehydrated),
              l !== null && ((a = yy.bind(null, a)), Ry(l, a)))));
        break;
      case 22:
        if (((u = a.memoizedState !== null || Vt), !u)) {
          ((t = (t !== null && t.memoizedState !== null) || Ml), (e = Vt));
          var n = Ml;
          ((Vt = u),
            (Ml = t) && !n ? Jt(l, a, (a.subtreeFlags & 8772) !== 0) : Kt(l, a),
            (Vt = e),
            (Ml = n));
        }
        break;
      case 30:
        break;
      default:
        Kt(l, a);
    }
  }
  function Id(l) {
    var t = l.alternate;
    (t !== null && ((l.alternate = null), Id(t)),
      (l.child = null),
      (l.deletions = null),
      (l.sibling = null),
      l.tag === 5 && ((t = l.stateNode), t !== null && In(t)),
      (l.stateNode = null),
      (l.return = null),
      (l.dependencies = null),
      (l.memoizedProps = null),
      (l.memoizedState = null),
      (l.pendingProps = null),
      (l.stateNode = null),
      (l.updateQueue = null));
  }
  var gl = null,
    $l = !1;
  function Lt(l, t, a) {
    for (a = a.child; a !== null; ) (Pd(l, t, a), (a = a.sibling));
  }
  function Pd(l, t, a) {
    if (tt && typeof tt.onCommitFiberUnmount == "function")
      try {
        tt.onCommitFiberUnmount(Du, a);
      } catch {}
    switch (a.tag) {
      case 26:
        (Ml || Dt(a, t),
          Lt(l, t, a),
          a.memoizedState
            ? a.memoizedState.count--
            : a.stateNode && ((a = a.stateNode), a.parentNode.removeChild(a)));
        break;
      case 27:
        Ml || Dt(a, t);
        var u = gl,
          e = $l;
        (ha(a.type) && ((gl = a.stateNode), ($l = !1)),
          Lt(l, t, a),
          ve(a.stateNode),
          (gl = u),
          ($l = e));
        break;
      case 5:
        Ml || Dt(a, t);
      case 6:
        if (
          ((u = gl),
          (e = $l),
          (gl = null),
          Lt(l, t, a),
          (gl = u),
          ($l = e),
          gl !== null)
        )
          if ($l)
            try {
              (gl.nodeType === 9
                ? gl.body
                : gl.nodeName === "HTML"
                  ? gl.ownerDocument.body
                  : gl
              ).removeChild(a.stateNode);
            } catch (n) {
              cl(a, t, n);
            }
          else
            try {
              gl.removeChild(a.stateNode);
            } catch (n) {
              cl(a, t, n);
            }
        break;
      case 18:
        gl !== null &&
          ($l
            ? ((l = gl),
              Jo(
                l.nodeType === 9
                  ? l.body
                  : l.nodeName === "HTML"
                    ? l.ownerDocument.body
                    : l,
                a.stateNode,
              ),
              Mu(l))
            : Jo(gl, a.stateNode));
        break;
      case 4:
        ((u = gl),
          (e = $l),
          (gl = a.stateNode.containerInfo),
          ($l = !0),
          Lt(l, t, a),
          (gl = u),
          ($l = e));
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        (fa(2, a, t), Ml || fa(4, a, t), Lt(l, t, a));
        break;
      case 1:
        (Ml ||
          (Dt(a, t),
          (u = a.stateNode),
          typeof u.componentWillUnmount == "function" && Jd(a, t, u)),
          Lt(l, t, a));
        break;
      case 21:
        Lt(l, t, a);
        break;
      case 22:
        ((Ml = (u = Ml) || a.memoizedState !== null), Lt(l, t, a), (Ml = u));
        break;
      default:
        Lt(l, t, a);
    }
  }
  function lo(l, t) {
    if (
      t.memoizedState === null &&
      ((l = t.alternate), l !== null && ((l = l.memoizedState), l !== null))
    ) {
      l = l.dehydrated;
      try {
        Mu(l);
      } catch (a) {
        cl(t, t.return, a);
      }
    }
  }
  function to(l, t) {
    if (
      t.memoizedState === null &&
      ((l = t.alternate),
      l !== null &&
        ((l = l.memoizedState), l !== null && ((l = l.dehydrated), l !== null)))
    )
      try {
        Mu(l);
      } catch (a) {
        cl(t, t.return, a);
      }
  }
  function ny(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var t = l.stateNode;
        return (t === null && (t = l.stateNode = new Fd()), t);
      case 22:
        return (
          (l = l.stateNode),
          (t = l._retryCache),
          t === null && (t = l._retryCache = new Fd()),
          t
        );
      default:
        throw Error(s(435, l.tag));
    }
  }
  function hn(l, t) {
    var a = ny(l);
    t.forEach(function (u) {
      if (!a.has(u)) {
        a.add(u);
        var e = vy.bind(null, l, u);
        u.then(e, e);
      }
    });
  }
  function Fl(l, t) {
    var a = t.deletions;
    if (a !== null)
      for (var u = 0; u < a.length; u++) {
        var e = a[u],
          n = l,
          c = t,
          i = c;
        l: for (; i !== null; ) {
          switch (i.tag) {
            case 27:
              if (ha(i.type)) {
                ((gl = i.stateNode), ($l = !1));
                break l;
              }
              break;
            case 5:
              ((gl = i.stateNode), ($l = !1));
              break l;
            case 3:
            case 4:
              ((gl = i.stateNode.containerInfo), ($l = !0));
              break l;
          }
          i = i.return;
        }
        if (gl === null) throw Error(s(160));
        (Pd(n, c, e),
          (gl = null),
          ($l = !1),
          (n = e.alternate),
          n !== null && (n.return = null),
          (e.return = null));
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; ) (ao(t, l), (t = t.sibling));
  }
  var _t = null;
  function ao(l, t) {
    var a = l.alternate,
      u = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        (Fl(t, l),
          kl(l),
          u & 4 && (fa(3, l, l.return), ee(3, l), fa(5, l, l.return)));
        break;
      case 1:
        (Fl(t, l),
          kl(l),
          u & 512 && (Ml || a === null || Dt(a, a.return)),
          u & 64 &&
            Vt &&
            ((l = l.updateQueue),
            l !== null &&
              ((u = l.callbacks),
              u !== null &&
                ((a = l.shared.hiddenCallbacks),
                (l.shared.hiddenCallbacks = a === null ? u : a.concat(u))))));
        break;
      case 26:
        var e = _t;
        if (
          (Fl(t, l),
          kl(l),
          u & 512 && (Ml || a === null || Dt(a, a.return)),
          u & 4)
        ) {
          var n = a !== null ? a.memoizedState : null;
          if (((u = l.memoizedState), a === null))
            if (u === null)
              if (l.stateNode === null) {
                l: {
                  ((u = l.type),
                    (a = l.memoizedProps),
                    (e = e.ownerDocument || e));
                  t: switch (u) {
                    case "title":
                      ((n = e.getElementsByTagName("title")[0]),
                        (!n ||
                          n[Hu] ||
                          n[ql] ||
                          n.namespaceURI === "http://www.w3.org/2000/svg" ||
                          n.hasAttribute("itemprop")) &&
                          ((n = e.createElement(u)),
                          e.head.insertBefore(
                            n,
                            e.querySelector("head > title"),
                          )),
                        Gl(n, u, a),
                        (n[ql] = l),
                        Rl(n),
                        (u = n));
                      break l;
                    case "link":
                      var c = um("link", "href", e).get(u + (a.href || ""));
                      if (c) {
                        for (var i = 0; i < c.length; i++)
                          if (
                            ((n = c[i]),
                            n.getAttribute("href") ===
                              (a.href == null || a.href === ""
                                ? null
                                : a.href) &&
                              n.getAttribute("rel") ===
                                (a.rel == null ? null : a.rel) &&
                              n.getAttribute("title") ===
                                (a.title == null ? null : a.title) &&
                              n.getAttribute("crossorigin") ===
                                (a.crossOrigin == null ? null : a.crossOrigin))
                          ) {
                            c.splice(i, 1);
                            break t;
                          }
                      }
                      ((n = e.createElement(u)),
                        Gl(n, u, a),
                        e.head.appendChild(n));
                      break;
                    case "meta":
                      if (
                        (c = um("meta", "content", e).get(
                          u + (a.content || ""),
                        ))
                      ) {
                        for (i = 0; i < c.length; i++)
                          if (
                            ((n = c[i]),
                            n.getAttribute("content") ===
                              (a.content == null ? null : "" + a.content) &&
                              n.getAttribute("name") ===
                                (a.name == null ? null : a.name) &&
                              n.getAttribute("property") ===
                                (a.property == null ? null : a.property) &&
                              n.getAttribute("http-equiv") ===
                                (a.httpEquiv == null ? null : a.httpEquiv) &&
                              n.getAttribute("charset") ===
                                (a.charSet == null ? null : a.charSet))
                          ) {
                            c.splice(i, 1);
                            break t;
                          }
                      }
                      ((n = e.createElement(u)),
                        Gl(n, u, a),
                        e.head.appendChild(n));
                      break;
                    default:
                      throw Error(s(468, u));
                  }
                  ((n[ql] = l), Rl(n), (u = n));
                }
                l.stateNode = u;
              } else em(e, l.type, l.stateNode);
            else l.stateNode = am(e, u, l.memoizedProps);
          else
            n !== u
              ? (n === null
                  ? a.stateNode !== null &&
                    ((a = a.stateNode), a.parentNode.removeChild(a))
                  : n.count--,
                u === null
                  ? em(e, l.type, l.stateNode)
                  : am(e, u, l.memoizedProps))
              : u === null &&
                l.stateNode !== null &&
                bi(l, l.memoizedProps, a.memoizedProps);
        }
        break;
      case 27:
        (Fl(t, l),
          kl(l),
          u & 512 && (Ml || a === null || Dt(a, a.return)),
          a !== null && u & 4 && bi(l, l.memoizedProps, a.memoizedProps));
        break;
      case 5:
        if (
          (Fl(t, l),
          kl(l),
          u & 512 && (Ml || a === null || Dt(a, a.return)),
          l.flags & 32)
        ) {
          e = l.stateNode;
          try {
            Fa(e, "");
          } catch (j) {
            cl(l, l.return, j);
          }
        }
        (u & 4 &&
          l.stateNode != null &&
          ((e = l.memoizedProps), bi(l, e, a !== null ? a.memoizedProps : e)),
          u & 1024 && (_i = !0));
        break;
      case 6:
        if ((Fl(t, l), kl(l), u & 4)) {
          if (l.stateNode === null) throw Error(s(162));
          ((u = l.memoizedProps), (a = l.stateNode));
          try {
            a.nodeValue = u;
          } catch (j) {
            cl(l, l.return, j);
          }
        }
        break;
      case 3:
        if (
          ((jn = null),
          (e = _t),
          (_t = Dn(t.containerInfo)),
          Fl(t, l),
          (_t = e),
          kl(l),
          u & 4 && a !== null && a.memoizedState.isDehydrated)
        )
          try {
            Mu(t.containerInfo);
          } catch (j) {
            cl(l, l.return, j);
          }
        _i && ((_i = !1), uo(l));
        break;
      case 4:
        ((u = _t),
          (_t = Dn(l.stateNode.containerInfo)),
          Fl(t, l),
          kl(l),
          (_t = u));
        break;
      case 12:
        (Fl(t, l), kl(l));
        break;
      case 31:
        (Fl(t, l),
          kl(l),
          u & 4 &&
            ((u = l.updateQueue),
            u !== null && ((l.updateQueue = null), hn(l, u))));
        break;
      case 13:
        (Fl(t, l),
          kl(l),
          l.child.flags & 8192 &&
            (l.memoizedState !== null) !=
              (a !== null && a.memoizedState !== null) &&
            (gn = lt()),
          u & 4 &&
            ((u = l.updateQueue),
            u !== null && ((l.updateQueue = null), hn(l, u))));
        break;
      case 22:
        e = l.memoizedState !== null;
        var f = a !== null && a.memoizedState !== null,
          v = Vt,
          p = Ml;
        if (
          ((Vt = v || e),
          (Ml = p || f),
          Fl(t, l),
          (Ml = p),
          (Vt = v),
          kl(l),
          u & 8192)
        )
          l: for (
            t = l.stateNode,
              t._visibility = e ? t._visibility & -2 : t._visibility | 1,
              e && (a === null || f || Vt || Ml || Xa(l)),
              a = null,
              t = l;
            ;

          ) {
            if (t.tag === 5 || t.tag === 26) {
              if (a === null) {
                f = a = t;
                try {
                  if (((n = f.stateNode), e))
                    ((c = n.style),
                      typeof c.setProperty == "function"
                        ? c.setProperty("display", "none", "important")
                        : (c.display = "none"));
                  else {
                    i = f.stateNode;
                    var z = f.memoizedProps.style,
                      r =
                        z != null && z.hasOwnProperty("display")
                          ? z.display
                          : null;
                    i.style.display =
                      r == null || typeof r == "boolean" ? "" : ("" + r).trim();
                  }
                } catch (j) {
                  cl(f, f.return, j);
                }
              }
            } else if (t.tag === 6) {
              if (a === null) {
                f = t;
                try {
                  f.stateNode.nodeValue = e ? "" : f.memoizedProps;
                } catch (j) {
                  cl(f, f.return, j);
                }
              }
            } else if (t.tag === 18) {
              if (a === null) {
                f = t;
                try {
                  var S = f.stateNode;
                  e ? wo(S, !0) : wo(f.stateNode, !1);
                } catch (j) {
                  cl(f, f.return, j);
                }
              }
            } else if (
              ((t.tag !== 22 && t.tag !== 23) ||
                t.memoizedState === null ||
                t === l) &&
              t.child !== null
            ) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === l) break l;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === l) break l;
              (a === t && (a = null), (t = t.return));
            }
            (a === t && (a = null),
              (t.sibling.return = t.return),
              (t = t.sibling));
          }
        u & 4 &&
          ((u = l.updateQueue),
          u !== null &&
            ((a = u.retryQueue),
            a !== null && ((u.retryQueue = null), hn(l, a))));
        break;
      case 19:
        (Fl(t, l),
          kl(l),
          u & 4 &&
            ((u = l.updateQueue),
            u !== null && ((l.updateQueue = null), hn(l, u))));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        (Fl(t, l), kl(l));
    }
  }
  function kl(l) {
    var t = l.flags;
    if (t & 2) {
      try {
        for (var a, u = l.return; u !== null; ) {
          if (Wd(u)) {
            a = u;
            break;
          }
          u = u.return;
        }
        if (a == null) throw Error(s(160));
        switch (a.tag) {
          case 27:
            var e = a.stateNode,
              n = pi(l);
            vn(l, n, e);
            break;
          case 5:
            var c = a.stateNode;
            a.flags & 32 && (Fa(c, ""), (a.flags &= -33));
            var i = pi(l);
            vn(l, i, c);
            break;
          case 3:
          case 4:
            var f = a.stateNode.containerInfo,
              v = pi(l);
            Ei(l, v, f);
            break;
          default:
            throw Error(s(161));
        }
      } catch (p) {
        cl(l, l.return, p);
      }
      l.flags &= -3;
    }
    t & 4096 && (l.flags &= -4097);
  }
  function uo(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var t = l;
        (uo(t),
          t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
          (l = l.sibling));
      }
  }
  function Kt(l, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; ) (kd(l, t.alternate, t), (t = t.sibling));
  }
  function Xa(l) {
    for (l = l.child; l !== null; ) {
      var t = l;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          (fa(4, t, t.return), Xa(t));
          break;
        case 1:
          Dt(t, t.return);
          var a = t.stateNode;
          (typeof a.componentWillUnmount == "function" && Jd(t, t.return, a),
            Xa(t));
          break;
        case 27:
          ve(t.stateNode);
        case 26:
        case 5:
          (Dt(t, t.return), Xa(t));
          break;
        case 22:
          t.memoizedState === null && Xa(t);
          break;
        case 30:
          Xa(t);
          break;
        default:
          Xa(t);
      }
      l = l.sibling;
    }
  }
  function Jt(l, t, a) {
    for (a = a && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var u = t.alternate,
        e = l,
        n = t,
        c = n.flags;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          (Jt(e, n, a), ee(4, n));
          break;
        case 1:
          if (
            (Jt(e, n, a),
            (u = n),
            (e = u.stateNode),
            typeof e.componentDidMount == "function")
          )
            try {
              e.componentDidMount();
            } catch (v) {
              cl(u, u.return, v);
            }
          if (((u = n), (e = u.updateQueue), e !== null)) {
            var i = u.stateNode;
            try {
              var f = e.shared.hiddenCallbacks;
              if (f !== null)
                for (e.shared.hiddenCallbacks = null, e = 0; e < f.length; e++)
                  Cs(f[e], i);
            } catch (v) {
              cl(u, u.return, v);
            }
          }
          (a && c & 64 && Kd(n), ne(n, n.return));
          break;
        case 27:
          $d(n);
        case 26:
        case 5:
          (Jt(e, n, a), a && u === null && c & 4 && wd(n), ne(n, n.return));
          break;
        case 12:
          Jt(e, n, a);
          break;
        case 31:
          (Jt(e, n, a), a && c & 4 && lo(e, n));
          break;
        case 13:
          (Jt(e, n, a), a && c & 4 && to(e, n));
          break;
        case 22:
          (n.memoizedState === null && Jt(e, n, a), ne(n, n.return));
          break;
        case 30:
          break;
        default:
          Jt(e, n, a);
      }
      t = t.sibling;
    }
  }
  function zi(l, t) {
    var a = null;
    (l !== null &&
      l.memoizedState !== null &&
      l.memoizedState.cachePool !== null &&
      (a = l.memoizedState.cachePool.pool),
      (l = null),
      t.memoizedState !== null &&
        t.memoizedState.cachePool !== null &&
        (l = t.memoizedState.cachePool.pool),
      l !== a && (l != null && l.refCount++, a != null && Ku(a)));
  }
  function Ti(l, t) {
    ((l = null),
      t.alternate !== null && (l = t.alternate.memoizedState.cache),
      (t = t.memoizedState.cache),
      t !== l && (t.refCount++, l != null && Ku(l)));
  }
  function zt(l, t, a, u) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) (eo(l, t, a, u), (t = t.sibling));
  }
  function eo(l, t, a, u) {
    var e = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        (zt(l, t, a, u), e & 2048 && ee(9, t));
        break;
      case 1:
        zt(l, t, a, u);
        break;
      case 3:
        (zt(l, t, a, u),
          e & 2048 &&
            ((l = null),
            t.alternate !== null && (l = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== l && (t.refCount++, l != null && Ku(l))));
        break;
      case 12:
        if (e & 2048) {
          (zt(l, t, a, u), (l = t.stateNode));
          try {
            var n = t.memoizedProps,
              c = n.id,
              i = n.onPostCommit;
            typeof i == "function" &&
              i(
                c,
                t.alternate === null ? "mount" : "update",
                l.passiveEffectDuration,
                -0,
              );
          } catch (f) {
            cl(t, t.return, f);
          }
        } else zt(l, t, a, u);
        break;
      case 31:
        zt(l, t, a, u);
        break;
      case 13:
        zt(l, t, a, u);
        break;
      case 23:
        break;
      case 22:
        ((n = t.stateNode),
          (c = t.alternate),
          t.memoizedState !== null
            ? n._visibility & 2
              ? zt(l, t, a, u)
              : ce(l, t)
            : n._visibility & 2
              ? zt(l, t, a, u)
              : ((n._visibility |= 2),
                ru(l, t, a, u, (t.subtreeFlags & 10256) !== 0 || !1)),
          e & 2048 && zi(c, t));
        break;
      case 24:
        (zt(l, t, a, u), e & 2048 && Ti(t.alternate, t));
        break;
      default:
        zt(l, t, a, u);
    }
  }
  function ru(l, t, a, u, e) {
    for (
      e = e && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child;
      t !== null;

    ) {
      var n = l,
        c = t,
        i = a,
        f = u,
        v = c.flags;
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
          (ru(n, c, i, f, e), ee(8, c));
          break;
        case 23:
          break;
        case 22:
          var p = c.stateNode;
          (c.memoizedState !== null
            ? p._visibility & 2
              ? ru(n, c, i, f, e)
              : ce(n, c)
            : ((p._visibility |= 2), ru(n, c, i, f, e)),
            e && v & 2048 && zi(c.alternate, c));
          break;
        case 24:
          (ru(n, c, i, f, e), e && v & 2048 && Ti(c.alternate, c));
          break;
        default:
          ru(n, c, i, f, e);
      }
      t = t.sibling;
    }
  }
  function ce(l, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var a = l,
          u = t,
          e = u.flags;
        switch (u.tag) {
          case 22:
            (ce(a, u), e & 2048 && zi(u.alternate, u));
            break;
          case 24:
            (ce(a, u), e & 2048 && Ti(u.alternate, u));
            break;
          default:
            ce(a, u);
        }
        t = t.sibling;
      }
  }
  var ie = 8192;
  function gu(l, t, a) {
    if (l.subtreeFlags & ie)
      for (l = l.child; l !== null; ) (no(l, t, a), (l = l.sibling));
  }
  function no(l, t, a) {
    switch (l.tag) {
      case 26:
        (gu(l, t, a),
          l.flags & ie &&
            l.memoizedState !== null &&
            Ky(a, _t, l.memoizedState, l.memoizedProps));
        break;
      case 5:
        gu(l, t, a);
        break;
      case 3:
      case 4:
        var u = _t;
        ((_t = Dn(l.stateNode.containerInfo)), gu(l, t, a), (_t = u));
        break;
      case 22:
        l.memoizedState === null &&
          ((u = l.alternate),
          u !== null && u.memoizedState !== null
            ? ((u = ie), (ie = 16777216), gu(l, t, a), (ie = u))
            : gu(l, t, a));
        break;
      default:
        gu(l, t, a);
    }
  }
  function co(l) {
    var t = l.alternate;
    if (t !== null && ((l = t.child), l !== null)) {
      t.child = null;
      do ((t = l.sibling), (l.sibling = null), (l = t));
      while (l !== null);
    }
  }
  function fe(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var u = t[a];
          ((Cl = u), fo(u, l));
        }
      co(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; ) (io(l), (l = l.sibling));
  }
  function io(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        (fe(l), l.flags & 2048 && fa(9, l, l.return));
        break;
      case 3:
        fe(l);
        break;
      case 12:
        fe(l);
        break;
      case 22:
        var t = l.stateNode;
        l.memoizedState !== null &&
        t._visibility & 2 &&
        (l.return === null || l.return.tag !== 13)
          ? ((t._visibility &= -3), rn(l))
          : fe(l);
        break;
      default:
        fe(l);
    }
  }
  function rn(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var a = 0; a < t.length; a++) {
          var u = t[a];
          ((Cl = u), fo(u, l));
        }
      co(l);
    }
    for (l = l.child; l !== null; ) {
      switch (((t = l), t.tag)) {
        case 0:
        case 11:
        case 15:
          (fa(8, t, t.return), rn(t));
          break;
        case 22:
          ((a = t.stateNode),
            a._visibility & 2 && ((a._visibility &= -3), rn(t)));
          break;
        default:
          rn(t);
      }
      l = l.sibling;
    }
  }
  function fo(l, t) {
    for (; Cl !== null; ) {
      var a = Cl;
      switch (a.tag) {
        case 0:
        case 11:
        case 15:
          fa(8, a, t);
          break;
        case 23:
        case 22:
          if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
            var u = a.memoizedState.cachePool.pool;
            u != null && u.refCount++;
          }
          break;
        case 24:
          Ku(a.memoizedState.cache);
      }
      if (((u = a.child), u !== null)) ((u.return = a), (Cl = u));
      else
        l: for (a = l; Cl !== null; ) {
          u = Cl;
          var e = u.sibling,
            n = u.return;
          if ((Id(u), u === a)) {
            Cl = null;
            break l;
          }
          if (e !== null) {
            ((e.return = n), (Cl = e));
            break l;
          }
          Cl = n;
        }
    }
  }
  var cy = {
      getCacheForType: function (l) {
        var t = Bl(Tl),
          a = t.data.get(l);
        return (a === void 0 && ((a = l()), t.data.set(l, a)), a);
      },
      cacheSignal: function () {
        return Bl(Tl).controller.signal;
      },
    },
    iy = typeof WeakMap == "function" ? WeakMap : Map,
    ul = 0,
    yl = null,
    W = null,
    F = 0,
    nl = 0,
    it = null,
    sa = !1,
    Su = !1,
    Ai = !1,
    wt = 0,
    pl = 0,
    da = 0,
    Qa = 0,
    Oi = 0,
    ft = 0,
    bu = 0,
    se = null,
    Il = null,
    Mi = !1,
    gn = 0,
    so = 0,
    Sn = 1 / 0,
    bn = null,
    oa = null,
    Dl = 0,
    ma = null,
    pu = null,
    Wt = 0,
    Ni = 0,
    Di = null,
    oo = null,
    de = 0,
    Ui = null;
  function st() {
    return (ul & 2) !== 0 && F !== 0 ? F & -F : E.T !== null ? xi() : Of();
  }
  function mo() {
    if (ft === 0)
      if ((F & 536870912) === 0 || P) {
        var l = Oe;
        ((Oe <<= 1), (Oe & 3932160) === 0 && (Oe = 262144), (ft = l));
      } else ft = 536870912;
    return ((l = nt.current), l !== null && (l.flags |= 32), ft);
  }
  function Pl(l, t, a) {
    (((l === yl && (nl === 2 || nl === 9)) || l.cancelPendingCommit !== null) &&
      (Eu(l, 0), ya(l, F, ft, !1)),
      ju(l, a),
      ((ul & 2) === 0 || l !== yl) &&
        (l === yl &&
          ((ul & 2) === 0 && (Qa |= a), pl === 4 && ya(l, F, ft, !1)),
        Ut(l)));
  }
  function yo(l, t, a) {
    if ((ul & 6) !== 0) throw Error(s(327));
    var u = (!a && (t & 127) === 0 && (t & l.expiredLanes) === 0) || Uu(l, t),
      e = u ? dy(l, t) : Hi(l, t, !0),
      n = u;
    do {
      if (e === 0) {
        Su && !u && ya(l, t, 0, !1);
        break;
      } else {
        if (((a = l.current.alternate), n && !fy(a))) {
          ((e = Hi(l, t, !1)), (n = !1));
          continue;
        }
        if (e === 2) {
          if (((n = t), l.errorRecoveryDisabledLanes & n)) var c = 0;
          else
            ((c = l.pendingLanes & -536870913),
              (c = c !== 0 ? c : c & 536870912 ? 536870912 : 0));
          if (c !== 0) {
            t = c;
            l: {
              var i = l;
              e = se;
              var f = i.current.memoizedState.isDehydrated;
              if ((f && (Eu(i, c).flags |= 256), (c = Hi(i, c, !1)), c !== 2)) {
                if (Ai && !f) {
                  ((i.errorRecoveryDisabledLanes |= n), (Qa |= n), (e = 4));
                  break l;
                }
                ((n = Il),
                  (Il = e),
                  n !== null &&
                    (Il === null ? (Il = n) : Il.push.apply(Il, n)));
              }
              e = c;
            }
            if (((n = !1), e !== 2)) continue;
          }
        }
        if (e === 1) {
          (Eu(l, 0), ya(l, t, 0, !0));
          break;
        }
        l: {
          switch (((u = l), (n = e), n)) {
            case 0:
            case 1:
              throw Error(s(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              ya(u, t, ft, !sa);
              break l;
            case 2:
              Il = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(s(329));
          }
          if ((t & 62914560) === t && ((e = gn + 300 - lt()), 10 < e)) {
            if ((ya(u, t, ft, !sa), Ne(u, 0, !0) !== 0)) break l;
            ((Wt = t),
              (u.timeoutHandle = Lo(
                vo.bind(
                  null,
                  u,
                  a,
                  Il,
                  bn,
                  Mi,
                  t,
                  ft,
                  Qa,
                  bu,
                  sa,
                  n,
                  "Throttled",
                  -0,
                  0,
                ),
                e,
              )));
            break l;
          }
          vo(u, a, Il, bn, Mi, t, ft, Qa, bu, sa, n, null, -0, 0);
        }
      }
      break;
    } while (!0);
    Ut(l);
  }
  function vo(l, t, a, u, e, n, c, i, f, v, p, z, r, S) {
    if (
      ((l.timeoutHandle = -1),
      (z = t.subtreeFlags),
      z & 8192 || (z & 16785408) === 16785408)
    ) {
      ((z = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Rt,
      }),
        no(t, n, z));
      var j =
        (n & 62914560) === n ? gn - lt() : (n & 4194048) === n ? so - lt() : 0;
      if (((j = Jy(z, j)), j !== null)) {
        ((Wt = n),
          (l.cancelPendingCommit = j(
            _o.bind(null, l, t, n, a, u, e, c, i, f, p, z, null, r, S),
          )),
          ya(l, n, c, !v));
        return;
      }
    }
    _o(l, t, n, a, u, e, c, i, f);
  }
  function fy(l) {
    for (var t = l; ; ) {
      var a = t.tag;
      if (
        (a === 0 || a === 11 || a === 15) &&
        t.flags & 16384 &&
        ((a = t.updateQueue), a !== null && ((a = a.stores), a !== null))
      )
        for (var u = 0; u < a.length; u++) {
          var e = a[u],
            n = e.getSnapshot;
          e = e.value;
          try {
            if (!ut(n(), e)) return !1;
          } catch {
            return !1;
          }
        }
      if (((a = t.child), t.subtreeFlags & 16384 && a !== null))
        ((a.return = t), (t = a));
      else {
        if (t === l) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l) return !0;
          t = t.return;
        }
        ((t.sibling.return = t.return), (t = t.sibling));
      }
    }
    return !0;
  }
  function ya(l, t, a, u) {
    ((t &= ~Oi),
      (t &= ~Qa),
      (l.suspendedLanes |= t),
      (l.pingedLanes &= ~t),
      u && (l.warmLanes |= t),
      (u = l.expirationTimes));
    for (var e = t; 0 < e; ) {
      var n = 31 - at(e),
        c = 1 << n;
      ((u[n] = -1), (e &= ~c));
    }
    a !== 0 && zf(l, a, t);
  }
  function pn() {
    return (ul & 6) === 0 ? (oe(0), !1) : !0;
  }
  function ji() {
    if (W !== null) {
      if (nl === 0) var l = W.return;
      else ((l = W), (Bt = Ha = null), wc(l), (ou = null), (wu = 0), (l = W));
      for (; l !== null; ) (Ld(l.alternate, l), (l = l.return));
      W = null;
    }
  }
  function Eu(l, t) {
    var a = l.timeoutHandle;
    (a !== -1 && ((l.timeoutHandle = -1), Ny(a)),
      (a = l.cancelPendingCommit),
      a !== null && ((l.cancelPendingCommit = null), a()),
      (Wt = 0),
      ji(),
      (yl = l),
      (W = a = qt(l.current, null)),
      (F = t),
      (nl = 0),
      (it = null),
      (sa = !1),
      (Su = Uu(l, t)),
      (Ai = !1),
      (bu = ft = Oi = Qa = da = pl = 0),
      (Il = se = null),
      (Mi = !1),
      (t & 8) !== 0 && (t |= t & 32));
    var u = l.entangledLanes;
    if (u !== 0)
      for (l = l.entanglements, u &= t; 0 < u; ) {
        var e = 31 - at(u),
          n = 1 << e;
        ((t |= l[e]), (u &= ~n));
      }
    return ((wt = t), Xe(), a);
  }
  function ho(l, t) {
    ((V = null),
      (E.H = te),
      t === du || t === We
        ? ((t = Us()), (nl = 3))
        : t === qc
          ? ((t = Us()), (nl = 4))
          : (nl =
              t === si
                ? 8
                : t !== null &&
                    typeof t == "object" &&
                    typeof t.then == "function"
                  ? 6
                  : 1),
      (it = t),
      W === null && ((pl = 1), sn(l, yt(t, l.current))));
  }
  function ro() {
    var l = nt.current;
    return l === null
      ? !0
      : (F & 4194048) === F
        ? gt === null
        : (F & 62914560) === F || (F & 536870912) !== 0
          ? l === gt
          : !1;
  }
  function go() {
    var l = E.H;
    return ((E.H = te), l === null ? te : l);
  }
  function So() {
    var l = E.A;
    return ((E.A = cy), l);
  }
  function En() {
    ((pl = 4),
      sa || ((F & 4194048) !== F && nt.current !== null) || (Su = !0),
      ((da & 134217727) === 0 && (Qa & 134217727) === 0) ||
        yl === null ||
        ya(yl, F, ft, !1));
  }
  function Hi(l, t, a) {
    var u = ul;
    ul |= 2;
    var e = go(),
      n = So();
    ((yl !== l || F !== t) && ((bn = null), Eu(l, t)), (t = !1));
    var c = pl;
    l: do
      try {
        if (nl !== 0 && W !== null) {
          var i = W,
            f = it;
          switch (nl) {
            case 8:
              (ji(), (c = 6));
              break l;
            case 3:
            case 2:
            case 9:
            case 6:
              nt.current === null && (t = !0);
              var v = nl;
              if (((nl = 0), (it = null), _u(l, i, f, v), a && Su)) {
                c = 0;
                break l;
              }
              break;
            default:
              ((v = nl), (nl = 0), (it = null), _u(l, i, f, v));
          }
        }
        (sy(), (c = pl));
        break;
      } catch (p) {
        ho(l, p);
      }
    while (!0);
    return (
      t && l.shellSuspendCounter++,
      (Bt = Ha = null),
      (ul = u),
      (E.H = e),
      (E.A = n),
      W === null && ((yl = null), (F = 0), Xe()),
      c
    );
  }
  function sy() {
    for (; W !== null; ) bo(W);
  }
  function dy(l, t) {
    var a = ul;
    ul |= 2;
    var u = go(),
      e = So();
    yl !== l || F !== t
      ? ((bn = null), (Sn = lt() + 500), Eu(l, t))
      : (Su = Uu(l, t));
    l: do
      try {
        if (nl !== 0 && W !== null) {
          t = W;
          var n = it;
          t: switch (nl) {
            case 1:
              ((nl = 0), (it = null), _u(l, t, n, 1));
              break;
            case 2:
            case 9:
              if (Ns(n)) {
                ((nl = 0), (it = null), po(t));
                break;
              }
              ((t = function () {
                ((nl !== 2 && nl !== 9) || yl !== l || (nl = 7), Ut(l));
              }),
                n.then(t, t));
              break l;
            case 3:
              nl = 7;
              break l;
            case 4:
              nl = 5;
              break l;
            case 7:
              Ns(n)
                ? ((nl = 0), (it = null), po(t))
                : ((nl = 0), (it = null), _u(l, t, n, 7));
              break;
            case 5:
              var c = null;
              switch (W.tag) {
                case 26:
                  c = W.memoizedState;
                case 5:
                case 27:
                  var i = W;
                  if (c ? nm(c) : i.stateNode.complete) {
                    ((nl = 0), (it = null));
                    var f = i.sibling;
                    if (f !== null) W = f;
                    else {
                      var v = i.return;
                      v !== null ? ((W = v), _n(v)) : (W = null);
                    }
                    break t;
                  }
              }
              ((nl = 0), (it = null), _u(l, t, n, 5));
              break;
            case 6:
              ((nl = 0), (it = null), _u(l, t, n, 6));
              break;
            case 8:
              (ji(), (pl = 6));
              break l;
            default:
              throw Error(s(462));
          }
        }
        oy();
        break;
      } catch (p) {
        ho(l, p);
      }
    while (!0);
    return (
      (Bt = Ha = null),
      (E.H = u),
      (E.A = e),
      (ul = a),
      W !== null ? 0 : ((yl = null), (F = 0), Xe(), pl)
    );
  }
  function oy() {
    for (; W !== null && !Cm(); ) bo(W);
  }
  function bo(l) {
    var t = Zd(l.alternate, l, wt);
    ((l.memoizedProps = l.pendingProps), t === null ? _n(l) : (W = t));
  }
  function po(l) {
    var t = l,
      a = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = xd(a, t, t.pendingProps, t.type, void 0, F);
        break;
      case 11:
        t = xd(a, t, t.pendingProps, t.type.render, t.ref, F);
        break;
      case 5:
        wc(t);
      default:
        (Ld(a, t), (t = W = gs(t, wt)), (t = Zd(a, t, wt)));
    }
    ((l.memoizedProps = l.pendingProps), t === null ? _n(l) : (W = t));
  }
  function _u(l, t, a, u) {
    ((Bt = Ha = null), wc(t), (ou = null), (wu = 0));
    var e = t.return;
    try {
      if (P0(l, e, t, a, F)) {
        ((pl = 1), sn(l, yt(a, l.current)), (W = null));
        return;
      }
    } catch (n) {
      if (e !== null) throw ((W = e), n);
      ((pl = 1), sn(l, yt(a, l.current)), (W = null));
      return;
    }
    t.flags & 32768
      ? (P || u === 1
          ? (l = !0)
          : Su || (F & 536870912) !== 0
            ? (l = !1)
            : ((sa = l = !0),
              (u === 2 || u === 9 || u === 3 || u === 6) &&
                ((u = nt.current),
                u !== null && u.tag === 13 && (u.flags |= 16384))),
        Eo(t, l))
      : _n(t);
  }
  function _n(l) {
    var t = l;
    do {
      if ((t.flags & 32768) !== 0) {
        Eo(t, sa);
        return;
      }
      l = t.return;
      var a = ay(t.alternate, t, wt);
      if (a !== null) {
        W = a;
        return;
      }
      if (((t = t.sibling), t !== null)) {
        W = t;
        return;
      }
      W = t = l;
    } while (t !== null);
    pl === 0 && (pl = 5);
  }
  function Eo(l, t) {
    do {
      var a = uy(l.alternate, l);
      if (a !== null) {
        ((a.flags &= 32767), (W = a));
        return;
      }
      if (
        ((a = l.return),
        a !== null &&
          ((a.flags |= 32768), (a.subtreeFlags = 0), (a.deletions = null)),
        !t && ((l = l.sibling), l !== null))
      ) {
        W = l;
        return;
      }
      W = l = a;
    } while (l !== null);
    ((pl = 6), (W = null));
  }
  function _o(l, t, a, u, e, n, c, i, f) {
    l.cancelPendingCommit = null;
    do zn();
    while (Dl !== 0);
    if ((ul & 6) !== 0) throw Error(s(327));
    if (t !== null) {
      if (t === l.current) throw Error(s(177));
      if (
        ((n = t.lanes | t.childLanes),
        (n |= pc),
        Lm(l, a, n, c, i, f),
        l === yl && ((W = yl = null), (F = 0)),
        (pu = t),
        (ma = l),
        (Wt = a),
        (Ni = n),
        (Di = e),
        (oo = u),
        (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
          ? ((l.callbackNode = null),
            (l.callbackPriority = 0),
            hy(Te, function () {
              return (Mo(), null);
            }))
          : ((l.callbackNode = null), (l.callbackPriority = 0)),
        (u = (t.flags & 13878) !== 0),
        (t.subtreeFlags & 13878) !== 0 || u)
      ) {
        ((u = E.T), (E.T = null), (e = D.p), (D.p = 2), (c = ul), (ul |= 4));
        try {
          ey(l, t, a);
        } finally {
          ((ul = c), (D.p = e), (E.T = u));
        }
      }
      ((Dl = 1), zo(), To(), Ao());
    }
  }
  function zo() {
    if (Dl === 1) {
      Dl = 0;
      var l = ma,
        t = pu,
        a = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || a) {
        ((a = E.T), (E.T = null));
        var u = D.p;
        D.p = 2;
        var e = ul;
        ul |= 4;
        try {
          ao(t, l);
          var n = Li,
            c = fs(l.containerInfo),
            i = n.focusedElem,
            f = n.selectionRange;
          if (
            c !== i &&
            i &&
            i.ownerDocument &&
            is(i.ownerDocument.documentElement, i)
          ) {
            if (f !== null && hc(i)) {
              var v = f.start,
                p = f.end;
              if ((p === void 0 && (p = v), "selectionStart" in i))
                ((i.selectionStart = v),
                  (i.selectionEnd = Math.min(p, i.value.length)));
              else {
                var z = i.ownerDocument || document,
                  r = (z && z.defaultView) || window;
                if (r.getSelection) {
                  var S = r.getSelection(),
                    j = i.textContent.length,
                    G = Math.min(f.start, j),
                    dl = f.end === void 0 ? G : Math.min(f.end, j);
                  !S.extend && G > dl && ((c = dl), (dl = G), (G = c));
                  var m = cs(i, G),
                    d = cs(i, dl);
                  if (
                    m &&
                    d &&
                    (S.rangeCount !== 1 ||
                      S.anchorNode !== m.node ||
                      S.anchorOffset !== m.offset ||
                      S.focusNode !== d.node ||
                      S.focusOffset !== d.offset)
                  ) {
                    var y = z.createRange();
                    (y.setStart(m.node, m.offset),
                      S.removeAllRanges(),
                      G > dl
                        ? (S.addRange(y), S.extend(d.node, d.offset))
                        : (y.setEnd(d.node, d.offset), S.addRange(y)));
                  }
                }
              }
            }
            for (z = [], S = i; (S = S.parentNode); )
              S.nodeType === 1 &&
                z.push({ element: S, left: S.scrollLeft, top: S.scrollTop });
            for (
              typeof i.focus == "function" && i.focus(), i = 0;
              i < z.length;
              i++
            ) {
              var _ = z[i];
              ((_.element.scrollLeft = _.left), (_.element.scrollTop = _.top));
            }
          }
          ((qn = !!Vi), (Li = Vi = null));
        } finally {
          ((ul = e), (D.p = u), (E.T = a));
        }
      }
      ((l.current = t), (Dl = 2));
    }
  }
  function To() {
    if (Dl === 2) {
      Dl = 0;
      var l = ma,
        t = pu,
        a = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || a) {
        ((a = E.T), (E.T = null));
        var u = D.p;
        D.p = 2;
        var e = ul;
        ul |= 4;
        try {
          kd(l, t.alternate, t);
        } finally {
          ((ul = e), (D.p = u), (E.T = a));
        }
      }
      Dl = 3;
    }
  }
  function Ao() {
    if (Dl === 4 || Dl === 3) {
      ((Dl = 0), qm());
      var l = ma,
        t = pu,
        a = Wt,
        u = oo;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
        ? (Dl = 5)
        : ((Dl = 0), (pu = ma = null), Oo(l, l.pendingLanes));
      var e = l.pendingLanes;
      if (
        (e === 0 && (oa = null),
        Fn(a),
        (t = t.stateNode),
        tt && typeof tt.onCommitFiberRoot == "function")
      )
        try {
          tt.onCommitFiberRoot(Du, t, void 0, (t.current.flags & 128) === 128);
        } catch {}
      if (u !== null) {
        ((t = E.T), (e = D.p), (D.p = 2), (E.T = null));
        try {
          for (var n = l.onRecoverableError, c = 0; c < u.length; c++) {
            var i = u[c];
            n(i.value, { componentStack: i.stack });
          }
        } finally {
          ((E.T = t), (D.p = e));
        }
      }
      ((Wt & 3) !== 0 && zn(),
        Ut(l),
        (e = l.pendingLanes),
        (a & 261930) !== 0 && (e & 42) !== 0
          ? l === Ui
            ? de++
            : ((de = 0), (Ui = l))
          : (de = 0),
        oe(0));
    }
  }
  function Oo(l, t) {
    (l.pooledCacheLanes &= t) === 0 &&
      ((t = l.pooledCache), t != null && ((l.pooledCache = null), Ku(t)));
  }
  function zn() {
    return (zo(), To(), Ao(), Mo());
  }
  function Mo() {
    if (Dl !== 5) return !1;
    var l = ma,
      t = Ni;
    Ni = 0;
    var a = Fn(Wt),
      u = E.T,
      e = D.p;
    try {
      ((D.p = 32 > a ? 32 : a), (E.T = null), (a = Di), (Di = null));
      var n = ma,
        c = Wt;
      if (((Dl = 0), (pu = ma = null), (Wt = 0), (ul & 6) !== 0))
        throw Error(s(331));
      var i = ul;
      if (
        ((ul |= 4),
        io(n.current),
        eo(n, n.current, c, a),
        (ul = i),
        oe(0, !1),
        tt && typeof tt.onPostCommitFiberRoot == "function")
      )
        try {
          tt.onPostCommitFiberRoot(Du, n);
        } catch {}
      return !0;
    } finally {
      ((D.p = e), (E.T = u), Oo(l, t));
    }
  }
  function No(l, t, a) {
    ((t = yt(a, t)),
      (t = fi(l.stateNode, t, 2)),
      (l = na(l, t, 2)),
      l !== null && (ju(l, 2), Ut(l)));
  }
  function cl(l, t, a) {
    if (l.tag === 3) No(l, l, a);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          No(t, l, a);
          break;
        } else if (t.tag === 1) {
          var u = t.stateNode;
          if (
            typeof t.type.getDerivedStateFromError == "function" ||
            (typeof u.componentDidCatch == "function" &&
              (oa === null || !oa.has(u)))
          ) {
            ((l = yt(a, l)),
              (a = Nd(2)),
              (u = na(t, a, 2)),
              u !== null && (Dd(a, u, t, l), ju(u, 2), Ut(u)));
            break;
          }
        }
        t = t.return;
      }
  }
  function Ri(l, t, a) {
    var u = l.pingCache;
    if (u === null) {
      u = l.pingCache = new iy();
      var e = new Set();
      u.set(t, e);
    } else ((e = u.get(t)), e === void 0 && ((e = new Set()), u.set(t, e)));
    e.has(a) ||
      ((Ai = !0), e.add(a), (l = my.bind(null, l, t, a)), t.then(l, l));
  }
  function my(l, t, a) {
    var u = l.pingCache;
    (u !== null && u.delete(t),
      (l.pingedLanes |= l.suspendedLanes & a),
      (l.warmLanes &= ~a),
      yl === l &&
        (F & a) === a &&
        (pl === 4 || (pl === 3 && (F & 62914560) === F && 300 > lt() - gn)
          ? (ul & 2) === 0 && Eu(l, 0)
          : (Oi |= a),
        bu === F && (bu = 0)),
      Ut(l));
  }
  function Do(l, t) {
    (t === 0 && (t = _f()), (l = Da(l, t)), l !== null && (ju(l, t), Ut(l)));
  }
  function yy(l) {
    var t = l.memoizedState,
      a = 0;
    (t !== null && (a = t.retryLane), Do(l, a));
  }
  function vy(l, t) {
    var a = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var u = l.stateNode,
          e = l.memoizedState;
        e !== null && (a = e.retryLane);
        break;
      case 19:
        u = l.stateNode;
        break;
      case 22:
        u = l.stateNode._retryCache;
        break;
      default:
        throw Error(s(314));
    }
    (u !== null && u.delete(t), Do(l, a));
  }
  function hy(l, t) {
    return Jn(l, t);
  }
  var Tn = null,
    zu = null,
    Ci = !1,
    An = !1,
    qi = !1,
    va = 0;
  function Ut(l) {
    (l !== zu &&
      l.next === null &&
      (zu === null ? (Tn = zu = l) : (zu = zu.next = l)),
      (An = !0),
      Ci || ((Ci = !0), gy()));
  }
  function oe(l, t) {
    if (!qi && An) {
      qi = !0;
      do
        for (var a = !1, u = Tn; u !== null; ) {
          if (l !== 0) {
            var e = u.pendingLanes;
            if (e === 0) var n = 0;
            else {
              var c = u.suspendedLanes,
                i = u.pingedLanes;
              ((n = (1 << (31 - at(42 | l) + 1)) - 1),
                (n &= e & ~(c & ~i)),
                (n = n & 201326741 ? (n & 201326741) | 1 : n ? n | 2 : 0));
            }
            n !== 0 && ((a = !0), Ro(u, n));
          } else
            ((n = F),
              (n = Ne(
                u,
                u === yl ? n : 0,
                u.cancelPendingCommit !== null || u.timeoutHandle !== -1,
              )),
              (n & 3) === 0 || Uu(u, n) || ((a = !0), Ro(u, n)));
          u = u.next;
        }
      while (a);
      qi = !1;
    }
  }
  function ry() {
    Uo();
  }
  function Uo() {
    An = Ci = !1;
    var l = 0;
    va !== 0 && My() && (l = va);
    for (var t = lt(), a = null, u = Tn; u !== null; ) {
      var e = u.next,
        n = jo(u, t);
      (n === 0
        ? ((u.next = null),
          a === null ? (Tn = e) : (a.next = e),
          e === null && (zu = a))
        : ((a = u), (l !== 0 || (n & 3) !== 0) && (An = !0)),
        (u = e));
    }
    ((Dl !== 0 && Dl !== 5) || oe(l), va !== 0 && (va = 0));
  }
  function jo(l, t) {
    for (
      var a = l.suspendedLanes,
        u = l.pingedLanes,
        e = l.expirationTimes,
        n = l.pendingLanes & -62914561;
      0 < n;

    ) {
      var c = 31 - at(n),
        i = 1 << c,
        f = e[c];
      (f === -1
        ? ((i & a) === 0 || (i & u) !== 0) && (e[c] = Vm(i, t))
        : f <= t && (l.expiredLanes |= i),
        (n &= ~i));
    }
    if (
      ((t = yl),
      (a = F),
      (a = Ne(
        l,
        l === t ? a : 0,
        l.cancelPendingCommit !== null || l.timeoutHandle !== -1,
      )),
      (u = l.callbackNode),
      a === 0 ||
        (l === t && (nl === 2 || nl === 9)) ||
        l.cancelPendingCommit !== null)
    )
      return (
        u !== null && u !== null && wn(u),
        (l.callbackNode = null),
        (l.callbackPriority = 0)
      );
    if ((a & 3) === 0 || Uu(l, a)) {
      if (((t = a & -a), t === l.callbackPriority)) return t;
      switch ((u !== null && wn(u), Fn(a))) {
        case 2:
        case 8:
          a = pf;
          break;
        case 32:
          a = Te;
          break;
        case 268435456:
          a = Ef;
          break;
        default:
          a = Te;
      }
      return (
        (u = Ho.bind(null, l)),
        (a = Jn(a, u)),
        (l.callbackPriority = t),
        (l.callbackNode = a),
        t
      );
    }
    return (
      u !== null && u !== null && wn(u),
      (l.callbackPriority = 2),
      (l.callbackNode = null),
      2
    );
  }
  function Ho(l, t) {
    if (Dl !== 0 && Dl !== 5)
      return ((l.callbackNode = null), (l.callbackPriority = 0), null);
    var a = l.callbackNode;
    if (zn() && l.callbackNode !== a) return null;
    var u = F;
    return (
      (u = Ne(
        l,
        l === yl ? u : 0,
        l.cancelPendingCommit !== null || l.timeoutHandle !== -1,
      )),
      u === 0
        ? null
        : (yo(l, u, t),
          jo(l, lt()),
          l.callbackNode != null && l.callbackNode === a
            ? Ho.bind(null, l)
            : null)
    );
  }
  function Ro(l, t) {
    if (zn()) return null;
    yo(l, t, !0);
  }
  function gy() {
    Dy(function () {
      (ul & 6) !== 0 ? Jn(bf, ry) : Uo();
    });
  }
  function xi() {
    if (va === 0) {
      var l = fu;
      (l === 0 && ((l = Ae), (Ae <<= 1), (Ae & 261888) === 0 && (Ae = 256)),
        (va = l));
    }
    return va;
  }
  function Co(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean"
      ? null
      : typeof l == "function"
        ? l
        : He("" + l);
  }
  function qo(l, t) {
    var a = t.ownerDocument.createElement("input");
    return (
      (a.name = t.name),
      (a.value = t.value),
      l.id && a.setAttribute("form", l.id),
      t.parentNode.insertBefore(a, t),
      (l = new FormData(l)),
      a.parentNode.removeChild(a),
      l
    );
  }
  function Sy(l, t, a, u, e) {
    if (t === "submit" && a && a.stateNode === e) {
      var n = Co((e[wl] || null).action),
        c = u.submitter;
      c &&
        ((t = (t = c[wl] || null)
          ? Co(t.formAction)
          : c.getAttribute("formAction")),
        t !== null && ((n = t), (c = null)));
      var i = new xe("action", "action", null, u, e);
      l.push({
        event: i,
        listeners: [
          {
            instance: null,
            listener: function () {
              if (u.defaultPrevented) {
                if (va !== 0) {
                  var f = c ? qo(e, c) : new FormData(e);
                  ai(
                    a,
                    { pending: !0, data: f, method: e.method, action: n },
                    null,
                    f,
                  );
                }
              } else
                typeof n == "function" &&
                  (i.preventDefault(),
                  (f = c ? qo(e, c) : new FormData(e)),
                  ai(
                    a,
                    { pending: !0, data: f, method: e.method, action: n },
                    n,
                    f,
                  ));
            },
            currentTarget: e,
          },
        ],
      });
    }
  }
  for (var Bi = 0; Bi < bc.length; Bi++) {
    var Yi = bc[Bi],
      by = Yi.toLowerCase(),
      py = Yi[0].toUpperCase() + Yi.slice(1);
    Et(by, "on" + py);
  }
  (Et(os, "onAnimationEnd"),
    Et(ms, "onAnimationIteration"),
    Et(ys, "onAnimationStart"),
    Et("dblclick", "onDoubleClick"),
    Et("focusin", "onFocus"),
    Et("focusout", "onBlur"),
    Et(x0, "onTransitionRun"),
    Et(B0, "onTransitionStart"),
    Et(Y0, "onTransitionCancel"),
    Et(vs, "onTransitionEnd"),
    Wa("onMouseEnter", ["mouseout", "mouseover"]),
    Wa("onMouseLeave", ["mouseout", "mouseover"]),
    Wa("onPointerEnter", ["pointerout", "pointerover"]),
    Wa("onPointerLeave", ["pointerout", "pointerover"]),
    Aa(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " ",
      ),
    ),
    Aa(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " ",
      ),
    ),
    Aa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    Aa(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" "),
    ),
    Aa(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" "),
    ),
    Aa(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
    ));
  var me =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " ",
      ),
    Ey = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle"
        .split(" ")
        .concat(me),
    );
  function xo(l, t) {
    t = (t & 4) !== 0;
    for (var a = 0; a < l.length; a++) {
      var u = l[a],
        e = u.event;
      u = u.listeners;
      l: {
        var n = void 0;
        if (t)
          for (var c = u.length - 1; 0 <= c; c--) {
            var i = u[c],
              f = i.instance,
              v = i.currentTarget;
            if (((i = i.listener), f !== n && e.isPropagationStopped()))
              break l;
            ((n = i), (e.currentTarget = v));
            try {
              n(e);
            } catch (p) {
              Ge(p);
            }
            ((e.currentTarget = null), (n = f));
          }
        else
          for (c = 0; c < u.length; c++) {
            if (
              ((i = u[c]),
              (f = i.instance),
              (v = i.currentTarget),
              (i = i.listener),
              f !== n && e.isPropagationStopped())
            )
              break l;
            ((n = i), (e.currentTarget = v));
            try {
              n(e);
            } catch (p) {
              Ge(p);
            }
            ((e.currentTarget = null), (n = f));
          }
      }
    }
  }
  function $(l, t) {
    var a = t[kn];
    a === void 0 && (a = t[kn] = new Set());
    var u = l + "__bubble";
    a.has(u) || (Bo(t, l, 2, !1), a.add(u));
  }
  function Gi(l, t, a) {
    var u = 0;
    (t && (u |= 4), Bo(a, l, u, t));
  }
  var On = "_reactListening" + Math.random().toString(36).slice(2);
  function Xi(l) {
    if (!l[On]) {
      ((l[On] = !0),
        Df.forEach(function (a) {
          a !== "selectionchange" && (Ey.has(a) || Gi(a, !1, l), Gi(a, !0, l));
        }));
      var t = l.nodeType === 9 ? l : l.ownerDocument;
      t === null || t[On] || ((t[On] = !0), Gi("selectionchange", !1, t));
    }
  }
  function Bo(l, t, a, u) {
    switch (mm(t)) {
      case 2:
        var e = $y;
        break;
      case 8:
        e = Fy;
        break;
      default:
        e = tf;
    }
    ((a = e.bind(null, t, a, l)),
      (e = void 0),
      !cc ||
        (t !== "touchstart" && t !== "touchmove" && t !== "wheel") ||
        (e = !0),
      u
        ? e !== void 0
          ? l.addEventListener(t, a, { capture: !0, passive: e })
          : l.addEventListener(t, a, !0)
        : e !== void 0
          ? l.addEventListener(t, a, { passive: e })
          : l.addEventListener(t, a, !1));
  }
  function Qi(l, t, a, u, e) {
    var n = u;
    if ((t & 1) === 0 && (t & 2) === 0 && u !== null)
      l: for (;;) {
        if (u === null) return;
        var c = u.tag;
        if (c === 3 || c === 4) {
          var i = u.stateNode.containerInfo;
          if (i === e) break;
          if (c === 4)
            for (c = u.return; c !== null; ) {
              var f = c.tag;
              if ((f === 3 || f === 4) && c.stateNode.containerInfo === e)
                return;
              c = c.return;
            }
          for (; i !== null; ) {
            if (((c = Ka(i)), c === null)) return;
            if (((f = c.tag), f === 5 || f === 6 || f === 26 || f === 27)) {
              u = n = c;
              continue l;
            }
            i = i.parentNode;
          }
        }
        u = u.return;
      }
    Qf(function () {
      var v = n,
        p = ec(a),
        z = [];
      l: {
        var r = hs.get(l);
        if (r !== void 0) {
          var S = xe,
            j = l;
          switch (l) {
            case "keypress":
              if (Ce(a) === 0) break l;
            case "keydown":
            case "keyup":
              S = v0;
              break;
            case "focusin":
              ((j = "focus"), (S = dc));
              break;
            case "focusout":
              ((j = "blur"), (S = dc));
              break;
            case "beforeblur":
            case "afterblur":
              S = dc;
              break;
            case "click":
              if (a.button === 2) break l;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              S = Lf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              S = a0;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              S = g0;
              break;
            case os:
            case ms:
            case ys:
              S = n0;
              break;
            case vs:
              S = b0;
              break;
            case "scroll":
            case "scrollend":
              S = l0;
              break;
            case "wheel":
              S = E0;
              break;
            case "copy":
            case "cut":
            case "paste":
              S = i0;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              S = Jf;
              break;
            case "toggle":
            case "beforetoggle":
              S = z0;
          }
          var G = (t & 4) !== 0,
            dl = !G && (l === "scroll" || l === "scrollend"),
            m = G ? (r !== null ? r + "Capture" : null) : r;
          G = [];
          for (var d = v, y; d !== null; ) {
            var _ = d;
            if (
              ((y = _.stateNode),
              (_ = _.tag),
              (_ !== 5 && _ !== 26 && _ !== 27) ||
                y === null ||
                m === null ||
                ((_ = Cu(d, m)), _ != null && G.push(ye(d, _, y))),
              dl)
            )
              break;
            d = d.return;
          }
          0 < G.length &&
            ((r = new S(r, j, null, a, p)), z.push({ event: r, listeners: G }));
        }
      }
      if ((t & 7) === 0) {
        l: {
          if (
            ((r = l === "mouseover" || l === "pointerover"),
            (S = l === "mouseout" || l === "pointerout"),
            r &&
              a !== uc &&
              (j = a.relatedTarget || a.fromElement) &&
              (Ka(j) || j[La]))
          )
            break l;
          if (
            (S || r) &&
            ((r =
              p.window === p
                ? p
                : (r = p.ownerDocument)
                  ? r.defaultView || r.parentWindow
                  : window),
            S
              ? ((j = a.relatedTarget || a.toElement),
                (S = v),
                (j = j ? Ka(j) : null),
                j !== null &&
                  ((dl = L(j)),
                  (G = j.tag),
                  j !== dl || (G !== 5 && G !== 27 && G !== 6)) &&
                  (j = null))
              : ((S = null), (j = v)),
            S !== j)
          ) {
            if (
              ((G = Lf),
              (_ = "onMouseLeave"),
              (m = "onMouseEnter"),
              (d = "mouse"),
              (l === "pointerout" || l === "pointerover") &&
                ((G = Jf),
                (_ = "onPointerLeave"),
                (m = "onPointerEnter"),
                (d = "pointer")),
              (dl = S == null ? r : Ru(S)),
              (y = j == null ? r : Ru(j)),
              (r = new G(_, d + "leave", S, a, p)),
              (r.target = dl),
              (r.relatedTarget = y),
              (_ = null),
              Ka(p) === v &&
                ((G = new G(m, d + "enter", j, a, p)),
                (G.target = y),
                (G.relatedTarget = dl),
                (_ = G)),
              (dl = _),
              S && j)
            )
              t: {
                for (G = _y, m = S, d = j, y = 0, _ = m; _; _ = G(_)) y++;
                _ = 0;
                for (var x = d; x; x = G(x)) _++;
                for (; 0 < y - _; ) ((m = G(m)), y--);
                for (; 0 < _ - y; ) ((d = G(d)), _--);
                for (; y--; ) {
                  if (m === d || (d !== null && m === d.alternate)) {
                    G = m;
                    break t;
                  }
                  ((m = G(m)), (d = G(d)));
                }
                G = null;
              }
            else G = null;
            (S !== null && Yo(z, r, S, G, !1),
              j !== null && dl !== null && Yo(z, dl, j, G, !0));
          }
        }
        l: {
          if (
            ((r = v ? Ru(v) : window),
            (S = r.nodeName && r.nodeName.toLowerCase()),
            S === "select" || (S === "input" && r.type === "file"))
          )
            var tl = ls;
          else if (If(r))
            if (ts) tl = R0;
            else {
              tl = j0;
              var C = U0;
            }
          else
            ((S = r.nodeName),
              !S ||
              S.toLowerCase() !== "input" ||
              (r.type !== "checkbox" && r.type !== "radio")
                ? v && ac(v.elementType) && (tl = ls)
                : (tl = H0));
          if (tl && (tl = tl(l, v))) {
            Pf(z, tl, a, p);
            break l;
          }
          (C && C(l, r, v),
            l === "focusout" &&
              v &&
              r.type === "number" &&
              v.memoizedProps.value != null &&
              tc(r, "number", r.value));
        }
        switch (((C = v ? Ru(v) : window), l)) {
          case "focusin":
            (If(C) || C.contentEditable === "true") &&
              ((lu = C), (rc = v), (Zu = null));
            break;
          case "focusout":
            Zu = rc = lu = null;
            break;
          case "mousedown":
            gc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ((gc = !1), ss(z, a, p));
            break;
          case "selectionchange":
            if (q0) break;
          case "keydown":
          case "keyup":
            ss(z, a, p);
        }
        var K;
        if (mc)
          l: {
            switch (l) {
              case "compositionstart":
                var k = "onCompositionStart";
                break l;
              case "compositionend":
                k = "onCompositionEnd";
                break l;
              case "compositionupdate":
                k = "onCompositionUpdate";
                break l;
            }
            k = void 0;
          }
        else
          Pa
            ? Ff(l, a) && (k = "onCompositionEnd")
            : l === "keydown" &&
              a.keyCode === 229 &&
              (k = "onCompositionStart");
        (k &&
          (wf &&
            a.locale !== "ko" &&
            (Pa || k !== "onCompositionStart"
              ? k === "onCompositionEnd" && Pa && (K = Zf())
              : ((It = p),
                (ic = "value" in It ? It.value : It.textContent),
                (Pa = !0))),
          (C = Mn(v, k)),
          0 < C.length &&
            ((k = new Kf(k, l, null, a, p)),
            z.push({ event: k, listeners: C }),
            K ? (k.data = K) : ((K = kf(a)), K !== null && (k.data = K)))),
          (K = A0 ? O0(l, a) : M0(l, a)) &&
            ((k = Mn(v, "onBeforeInput")),
            0 < k.length &&
              ((C = new Kf("onBeforeInput", "beforeinput", null, a, p)),
              z.push({ event: C, listeners: k }),
              (C.data = K))),
          Sy(z, l, v, a, p));
      }
      xo(z, t);
    });
  }
  function ye(l, t, a) {
    return { instance: l, listener: t, currentTarget: a };
  }
  function Mn(l, t) {
    for (var a = t + "Capture", u = []; l !== null; ) {
      var e = l,
        n = e.stateNode;
      if (
        ((e = e.tag),
        (e !== 5 && e !== 26 && e !== 27) ||
          n === null ||
          ((e = Cu(l, a)),
          e != null && u.unshift(ye(l, e, n)),
          (e = Cu(l, t)),
          e != null && u.push(ye(l, e, n))),
        l.tag === 3)
      )
        return u;
      l = l.return;
    }
    return [];
  }
  function _y(l) {
    if (l === null) return null;
    do l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Yo(l, t, a, u, e) {
    for (var n = t._reactName, c = []; a !== null && a !== u; ) {
      var i = a,
        f = i.alternate,
        v = i.stateNode;
      if (((i = i.tag), f !== null && f === u)) break;
      ((i !== 5 && i !== 26 && i !== 27) ||
        v === null ||
        ((f = v),
        e
          ? ((v = Cu(a, n)), v != null && c.unshift(ye(a, v, f)))
          : e || ((v = Cu(a, n)), v != null && c.push(ye(a, v, f)))),
        (a = a.return));
    }
    c.length !== 0 && l.push({ event: t, listeners: c });
  }
  var zy = /\r\n?/g,
    Ty = /\u0000|\uFFFD/g;
  function Go(l) {
    return (typeof l == "string" ? l : "" + l)
      .replace(
        zy,
        `
`,
      )
      .replace(Ty, "");
  }
  function Xo(l, t) {
    return ((t = Go(t)), Go(l) === t);
  }
  function sl(l, t, a, u, e, n) {
    switch (a) {
      case "children":
        typeof u == "string"
          ? t === "body" || (t === "textarea" && u === "") || Fa(l, u)
          : (typeof u == "number" || typeof u == "bigint") &&
            t !== "body" &&
            Fa(l, "" + u);
        break;
      case "className":
        Ue(l, "class", u);
        break;
      case "tabIndex":
        Ue(l, "tabindex", u);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Ue(l, a, u);
        break;
      case "style":
        Gf(l, u, n);
        break;
      case "data":
        if (t !== "object") {
          Ue(l, "data", u);
          break;
        }
      case "src":
      case "href":
        if (u === "" && (t !== "a" || a !== "href")) {
          l.removeAttribute(a);
          break;
        }
        if (
          u == null ||
          typeof u == "function" ||
          typeof u == "symbol" ||
          typeof u == "boolean"
        ) {
          l.removeAttribute(a);
          break;
        }
        ((u = He("" + u)), l.setAttribute(a, u));
        break;
      case "action":
      case "formAction":
        if (typeof u == "function") {
          l.setAttribute(
            a,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')",
          );
          break;
        } else
          typeof n == "function" &&
            (a === "formAction"
              ? (t !== "input" && sl(l, t, "name", e.name, e, null),
                sl(l, t, "formEncType", e.formEncType, e, null),
                sl(l, t, "formMethod", e.formMethod, e, null),
                sl(l, t, "formTarget", e.formTarget, e, null))
              : (sl(l, t, "encType", e.encType, e, null),
                sl(l, t, "method", e.method, e, null),
                sl(l, t, "target", e.target, e, null)));
        if (u == null || typeof u == "symbol" || typeof u == "boolean") {
          l.removeAttribute(a);
          break;
        }
        ((u = He("" + u)), l.setAttribute(a, u));
        break;
      case "onClick":
        u != null && (l.onclick = Rt);
        break;
      case "onScroll":
        u != null && $("scroll", l);
        break;
      case "onScrollEnd":
        u != null && $("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (u != null) {
          if (typeof u != "object" || !("__html" in u)) throw Error(s(61));
          if (((a = u.__html), a != null)) {
            if (e.children != null) throw Error(s(60));
            l.innerHTML = a;
          }
        }
        break;
      case "multiple":
        l.multiple = u && typeof u != "function" && typeof u != "symbol";
        break;
      case "muted":
        l.muted = u && typeof u != "function" && typeof u != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (
          u == null ||
          typeof u == "function" ||
          typeof u == "boolean" ||
          typeof u == "symbol"
        ) {
          l.removeAttribute("xlink:href");
          break;
        }
        ((a = He("" + u)),
          l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a));
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        u != null && typeof u != "function" && typeof u != "symbol"
          ? l.setAttribute(a, "" + u)
          : l.removeAttribute(a);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        u && typeof u != "function" && typeof u != "symbol"
          ? l.setAttribute(a, "")
          : l.removeAttribute(a);
        break;
      case "capture":
      case "download":
        u === !0
          ? l.setAttribute(a, "")
          : u !== !1 &&
              u != null &&
              typeof u != "function" &&
              typeof u != "symbol"
            ? l.setAttribute(a, u)
            : l.removeAttribute(a);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        u != null &&
        typeof u != "function" &&
        typeof u != "symbol" &&
        !isNaN(u) &&
        1 <= u
          ? l.setAttribute(a, u)
          : l.removeAttribute(a);
        break;
      case "rowSpan":
      case "start":
        u == null || typeof u == "function" || typeof u == "symbol" || isNaN(u)
          ? l.removeAttribute(a)
          : l.setAttribute(a, u);
        break;
      case "popover":
        ($("beforetoggle", l), $("toggle", l), De(l, "popover", u));
        break;
      case "xlinkActuate":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:actuate", u);
        break;
      case "xlinkArcrole":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:arcrole", u);
        break;
      case "xlinkRole":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:role", u);
        break;
      case "xlinkShow":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:show", u);
        break;
      case "xlinkTitle":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:title", u);
        break;
      case "xlinkType":
        Ht(l, "http://www.w3.org/1999/xlink", "xlink:type", u);
        break;
      case "xmlBase":
        Ht(l, "http://www.w3.org/XML/1998/namespace", "xml:base", u);
        break;
      case "xmlLang":
        Ht(l, "http://www.w3.org/XML/1998/namespace", "xml:lang", u);
        break;
      case "xmlSpace":
        Ht(l, "http://www.w3.org/XML/1998/namespace", "xml:space", u);
        break;
      case "is":
        De(l, "is", u);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < a.length) ||
          (a[0] !== "o" && a[0] !== "O") ||
          (a[1] !== "n" && a[1] !== "N")) &&
          ((a = Im.get(a) || a), De(l, a, u));
    }
  }
  function Zi(l, t, a, u, e, n) {
    switch (a) {
      case "style":
        Gf(l, u, n);
        break;
      case "dangerouslySetInnerHTML":
        if (u != null) {
          if (typeof u != "object" || !("__html" in u)) throw Error(s(61));
          if (((a = u.__html), a != null)) {
            if (e.children != null) throw Error(s(60));
            l.innerHTML = a;
          }
        }
        break;
      case "children":
        typeof u == "string"
          ? Fa(l, u)
          : (typeof u == "number" || typeof u == "bigint") && Fa(l, "" + u);
        break;
      case "onScroll":
        u != null && $("scroll", l);
        break;
      case "onScrollEnd":
        u != null && $("scrollend", l);
        break;
      case "onClick":
        u != null && (l.onclick = Rt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Uf.hasOwnProperty(a))
          l: {
            if (
              a[0] === "o" &&
              a[1] === "n" &&
              ((e = a.endsWith("Capture")),
              (t = a.slice(2, e ? a.length - 7 : void 0)),
              (n = l[wl] || null),
              (n = n != null ? n[a] : null),
              typeof n == "function" && l.removeEventListener(t, n, e),
              typeof u == "function")
            ) {
              (typeof n != "function" &&
                n !== null &&
                (a in l
                  ? (l[a] = null)
                  : l.hasAttribute(a) && l.removeAttribute(a)),
                l.addEventListener(t, u, e));
              break l;
            }
            a in l
              ? (l[a] = u)
              : u === !0
                ? l.setAttribute(a, "")
                : De(l, a, u);
          }
    }
  }
  function Gl(l, t, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        ($("error", l), $("load", l));
        var u = !1,
          e = !1,
          n;
        for (n in a)
          if (a.hasOwnProperty(n)) {
            var c = a[n];
            if (c != null)
              switch (n) {
                case "src":
                  u = !0;
                  break;
                case "srcSet":
                  e = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(s(137, t));
                default:
                  sl(l, t, n, c, a, null);
              }
          }
        (e && sl(l, t, "srcSet", a.srcSet, a, null),
          u && sl(l, t, "src", a.src, a, null));
        return;
      case "input":
        $("invalid", l);
        var i = (n = c = e = null),
          f = null,
          v = null;
        for (u in a)
          if (a.hasOwnProperty(u)) {
            var p = a[u];
            if (p != null)
              switch (u) {
                case "name":
                  e = p;
                  break;
                case "type":
                  c = p;
                  break;
                case "checked":
                  f = p;
                  break;
                case "defaultChecked":
                  v = p;
                  break;
                case "value":
                  n = p;
                  break;
                case "defaultValue":
                  i = p;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (p != null) throw Error(s(137, t));
                  break;
                default:
                  sl(l, t, u, p, a, null);
              }
          }
        qf(l, n, i, f, v, c, e, !1);
        return;
      case "select":
        ($("invalid", l), (u = c = n = null));
        for (e in a)
          if (a.hasOwnProperty(e) && ((i = a[e]), i != null))
            switch (e) {
              case "value":
                n = i;
                break;
              case "defaultValue":
                c = i;
                break;
              case "multiple":
                u = i;
              default:
                sl(l, t, e, i, a, null);
            }
        ((t = n),
          (a = c),
          (l.multiple = !!u),
          t != null ? $a(l, !!u, t, !1) : a != null && $a(l, !!u, a, !0));
        return;
      case "textarea":
        ($("invalid", l), (n = e = u = null));
        for (c in a)
          if (a.hasOwnProperty(c) && ((i = a[c]), i != null))
            switch (c) {
              case "value":
                u = i;
                break;
              case "defaultValue":
                e = i;
                break;
              case "children":
                n = i;
                break;
              case "dangerouslySetInnerHTML":
                if (i != null) throw Error(s(91));
                break;
              default:
                sl(l, t, c, i, a, null);
            }
        Bf(l, u, e, n);
        return;
      case "option":
        for (f in a)
          a.hasOwnProperty(f) &&
            ((u = a[f]), u != null) &&
            (f === "selected"
              ? (l.selected =
                  u && typeof u != "function" && typeof u != "symbol")
              : sl(l, t, f, u, a, null));
        return;
      case "dialog":
        ($("beforetoggle", l), $("toggle", l), $("cancel", l), $("close", l));
        break;
      case "iframe":
      case "object":
        $("load", l);
        break;
      case "video":
      case "audio":
        for (u = 0; u < me.length; u++) $(me[u], l);
        break;
      case "image":
        ($("error", l), $("load", l));
        break;
      case "details":
        $("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        ($("error", l), $("load", l));
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (v in a)
          if (a.hasOwnProperty(v) && ((u = a[v]), u != null))
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(s(137, t));
              default:
                sl(l, t, v, u, a, null);
            }
        return;
      default:
        if (ac(t)) {
          for (p in a)
            a.hasOwnProperty(p) &&
              ((u = a[p]), u !== void 0 && Zi(l, t, p, u, a, void 0));
          return;
        }
    }
    for (i in a)
      a.hasOwnProperty(i) && ((u = a[i]), u != null && sl(l, t, i, u, a, null));
  }
  function Ay(l, t, a, u) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var e = null,
          n = null,
          c = null,
          i = null,
          f = null,
          v = null,
          p = null;
        for (S in a) {
          var z = a[S];
          if (a.hasOwnProperty(S) && z != null)
            switch (S) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                f = z;
              default:
                u.hasOwnProperty(S) || sl(l, t, S, null, u, z);
            }
        }
        for (var r in u) {
          var S = u[r];
          if (((z = a[r]), u.hasOwnProperty(r) && (S != null || z != null)))
            switch (r) {
              case "type":
                n = S;
                break;
              case "name":
                e = S;
                break;
              case "checked":
                v = S;
                break;
              case "defaultChecked":
                p = S;
                break;
              case "value":
                c = S;
                break;
              case "defaultValue":
                i = S;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (S != null) throw Error(s(137, t));
                break;
              default:
                S !== z && sl(l, t, r, S, u, z);
            }
        }
        lc(l, c, i, f, v, p, n, e);
        return;
      case "select":
        S = c = i = r = null;
        for (n in a)
          if (((f = a[n]), a.hasOwnProperty(n) && f != null))
            switch (n) {
              case "value":
                break;
              case "multiple":
                S = f;
              default:
                u.hasOwnProperty(n) || sl(l, t, n, null, u, f);
            }
        for (e in u)
          if (
            ((n = u[e]),
            (f = a[e]),
            u.hasOwnProperty(e) && (n != null || f != null))
          )
            switch (e) {
              case "value":
                r = n;
                break;
              case "defaultValue":
                i = n;
                break;
              case "multiple":
                c = n;
              default:
                n !== f && sl(l, t, e, n, u, f);
            }
        ((t = i),
          (a = c),
          (u = S),
          r != null
            ? $a(l, !!a, r, !1)
            : !!u != !!a &&
              (t != null ? $a(l, !!a, t, !0) : $a(l, !!a, a ? [] : "", !1)));
        return;
      case "textarea":
        S = r = null;
        for (i in a)
          if (
            ((e = a[i]),
            a.hasOwnProperty(i) && e != null && !u.hasOwnProperty(i))
          )
            switch (i) {
              case "value":
                break;
              case "children":
                break;
              default:
                sl(l, t, i, null, u, e);
            }
        for (c in u)
          if (
            ((e = u[c]),
            (n = a[c]),
            u.hasOwnProperty(c) && (e != null || n != null))
          )
            switch (c) {
              case "value":
                r = e;
                break;
              case "defaultValue":
                S = e;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (e != null) throw Error(s(91));
                break;
              default:
                e !== n && sl(l, t, c, e, u, n);
            }
        xf(l, r, S);
        return;
      case "option":
        for (var j in a)
          ((r = a[j]),
            a.hasOwnProperty(j) &&
              r != null &&
              !u.hasOwnProperty(j) &&
              (j === "selected" ? (l.selected = !1) : sl(l, t, j, null, u, r)));
        for (f in u)
          ((r = u[f]),
            (S = a[f]),
            u.hasOwnProperty(f) &&
              r !== S &&
              (r != null || S != null) &&
              (f === "selected"
                ? (l.selected =
                    r && typeof r != "function" && typeof r != "symbol")
                : sl(l, t, f, r, u, S)));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var G in a)
          ((r = a[G]),
            a.hasOwnProperty(G) &&
              r != null &&
              !u.hasOwnProperty(G) &&
              sl(l, t, G, null, u, r));
        for (v in u)
          if (
            ((r = u[v]),
            (S = a[v]),
            u.hasOwnProperty(v) && r !== S && (r != null || S != null))
          )
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (r != null) throw Error(s(137, t));
                break;
              default:
                sl(l, t, v, r, u, S);
            }
        return;
      default:
        if (ac(t)) {
          for (var dl in a)
            ((r = a[dl]),
              a.hasOwnProperty(dl) &&
                r !== void 0 &&
                !u.hasOwnProperty(dl) &&
                Zi(l, t, dl, void 0, u, r));
          for (p in u)
            ((r = u[p]),
              (S = a[p]),
              !u.hasOwnProperty(p) ||
                r === S ||
                (r === void 0 && S === void 0) ||
                Zi(l, t, p, r, u, S));
          return;
        }
    }
    for (var m in a)
      ((r = a[m]),
        a.hasOwnProperty(m) &&
          r != null &&
          !u.hasOwnProperty(m) &&
          sl(l, t, m, null, u, r));
    for (z in u)
      ((r = u[z]),
        (S = a[z]),
        !u.hasOwnProperty(z) ||
          r === S ||
          (r == null && S == null) ||
          sl(l, t, z, r, u, S));
  }
  function Qo(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Oy() {
    if (typeof performance.getEntriesByType == "function") {
      for (
        var l = 0, t = 0, a = performance.getEntriesByType("resource"), u = 0;
        u < a.length;
        u++
      ) {
        var e = a[u],
          n = e.transferSize,
          c = e.initiatorType,
          i = e.duration;
        if (n && i && Qo(c)) {
          for (c = 0, i = e.responseEnd, u += 1; u < a.length; u++) {
            var f = a[u],
              v = f.startTime;
            if (v > i) break;
            var p = f.transferSize,
              z = f.initiatorType;
            p &&
              Qo(z) &&
              ((f = f.responseEnd), (c += p * (f < i ? 1 : (i - v) / (f - v))));
          }
          if ((--u, (t += (8 * (n + c)) / (e.duration / 1e3)), l++, 10 < l))
            break;
        }
      }
      if (0 < l) return t / l / 1e6;
    }
    return navigator.connection &&
      ((l = navigator.connection.downlink), typeof l == "number")
      ? l
      : 5;
  }
  var Vi = null,
    Li = null;
  function Nn(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function Zo(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Vo(l, t) {
    if (l === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && t === "foreignObject" ? 0 : l;
  }
  function Ki(l, t) {
    return (
      l === "textarea" ||
      l === "noscript" ||
      typeof t.children == "string" ||
      typeof t.children == "number" ||
      typeof t.children == "bigint" ||
      (typeof t.dangerouslySetInnerHTML == "object" &&
        t.dangerouslySetInnerHTML !== null &&
        t.dangerouslySetInnerHTML.__html != null)
    );
  }
  var Ji = null;
  function My() {
    var l = window.event;
    return l && l.type === "popstate"
      ? l === Ji
        ? !1
        : ((Ji = l), !0)
      : ((Ji = null), !1);
  }
  var Lo = typeof setTimeout == "function" ? setTimeout : void 0,
    Ny = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Ko = typeof Promise == "function" ? Promise : void 0,
    Dy =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof Ko < "u"
          ? function (l) {
              return Ko.resolve(null).then(l).catch(Uy);
            }
          : Lo;
  function Uy(l) {
    setTimeout(function () {
      throw l;
    });
  }
  function ha(l) {
    return l === "head";
  }
  function Jo(l, t) {
    var a = t,
      u = 0;
    do {
      var e = a.nextSibling;
      if ((l.removeChild(a), e && e.nodeType === 8))
        if (((a = e.data), a === "/$" || a === "/&")) {
          if (u === 0) {
            (l.removeChild(e), Mu(t));
            return;
          }
          u--;
        } else if (
          a === "$" ||
          a === "$?" ||
          a === "$~" ||
          a === "$!" ||
          a === "&"
        )
          u++;
        else if (a === "html") ve(l.ownerDocument.documentElement);
        else if (a === "head") {
          ((a = l.ownerDocument.head), ve(a));
          for (var n = a.firstChild; n; ) {
            var c = n.nextSibling,
              i = n.nodeName;
            (n[Hu] ||
              i === "SCRIPT" ||
              i === "STYLE" ||
              (i === "LINK" && n.rel.toLowerCase() === "stylesheet") ||
              a.removeChild(n),
              (n = c));
          }
        } else a === "body" && ve(l.ownerDocument.body);
      a = e;
    } while (a);
    Mu(t);
  }
  function wo(l, t) {
    var a = l;
    l = 0;
    do {
      var u = a.nextSibling;
      if (
        (a.nodeType === 1
          ? t
            ? ((a._stashedDisplay = a.style.display),
              (a.style.display = "none"))
            : ((a.style.display = a._stashedDisplay || ""),
              a.getAttribute("style") === "" && a.removeAttribute("style"))
          : a.nodeType === 3 &&
            (t
              ? ((a._stashedText = a.nodeValue), (a.nodeValue = ""))
              : (a.nodeValue = a._stashedText || "")),
        u && u.nodeType === 8)
      )
        if (((a = u.data), a === "/$")) {
          if (l === 0) break;
          l--;
        } else (a !== "$" && a !== "$?" && a !== "$~" && a !== "$!") || l++;
      a = u;
    } while (a);
  }
  function wi(l) {
    var t = l.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var a = t;
      switch (((t = t.nextSibling), a.nodeName)) {
        case "HTML":
        case "HEAD":
        case "BODY":
          (wi(a), In(a));
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (a.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(a);
    }
  }
  function jy(l, t, a, u) {
    for (; l.nodeType === 1; ) {
      var e = a;
      if (l.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!u && (l.nodeName !== "INPUT" || l.type !== "hidden")) break;
      } else if (u) {
        if (!l[Hu])
          switch (t) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (
                ((n = l.getAttribute("rel")),
                n === "stylesheet" && l.hasAttribute("data-precedence"))
              )
                break;
              if (
                n !== e.rel ||
                l.getAttribute("href") !==
                  (e.href == null || e.href === "" ? null : e.href) ||
                l.getAttribute("crossorigin") !==
                  (e.crossOrigin == null ? null : e.crossOrigin) ||
                l.getAttribute("title") !== (e.title == null ? null : e.title)
              )
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (
                ((n = l.getAttribute("src")),
                (n !== (e.src == null ? null : e.src) ||
                  l.getAttribute("type") !== (e.type == null ? null : e.type) ||
                  l.getAttribute("crossorigin") !==
                    (e.crossOrigin == null ? null : e.crossOrigin)) &&
                  n &&
                  l.hasAttribute("async") &&
                  !l.hasAttribute("itemprop"))
              )
                break;
              return l;
            default:
              return l;
          }
      } else if (t === "input" && l.type === "hidden") {
        var n = e.name == null ? null : "" + e.name;
        if (e.type === "hidden" && l.getAttribute("name") === n) return l;
      } else return l;
      if (((l = St(l.nextSibling)), l === null)) break;
    }
    return null;
  }
  function Hy(l, t, a) {
    if (t === "") return null;
    for (; l.nodeType !== 3; )
      if (
        ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") &&
          !a) ||
        ((l = St(l.nextSibling)), l === null)
      )
        return null;
    return l;
  }
  function Wo(l, t) {
    for (; l.nodeType !== 8; )
      if (
        ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") &&
          !t) ||
        ((l = St(l.nextSibling)), l === null)
      )
        return null;
    return l;
  }
  function Wi(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function $i(l) {
    return (
      l.data === "$!" ||
      (l.data === "$?" && l.ownerDocument.readyState !== "loading")
    );
  }
  function Ry(l, t) {
    var a = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = t;
    else if (l.data !== "$?" || a.readyState !== "loading") t();
    else {
      var u = function () {
        (t(), a.removeEventListener("DOMContentLoaded", u));
      };
      (a.addEventListener("DOMContentLoaded", u), (l._reactRetry = u));
    }
  }
  function St(l) {
    for (; l != null; l = l.nextSibling) {
      var t = l.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (
          ((t = l.data),
          t === "$" ||
            t === "$!" ||
            t === "$?" ||
            t === "$~" ||
            t === "&" ||
            t === "F!" ||
            t === "F")
        )
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return l;
  }
  var Fi = null;
  function $o(l) {
    l = l.nextSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var a = l.data;
        if (a === "/$" || a === "/&") {
          if (t === 0) return St(l.nextSibling);
          t--;
        } else
          (a !== "$" && a !== "$!" && a !== "$?" && a !== "$~" && a !== "&") ||
            t++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function Fo(l) {
    l = l.previousSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var a = l.data;
        if (a === "$" || a === "$!" || a === "$?" || a === "$~" || a === "&") {
          if (t === 0) return l;
          t--;
        } else (a !== "/$" && a !== "/&") || t++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function ko(l, t, a) {
    switch (((t = Nn(a)), l)) {
      case "html":
        if (((l = t.documentElement), !l)) throw Error(s(452));
        return l;
      case "head":
        if (((l = t.head), !l)) throw Error(s(453));
        return l;
      case "body":
        if (((l = t.body), !l)) throw Error(s(454));
        return l;
      default:
        throw Error(s(451));
    }
  }
  function ve(l) {
    for (var t = l.attributes; t.length; ) l.removeAttributeNode(t[0]);
    In(l);
  }
  var bt = new Map(),
    Io = new Set();
  function Dn(l) {
    return typeof l.getRootNode == "function"
      ? l.getRootNode()
      : l.nodeType === 9
        ? l
        : l.ownerDocument;
  }
  var $t = D.d;
  D.d = { f: Cy, r: qy, D: xy, C: By, L: Yy, m: Gy, X: Qy, S: Xy, M: Zy };
  function Cy() {
    var l = $t.f(),
      t = pn();
    return l || t;
  }
  function qy(l) {
    var t = Ja(l);
    t !== null && t.tag === 5 && t.type === "form" ? vd(t) : $t.r(l);
  }
  var Tu = typeof document > "u" ? null : document;
  function Po(l, t, a) {
    var u = Tu;
    if (u && typeof t == "string" && t) {
      var e = ot(t);
      ((e = 'link[rel="' + l + '"][href="' + e + '"]'),
        typeof a == "string" && (e += '[crossorigin="' + a + '"]'),
        Io.has(e) ||
          (Io.add(e),
          (l = { rel: l, crossOrigin: a, href: t }),
          u.querySelector(e) === null &&
            ((t = u.createElement("link")),
            Gl(t, "link", l),
            Rl(t),
            u.head.appendChild(t))));
    }
  }
  function xy(l) {
    ($t.D(l), Po("dns-prefetch", l, null));
  }
  function By(l, t) {
    ($t.C(l, t), Po("preconnect", l, t));
  }
  function Yy(l, t, a) {
    $t.L(l, t, a);
    var u = Tu;
    if (u && l && t) {
      var e = 'link[rel="preload"][as="' + ot(t) + '"]';
      t === "image" && a && a.imageSrcSet
        ? ((e += '[imagesrcset="' + ot(a.imageSrcSet) + '"]'),
          typeof a.imageSizes == "string" &&
            (e += '[imagesizes="' + ot(a.imageSizes) + '"]'))
        : (e += '[href="' + ot(l) + '"]');
      var n = e;
      switch (t) {
        case "style":
          n = Au(l);
          break;
        case "script":
          n = Ou(l);
      }
      bt.has(n) ||
        ((l = N(
          {
            rel: "preload",
            href: t === "image" && a && a.imageSrcSet ? void 0 : l,
            as: t,
          },
          a,
        )),
        bt.set(n, l),
        u.querySelector(e) !== null ||
          (t === "style" && u.querySelector(he(n))) ||
          (t === "script" && u.querySelector(re(n))) ||
          ((t = u.createElement("link")),
          Gl(t, "link", l),
          Rl(t),
          u.head.appendChild(t)));
    }
  }
  function Gy(l, t) {
    $t.m(l, t);
    var a = Tu;
    if (a && l) {
      var u = t && typeof t.as == "string" ? t.as : "script",
        e =
          'link[rel="modulepreload"][as="' + ot(u) + '"][href="' + ot(l) + '"]',
        n = e;
      switch (u) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          n = Ou(l);
      }
      if (
        !bt.has(n) &&
        ((l = N({ rel: "modulepreload", href: l }, t)),
        bt.set(n, l),
        a.querySelector(e) === null)
      ) {
        switch (u) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (a.querySelector(re(n))) return;
        }
        ((u = a.createElement("link")),
          Gl(u, "link", l),
          Rl(u),
          a.head.appendChild(u));
      }
    }
  }
  function Xy(l, t, a) {
    $t.S(l, t, a);
    var u = Tu;
    if (u && l) {
      var e = wa(u).hoistableStyles,
        n = Au(l);
      t = t || "default";
      var c = e.get(n);
      if (!c) {
        var i = { loading: 0, preload: null };
        if ((c = u.querySelector(he(n)))) i.loading = 5;
        else {
          ((l = N({ rel: "stylesheet", href: l, "data-precedence": t }, a)),
            (a = bt.get(n)) && ki(l, a));
          var f = (c = u.createElement("link"));
          (Rl(f),
            Gl(f, "link", l),
            (f._p = new Promise(function (v, p) {
              ((f.onload = v), (f.onerror = p));
            })),
            f.addEventListener("load", function () {
              i.loading |= 1;
            }),
            f.addEventListener("error", function () {
              i.loading |= 2;
            }),
            (i.loading |= 4),
            Un(c, t, u));
        }
        ((c = { type: "stylesheet", instance: c, count: 1, state: i }),
          e.set(n, c));
      }
    }
  }
  function Qy(l, t) {
    $t.X(l, t);
    var a = Tu;
    if (a && l) {
      var u = wa(a).hoistableScripts,
        e = Ou(l),
        n = u.get(e);
      n ||
        ((n = a.querySelector(re(e))),
        n ||
          ((l = N({ src: l, async: !0 }, t)),
          (t = bt.get(e)) && Ii(l, t),
          (n = a.createElement("script")),
          Rl(n),
          Gl(n, "link", l),
          a.head.appendChild(n)),
        (n = { type: "script", instance: n, count: 1, state: null }),
        u.set(e, n));
    }
  }
  function Zy(l, t) {
    $t.M(l, t);
    var a = Tu;
    if (a && l) {
      var u = wa(a).hoistableScripts,
        e = Ou(l),
        n = u.get(e);
      n ||
        ((n = a.querySelector(re(e))),
        n ||
          ((l = N({ src: l, async: !0, type: "module" }, t)),
          (t = bt.get(e)) && Ii(l, t),
          (n = a.createElement("script")),
          Rl(n),
          Gl(n, "link", l),
          a.head.appendChild(n)),
        (n = { type: "script", instance: n, count: 1, state: null }),
        u.set(e, n));
    }
  }
  function lm(l, t, a, u) {
    var e = (e = w.current) ? Dn(e) : null;
    if (!e) throw Error(s(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof a.precedence == "string" && typeof a.href == "string"
          ? ((t = Au(a.href)),
            (a = wa(e).hoistableStyles),
            (u = a.get(t)),
            u ||
              ((u = { type: "style", instance: null, count: 0, state: null }),
              a.set(t, u)),
            u)
          : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (
          a.rel === "stylesheet" &&
          typeof a.href == "string" &&
          typeof a.precedence == "string"
        ) {
          l = Au(a.href);
          var n = wa(e).hoistableStyles,
            c = n.get(l);
          if (
            (c ||
              ((e = e.ownerDocument || e),
              (c = {
                type: "stylesheet",
                instance: null,
                count: 0,
                state: { loading: 0, preload: null },
              }),
              n.set(l, c),
              (n = e.querySelector(he(l))) &&
                !n._p &&
                ((c.instance = n), (c.state.loading = 5)),
              bt.has(l) ||
                ((a = {
                  rel: "preload",
                  as: "style",
                  href: a.href,
                  crossOrigin: a.crossOrigin,
                  integrity: a.integrity,
                  media: a.media,
                  hrefLang: a.hrefLang,
                  referrerPolicy: a.referrerPolicy,
                }),
                bt.set(l, a),
                n || Vy(e, l, a, c.state))),
            t && u === null)
          )
            throw Error(s(528, ""));
          return c;
        }
        if (t && u !== null) throw Error(s(529, ""));
        return null;
      case "script":
        return (
          (t = a.async),
          (a = a.src),
          typeof a == "string" &&
          t &&
          typeof t != "function" &&
          typeof t != "symbol"
            ? ((t = Ou(a)),
              (a = wa(e).hoistableScripts),
              (u = a.get(t)),
              u ||
                ((u = {
                  type: "script",
                  instance: null,
                  count: 0,
                  state: null,
                }),
                a.set(t, u)),
              u)
            : { type: "void", instance: null, count: 0, state: null }
        );
      default:
        throw Error(s(444, l));
    }
  }
  function Au(l) {
    return 'href="' + ot(l) + '"';
  }
  function he(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function tm(l) {
    return N({}, l, { "data-precedence": l.precedence, precedence: null });
  }
  function Vy(l, t, a, u) {
    l.querySelector('link[rel="preload"][as="style"][' + t + "]")
      ? (u.loading = 1)
      : ((t = l.createElement("link")),
        (u.preload = t),
        t.addEventListener("load", function () {
          return (u.loading |= 1);
        }),
        t.addEventListener("error", function () {
          return (u.loading |= 2);
        }),
        Gl(t, "link", a),
        Rl(t),
        l.head.appendChild(t));
  }
  function Ou(l) {
    return '[src="' + ot(l) + '"]';
  }
  function re(l) {
    return "script[async]" + l;
  }
  function am(l, t, a) {
    if ((t.count++, t.instance === null))
      switch (t.type) {
        case "style":
          var u = l.querySelector('style[data-href~="' + ot(a.href) + '"]');
          if (u) return ((t.instance = u), Rl(u), u);
          var e = N({}, a, {
            "data-href": a.href,
            "data-precedence": a.precedence,
            href: null,
            precedence: null,
          });
          return (
            (u = (l.ownerDocument || l).createElement("style")),
            Rl(u),
            Gl(u, "style", e),
            Un(u, a.precedence, l),
            (t.instance = u)
          );
        case "stylesheet":
          e = Au(a.href);
          var n = l.querySelector(he(e));
          if (n) return ((t.state.loading |= 4), (t.instance = n), Rl(n), n);
          ((u = tm(a)),
            (e = bt.get(e)) && ki(u, e),
            (n = (l.ownerDocument || l).createElement("link")),
            Rl(n));
          var c = n;
          return (
            (c._p = new Promise(function (i, f) {
              ((c.onload = i), (c.onerror = f));
            })),
            Gl(n, "link", u),
            (t.state.loading |= 4),
            Un(n, a.precedence, l),
            (t.instance = n)
          );
        case "script":
          return (
            (n = Ou(a.src)),
            (e = l.querySelector(re(n)))
              ? ((t.instance = e), Rl(e), e)
              : ((u = a),
                (e = bt.get(n)) && ((u = N({}, a)), Ii(u, e)),
                (l = l.ownerDocument || l),
                (e = l.createElement("script")),
                Rl(e),
                Gl(e, "link", u),
                l.head.appendChild(e),
                (t.instance = e))
          );
        case "void":
          return null;
        default:
          throw Error(s(443, t.type));
      }
    else
      t.type === "stylesheet" &&
        (t.state.loading & 4) === 0 &&
        ((u = t.instance), (t.state.loading |= 4), Un(u, a.precedence, l));
    return t.instance;
  }
  function Un(l, t, a) {
    for (
      var u = a.querySelectorAll(
          'link[rel="stylesheet"][data-precedence],style[data-precedence]',
        ),
        e = u.length ? u[u.length - 1] : null,
        n = e,
        c = 0;
      c < u.length;
      c++
    ) {
      var i = u[c];
      if (i.dataset.precedence === t) n = i;
      else if (n !== e) break;
    }
    n
      ? n.parentNode.insertBefore(l, n.nextSibling)
      : ((t = a.nodeType === 9 ? a.head : a), t.insertBefore(l, t.firstChild));
  }
  function ki(l, t) {
    (l.crossOrigin == null && (l.crossOrigin = t.crossOrigin),
      l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy),
      l.title == null && (l.title = t.title));
  }
  function Ii(l, t) {
    (l.crossOrigin == null && (l.crossOrigin = t.crossOrigin),
      l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy),
      l.integrity == null && (l.integrity = t.integrity));
  }
  var jn = null;
  function um(l, t, a) {
    if (jn === null) {
      var u = new Map(),
        e = (jn = new Map());
      e.set(a, u);
    } else ((e = jn), (u = e.get(a)), u || ((u = new Map()), e.set(a, u)));
    if (u.has(l)) return u;
    for (
      u.set(l, null), a = a.getElementsByTagName(l), e = 0;
      e < a.length;
      e++
    ) {
      var n = a[e];
      if (
        !(
          n[Hu] ||
          n[ql] ||
          (l === "link" && n.getAttribute("rel") === "stylesheet")
        ) &&
        n.namespaceURI !== "http://www.w3.org/2000/svg"
      ) {
        var c = n.getAttribute(t) || "";
        c = l + c;
        var i = u.get(c);
        i ? i.push(n) : u.set(c, [n]);
      }
    }
    return u;
  }
  function em(l, t, a) {
    ((l = l.ownerDocument || l),
      l.head.insertBefore(
        a,
        t === "title" ? l.querySelector("head > title") : null,
      ));
  }
  function Ly(l, t, a) {
    if (a === 1 || t.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (
          typeof t.precedence != "string" ||
          typeof t.href != "string" ||
          t.href === ""
        )
          break;
        return !0;
      case "link":
        if (
          typeof t.rel != "string" ||
          typeof t.href != "string" ||
          t.href === "" ||
          t.onLoad ||
          t.onError
        )
          break;
        return t.rel === "stylesheet"
          ? ((l = t.disabled), typeof t.precedence == "string" && l == null)
          : !0;
      case "script":
        if (
          t.async &&
          typeof t.async != "function" &&
          typeof t.async != "symbol" &&
          !t.onLoad &&
          !t.onError &&
          t.src &&
          typeof t.src == "string"
        )
          return !0;
    }
    return !1;
  }
  function nm(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function Ky(l, t, a, u) {
    if (
      a.type === "stylesheet" &&
      (typeof u.media != "string" || matchMedia(u.media).matches !== !1) &&
      (a.state.loading & 4) === 0
    ) {
      if (a.instance === null) {
        var e = Au(u.href),
          n = t.querySelector(he(e));
        if (n) {
          ((t = n._p),
            t !== null &&
              typeof t == "object" &&
              typeof t.then == "function" &&
              (l.count++, (l = Hn.bind(l)), t.then(l, l)),
            (a.state.loading |= 4),
            (a.instance = n),
            Rl(n));
          return;
        }
        ((n = t.ownerDocument || t),
          (u = tm(u)),
          (e = bt.get(e)) && ki(u, e),
          (n = n.createElement("link")),
          Rl(n));
        var c = n;
        ((c._p = new Promise(function (i, f) {
          ((c.onload = i), (c.onerror = f));
        })),
          Gl(n, "link", u),
          (a.instance = n));
      }
      (l.stylesheets === null && (l.stylesheets = new Map()),
        l.stylesheets.set(a, t),
        (t = a.state.preload) &&
          (a.state.loading & 3) === 0 &&
          (l.count++,
          (a = Hn.bind(l)),
          t.addEventListener("load", a),
          t.addEventListener("error", a)));
    }
  }
  var Pi = 0;
  function Jy(l, t) {
    return (
      l.stylesheets && l.count === 0 && Cn(l, l.stylesheets),
      0 < l.count || 0 < l.imgCount
        ? function (a) {
            var u = setTimeout(function () {
              if ((l.stylesheets && Cn(l, l.stylesheets), l.unsuspend)) {
                var n = l.unsuspend;
                ((l.unsuspend = null), n());
              }
            }, 6e4 + t);
            0 < l.imgBytes && Pi === 0 && (Pi = 62500 * Oy());
            var e = setTimeout(
              function () {
                if (
                  ((l.waitingForImages = !1),
                  l.count === 0 &&
                    (l.stylesheets && Cn(l, l.stylesheets), l.unsuspend))
                ) {
                  var n = l.unsuspend;
                  ((l.unsuspend = null), n());
                }
              },
              (l.imgBytes > Pi ? 50 : 800) + t,
            );
            return (
              (l.unsuspend = a),
              function () {
                ((l.unsuspend = null), clearTimeout(u), clearTimeout(e));
              }
            );
          }
        : null
    );
  }
  function Hn() {
    if (
      (this.count--,
      this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))
    ) {
      if (this.stylesheets) Cn(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        ((this.unsuspend = null), l());
      }
    }
  }
  var Rn = null;
  function Cn(l, t) {
    ((l.stylesheets = null),
      l.unsuspend !== null &&
        (l.count++,
        (Rn = new Map()),
        t.forEach(wy, l),
        (Rn = null),
        Hn.call(l)));
  }
  function wy(l, t) {
    if (!(t.state.loading & 4)) {
      var a = Rn.get(l);
      if (a) var u = a.get(null);
      else {
        ((a = new Map()), Rn.set(l, a));
        for (
          var e = l.querySelectorAll(
              "link[data-precedence],style[data-precedence]",
            ),
            n = 0;
          n < e.length;
          n++
        ) {
          var c = e[n];
          (c.nodeName === "LINK" || c.getAttribute("media") !== "not all") &&
            (a.set(c.dataset.precedence, c), (u = c));
        }
        u && a.set(null, u);
      }
      ((e = t.instance),
        (c = e.getAttribute("data-precedence")),
        (n = a.get(c) || u),
        n === u && a.set(null, e),
        a.set(c, e),
        this.count++,
        (u = Hn.bind(this)),
        e.addEventListener("load", u),
        e.addEventListener("error", u),
        n
          ? n.parentNode.insertBefore(e, n.nextSibling)
          : ((l = l.nodeType === 9 ? l.head : l),
            l.insertBefore(e, l.firstChild)),
        (t.state.loading |= 4));
    }
  }
  var ge = {
    $$typeof: ll,
    Provider: null,
    Consumer: null,
    _currentValue: X,
    _currentValue2: X,
    _threadCount: 0,
  };
  function Wy(l, t, a, u, e, n, c, i, f) {
    ((this.tag = 1),
      (this.containerInfo = l),
      (this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode =
        this.next =
        this.pendingContext =
        this.context =
        this.cancelPendingCommit =
          null),
      (this.callbackPriority = 0),
      (this.expirationTimes = Wn(-1)),
      (this.entangledLanes =
        this.shellSuspendCounter =
        this.errorRecoveryDisabledLanes =
        this.expiredLanes =
        this.warmLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = Wn(0)),
      (this.hiddenUpdates = Wn(null)),
      (this.identifierPrefix = u),
      (this.onUncaughtError = e),
      (this.onCaughtError = n),
      (this.onRecoverableError = c),
      (this.pooledCache = null),
      (this.pooledCacheLanes = 0),
      (this.formState = f),
      (this.incompleteTransitions = new Map()));
  }
  function cm(l, t, a, u, e, n, c, i, f, v, p, z) {
    return (
      (l = new Wy(l, t, a, c, f, v, p, z, i)),
      (t = 1),
      n === !0 && (t |= 24),
      (n = et(3, null, null, t)),
      (l.current = n),
      (n.stateNode = l),
      (t = Hc()),
      t.refCount++,
      (l.pooledCache = t),
      t.refCount++,
      (n.memoizedState = { element: u, isDehydrated: a, cache: t }),
      xc(n),
      l
    );
  }
  function im(l) {
    return l ? ((l = uu), l) : uu;
  }
  function fm(l, t, a, u, e, n) {
    ((e = im(e)),
      u.context === null ? (u.context = e) : (u.pendingContext = e),
      (u = ea(t)),
      (u.payload = { element: a }),
      (n = n === void 0 ? null : n),
      n !== null && (u.callback = n),
      (a = na(l, u, t)),
      a !== null && (Pl(a, l, t), $u(a, l, t)));
  }
  function sm(l, t) {
    if (((l = l.memoizedState), l !== null && l.dehydrated !== null)) {
      var a = l.retryLane;
      l.retryLane = a !== 0 && a < t ? a : t;
    }
  }
  function lf(l, t) {
    (sm(l, t), (l = l.alternate) && sm(l, t));
  }
  function dm(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = Da(l, 67108864);
      (t !== null && Pl(t, l, 67108864), lf(l, 67108864));
    }
  }
  function om(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = st();
      t = $n(t);
      var a = Da(l, t);
      (a !== null && Pl(a, l, t), lf(l, t));
    }
  }
  var qn = !0;
  function $y(l, t, a, u) {
    var e = E.T;
    E.T = null;
    var n = D.p;
    try {
      ((D.p = 2), tf(l, t, a, u));
    } finally {
      ((D.p = n), (E.T = e));
    }
  }
  function Fy(l, t, a, u) {
    var e = E.T;
    E.T = null;
    var n = D.p;
    try {
      ((D.p = 8), tf(l, t, a, u));
    } finally {
      ((D.p = n), (E.T = e));
    }
  }
  function tf(l, t, a, u) {
    if (qn) {
      var e = af(u);
      if (e === null) (Qi(l, t, u, xn, a), ym(l, u));
      else if (Iy(e, l, t, a, u)) u.stopPropagation();
      else if ((ym(l, u), t & 4 && -1 < ky.indexOf(l))) {
        for (; e !== null; ) {
          var n = Ja(e);
          if (n !== null)
            switch (n.tag) {
              case 3:
                if (((n = n.stateNode), n.current.memoizedState.isDehydrated)) {
                  var c = Ta(n.pendingLanes);
                  if (c !== 0) {
                    var i = n;
                    for (i.pendingLanes |= 2, i.entangledLanes |= 2; c; ) {
                      var f = 1 << (31 - at(c));
                      ((i.entanglements[1] |= f), (c &= ~f));
                    }
                    (Ut(n), (ul & 6) === 0 && ((Sn = lt() + 500), oe(0)));
                  }
                }
                break;
              case 31:
              case 13:
                ((i = Da(n, 2)), i !== null && Pl(i, n, 2), pn(), lf(n, 2));
            }
          if (((n = af(u)), n === null && Qi(l, t, u, xn, a), n === e)) break;
          e = n;
        }
        e !== null && u.stopPropagation();
      } else Qi(l, t, u, null, a);
    }
  }
  function af(l) {
    return ((l = ec(l)), uf(l));
  }
  var xn = null;
  function uf(l) {
    if (((xn = null), (l = Ka(l)), l !== null)) {
      var t = L(l);
      if (t === null) l = null;
      else {
        var a = t.tag;
        if (a === 13) {
          if (((l = J(t)), l !== null)) return l;
          l = null;
        } else if (a === 31) {
          if (((l = q(t)), l !== null)) return l;
          l = null;
        } else if (a === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          l = null;
        } else t !== l && (l = null);
      }
    }
    return ((xn = l), null);
  }
  function mm(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (xm()) {
          case bf:
            return 2;
          case pf:
            return 8;
          case Te:
          case Bm:
            return 32;
          case Ef:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var ef = !1,
    ra = null,
    ga = null,
    Sa = null,
    Se = new Map(),
    be = new Map(),
    ba = [],
    ky =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
        " ",
      );
  function ym(l, t) {
    switch (l) {
      case "focusin":
      case "focusout":
        ra = null;
        break;
      case "dragenter":
      case "dragleave":
        ga = null;
        break;
      case "mouseover":
      case "mouseout":
        Sa = null;
        break;
      case "pointerover":
      case "pointerout":
        Se.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        be.delete(t.pointerId);
    }
  }
  function pe(l, t, a, u, e, n) {
    return l === null || l.nativeEvent !== n
      ? ((l = {
          blockedOn: t,
          domEventName: a,
          eventSystemFlags: u,
          nativeEvent: n,
          targetContainers: [e],
        }),
        t !== null && ((t = Ja(t)), t !== null && dm(t)),
        l)
      : ((l.eventSystemFlags |= u),
        (t = l.targetContainers),
        e !== null && t.indexOf(e) === -1 && t.push(e),
        l);
  }
  function Iy(l, t, a, u, e) {
    switch (t) {
      case "focusin":
        return ((ra = pe(ra, l, t, a, u, e)), !0);
      case "dragenter":
        return ((ga = pe(ga, l, t, a, u, e)), !0);
      case "mouseover":
        return ((Sa = pe(Sa, l, t, a, u, e)), !0);
      case "pointerover":
        var n = e.pointerId;
        return (Se.set(n, pe(Se.get(n) || null, l, t, a, u, e)), !0);
      case "gotpointercapture":
        return (
          (n = e.pointerId),
          be.set(n, pe(be.get(n) || null, l, t, a, u, e)),
          !0
        );
    }
    return !1;
  }
  function vm(l) {
    var t = Ka(l.target);
    if (t !== null) {
      var a = L(t);
      if (a !== null) {
        if (((t = a.tag), t === 13)) {
          if (((t = J(a)), t !== null)) {
            ((l.blockedOn = t),
              Mf(l.priority, function () {
                om(a);
              }));
            return;
          }
        } else if (t === 31) {
          if (((t = q(a)), t !== null)) {
            ((l.blockedOn = t),
              Mf(l.priority, function () {
                om(a);
              }));
            return;
          }
        } else if (t === 3 && a.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Bn(l) {
    if (l.blockedOn !== null) return !1;
    for (var t = l.targetContainers; 0 < t.length; ) {
      var a = af(l.nativeEvent);
      if (a === null) {
        a = l.nativeEvent;
        var u = new a.constructor(a.type, a);
        ((uc = u), a.target.dispatchEvent(u), (uc = null));
      } else return ((t = Ja(a)), t !== null && dm(t), (l.blockedOn = a), !1);
      t.shift();
    }
    return !0;
  }
  function hm(l, t, a) {
    Bn(l) && a.delete(t);
  }
  function Py() {
    ((ef = !1),
      ra !== null && Bn(ra) && (ra = null),
      ga !== null && Bn(ga) && (ga = null),
      Sa !== null && Bn(Sa) && (Sa = null),
      Se.forEach(hm),
      be.forEach(hm));
  }
  function Yn(l, t) {
    l.blockedOn === t &&
      ((l.blockedOn = null),
      ef ||
        ((ef = !0),
        h.unstable_scheduleCallback(h.unstable_NormalPriority, Py)));
  }
  var Gn = null;
  function rm(l) {
    Gn !== l &&
      ((Gn = l),
      h.unstable_scheduleCallback(h.unstable_NormalPriority, function () {
        Gn === l && (Gn = null);
        for (var t = 0; t < l.length; t += 3) {
          var a = l[t],
            u = l[t + 1],
            e = l[t + 2];
          if (typeof u != "function") {
            if (uf(u || a) === null) continue;
            break;
          }
          var n = Ja(a);
          n !== null &&
            (l.splice(t, 3),
            (t -= 3),
            ai(n, { pending: !0, data: e, method: a.method, action: u }, u, e));
        }
      }));
  }
  function Mu(l) {
    function t(f) {
      return Yn(f, l);
    }
    (ra !== null && Yn(ra, l),
      ga !== null && Yn(ga, l),
      Sa !== null && Yn(Sa, l),
      Se.forEach(t),
      be.forEach(t));
    for (var a = 0; a < ba.length; a++) {
      var u = ba[a];
      u.blockedOn === l && (u.blockedOn = null);
    }
    for (; 0 < ba.length && ((a = ba[0]), a.blockedOn === null); )
      (vm(a), a.blockedOn === null && ba.shift());
    if (((a = (l.ownerDocument || l).$$reactFormReplay), a != null))
      for (u = 0; u < a.length; u += 3) {
        var e = a[u],
          n = a[u + 1],
          c = e[wl] || null;
        if (typeof n == "function") c || rm(a);
        else if (c) {
          var i = null;
          if (n && n.hasAttribute("formAction")) {
            if (((e = n), (c = n[wl] || null))) i = c.formAction;
            else if (uf(e) !== null) continue;
          } else i = c.action;
          (typeof i == "function" ? (a[u + 1] = i) : (a.splice(u, 3), (u -= 3)),
            rm(a));
        }
      }
  }
  function gm() {
    function l(n) {
      n.canIntercept &&
        n.info === "react-transition" &&
        n.intercept({
          handler: function () {
            return new Promise(function (c) {
              return (e = c);
            });
          },
          focusReset: "manual",
          scroll: "manual",
        });
    }
    function t() {
      (e !== null && (e(), (e = null)), u || setTimeout(a, 20));
    }
    function a() {
      if (!u && !navigation.transition) {
        var n = navigation.currentEntry;
        n &&
          n.url != null &&
          navigation.navigate(n.url, {
            state: n.getState(),
            info: "react-transition",
            history: "replace",
          });
      }
    }
    if (typeof navigation == "object") {
      var u = !1,
        e = null;
      return (
        navigation.addEventListener("navigate", l),
        navigation.addEventListener("navigatesuccess", t),
        navigation.addEventListener("navigateerror", t),
        setTimeout(a, 100),
        function () {
          ((u = !0),
            navigation.removeEventListener("navigate", l),
            navigation.removeEventListener("navigatesuccess", t),
            navigation.removeEventListener("navigateerror", t),
            e !== null && (e(), (e = null)));
        }
      );
    }
  }
  function nf(l) {
    this._internalRoot = l;
  }
  ((Xn.prototype.render = nf.prototype.render =
    function (l) {
      var t = this._internalRoot;
      if (t === null) throw Error(s(409));
      var a = t.current,
        u = st();
      fm(a, u, l, t, null, null);
    }),
    (Xn.prototype.unmount = nf.prototype.unmount =
      function () {
        var l = this._internalRoot;
        if (l !== null) {
          this._internalRoot = null;
          var t = l.containerInfo;
          (fm(l.current, 2, null, l, null, null), pn(), (t[La] = null));
        }
      }));
  function Xn(l) {
    this._internalRoot = l;
  }
  Xn.prototype.unstable_scheduleHydration = function (l) {
    if (l) {
      var t = Of();
      l = { blockedOn: null, target: l, priority: t };
      for (var a = 0; a < ba.length && t !== 0 && t < ba[a].priority; a++);
      (ba.splice(a, 0, l), a === 0 && vm(l));
    }
  };
  var Sm = g.version;
  if (Sm !== "19.2.3") throw Error(s(527, Sm, "19.2.3"));
  D.findDOMNode = function (l) {
    var t = l._reactInternals;
    if (t === void 0)
      throw typeof l.render == "function"
        ? Error(s(188))
        : ((l = Object.keys(l).join(",")), Error(s(268, l)));
    return (
      (l = b(t)),
      (l = l !== null ? Y(l) : null),
      (l = l === null ? null : l.stateNode),
      l
    );
  };
  var lv = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: E,
    reconcilerVersion: "19.2.3",
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Qn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Qn.isDisabled && Qn.supportsFiber)
      try {
        ((Du = Qn.inject(lv)), (tt = Qn));
      } catch {}
  }
  return (
    (_e.createRoot = function (l, t) {
      if (!R(l)) throw Error(s(299));
      var a = !1,
        u = "",
        e = Td,
        n = Ad,
        c = Od;
      return (
        t != null &&
          (t.unstable_strictMode === !0 && (a = !0),
          t.identifierPrefix !== void 0 && (u = t.identifierPrefix),
          t.onUncaughtError !== void 0 && (e = t.onUncaughtError),
          t.onCaughtError !== void 0 && (n = t.onCaughtError),
          t.onRecoverableError !== void 0 && (c = t.onRecoverableError)),
        (t = cm(l, 1, !1, null, null, a, u, null, e, n, c, gm)),
        (l[La] = t.current),
        Xi(l),
        new nf(t)
      );
    }),
    (_e.hydrateRoot = function (l, t, a) {
      if (!R(l)) throw Error(s(299));
      var u = !1,
        e = "",
        n = Td,
        c = Ad,
        i = Od,
        f = null;
      return (
        a != null &&
          (a.unstable_strictMode === !0 && (u = !0),
          a.identifierPrefix !== void 0 && (e = a.identifierPrefix),
          a.onUncaughtError !== void 0 && (n = a.onUncaughtError),
          a.onCaughtError !== void 0 && (c = a.onCaughtError),
          a.onRecoverableError !== void 0 && (i = a.onRecoverableError),
          a.formState !== void 0 && (f = a.formState)),
        (t = cm(l, 1, !0, t, a ?? null, u, e, f, n, c, i, gm)),
        (t.context = im(null)),
        (a = t.current),
        (u = st()),
        (u = $n(u)),
        (e = ea(u)),
        (e.callback = null),
        na(a, e, u),
        (a = u),
        (t.current.lanes = a),
        ju(t, a),
        Ut(t),
        (l[La] = t.current),
        Xi(l),
        new Xn(t)
      );
    }),
    (_e.version = "19.2.3"),
    _e
  );
}
var Nm;
function ov() {
  if (Nm) return sf.exports;
  Nm = 1;
  function h() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(h);
      } catch (g) {
        console.error(g);
      }
  }
  return (h(), (sf.exports = dv()), sf.exports);
}
var mv = ov();
function Dm() {
  const h = document.getElementById("subscription-discount-map");
  if (!h?.textContent) return {};
  try {
    return JSON.parse(h.textContent);
  } catch {
    return {};
  }
}
function yv() {
  const h = document.getElementById("subscription-bundle-map");
  if (!h?.textContent) return {};
  try {
    return JSON.parse(h.textContent);
  } catch {
    return {};
  }
}
function vv(h, g) {
  switch (h) {
    case 0:
      return 1;
    case 1:
      return g.system?.machine_collection ? 2 : 4;
    case 2:
      return g.machine && g.system?.sample_collection ? 3 : 4;
    case 3:
      return 4;
    default:
      return 4;
  }
}
function hv(h, g) {
  switch (h) {
    case 4:
      return g.machine && g.system?.sample_collection
        ? 3
        : g.system?.machine_collection
          ? 2
          : 1;
    case 3:
      return 2;
    case 2:
      return 1;
    case 1:
      return 0;
    default:
      return 0;
  }
}
const Um = { step: 0 };
function rv(h, g) {
  switch (g.type) {
    case "REMOVE_MACHINE":
      return { ...h, machine: void 0, sample: void 0 };
    case "REMOVE_SAMPLE":
      return { ...h, sample: void 0 };
    case "SELECT_MACHINE":
      return { ...h, machine: g.payload };
    case "SELECT_PRODUCTS":
      return { ...h, products: g.payload };
    case "SELECT_SAMPLE":
      return { ...h, sample: g.payload };
    case "SELECT_SYSTEM":
      return { ...Um, system: g.payload };
    case "NEXT_STEP":
      const O = vv(h.step, h);
      return { ...h, step: O };
    case "PREV_STEP":
      const s = hv(h.step, h);
      return { ...h, step: s };
    default:
      return h;
  }
}
function gv(h, g) {
  if (!h) return;
  const O = g.split(".");
  let s = h;
  for (const R of O) {
    if (s === null || typeof s != "object" || !(R in s)) return;
    s = s[R];
  }
  return typeof s == "string" ? s : void 0;
}
function Sv(h, g) {
  return g
    ? h.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (O, s) =>
        g[s] !== void 0 && g[s] !== null ? String(g[s]) : "",
      )
    : h;
}
function bv(h, g, O) {
  const s = gv(h, g) ?? g;
  return Sv(s, O);
}
function pv() {
  if (typeof document > "u") return {};
  const g = document.getElementById("configurator-i18n")?.textContent?.trim();
  if (!g) return {};
  try {
    const O = JSON.parse(g);
    return O && typeof O == "object" && !Array.isArray(O) ? O : {};
  } catch {
    return {};
  }
}
const jm = Ul.createContext(null);
function Ev({ children: h, messages: g }) {
  const O = Ul.useMemo(() => (R, L) => bv(g, R, L), [g]),
    s = Ul.useMemo(() => ({ t: O }), [O]);
  return T.jsx(jm.Provider, { value: s, children: h });
}
function Ea() {
  const h = Ul.useContext(jm);
  if (!h) throw new Error("useI18n must be used within I18nProvider");
  return h;
}
const _v = T.jsx("svg", {
    className: "progress-step-check",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: T.jsx("polyline", { points: "20 6 9 17 4 12" }),
  }),
  zv = ({ step: h }) => {
    const { t: g } = Ea(),
      O = [
        {
          label: g("header.step_system.label"),
          title: g("header.step_system.title"),
        },
        {
          label: g("header.step_products.label"),
          title: g("header.step_products.title"),
        },
        {
          label: g("header.step_machine.label"),
          title: g("header.step_machine.title"),
        },
        {
          label: g("header.step_gift.label"),
          title: g("header.step_gift.title"),
        },
        {
          label: g("header.step_summary.label"),
          title: g("header.step_summary.title"),
        },
      ];
    return T.jsxs("div", {
      className: "configurator-header",
      children: [
        T.jsx("h2", { className: "h4 step-title", children: O[h].title }),
        T.jsx("div", {
          className: "configurator-progress",
          children: T.jsx("div", {
            className: "progress-steps",
            id: "progress-steps",
            children: O.map((s, R) =>
              T.jsxs(
                hf.Fragment,
                {
                  children: [
                    T.jsxs("div", {
                      className: `progress-step ${R === h ? "active" : ""} ${R < h ? "completed" : ""}`,
                      children: [
                        T.jsx("div", {
                          className: "progress-step-circle",
                          children:
                            R < h
                              ? _v
                              : T.jsx("span", {
                                  className: "progress-step-number",
                                  children: R + 1,
                                }),
                        }),
                        T.jsx("p", {
                          className: "progress-step-label",
                          children: s.label,
                        }),
                      ],
                    }),
                    R < O.length - 1 &&
                      T.jsx("div", { className: "progress-line" }),
                  ],
                },
                `progress-${R}`,
              ),
            ),
          }),
        }),
      ],
    });
  };
function Za(h) {
  return "€" + parseFloat(String(h)).toFixed(2).replace(".", ",");
}
const Tv = ({
    count: h,
    disabled: g,
    lastStep: O,
    pricing: s,
    showBackButton: R,
    systemImage: L,
    onBack: J,
    onNext: q,
  }) => {
    const { t: M } = Ea();
    return T.jsxs("div", {
      className: "configurator-footer",
      children: [
        R &&
          L &&
          T.jsx("div", {
            className: "configurator-summary-details",
            children: T.jsxs("p", {
              className: "configurator-summary-count",
              children: [
                T.jsx("strong", { children: h }),
                " ",
                M("footer.pods_per_month_after"),
              ],
            }),
          }),
        T.jsxs("div", {
          className: "configurator-price-container",
          children: [
            s &&
              s.firstDeliveryTotal > 0 &&
              T.jsxs("div", {
                className: "configurator-price",
                children: [
                  T.jsx("p", { children: M("footer.first_delivery_price") }),
                  T.jsxs("p", {
                    className: "price",
                    children: [
                      Number(s.firstDeliveryDiscounted) <
                        Number(s.firstDeliveryTotal) &&
                        T.jsx("span", {
                          className: "original-price",
                          children: Za(s.firstDeliveryTotal),
                        }),
                      T.jsx("span", {
                        className: "discount-price",
                        children: Za(s.firstDeliveryDiscounted),
                      }),
                    ],
                  }),
                ],
              }),
            s &&
              s.productsTotal > 0 &&
              T.jsxs(T.Fragment, {
                children: [
                  T.jsx("div", { className: "divider" }),
                  T.jsxs("div", {
                    className: "configurator-price",
                    children: [
                      T.jsx("p", {
                        children: M("footer.recurring_delivery_price"),
                      }),
                      T.jsxs("p", {
                        className: "price",
                        children: [
                          Number(s.productsDiscounted) <
                            Number(s.productsTotal) &&
                            T.jsx("span", {
                              className: "original-price",
                              children: Za(s.productsTotal),
                            }),
                          T.jsx("span", {
                            className: "discount-price",
                            children: Za(s.productsDiscounted),
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
          ],
        }),
        T.jsxs("div", {
          className: "configurator-navigation",
          children: [
            R &&
              T.jsx("button", {
                id: "prev-step",
                className: "button button--outline",
                onClick: J,
                style: { overflow: "unset" },
                children: M("footer.back"),
              }),
            T.jsx("button", {
              id: "next-step",
              className: "button",
              disabled: g,
              onClick: q,
              children: M(O ? "footer.set_subscription" : "footer.next_step"),
            }),
          ],
        }),
      ],
    });
  },
  Av = ({ bundle: h, products: g }) => {
    const { t: O } = Ea(),
      s =
        h?.bundle_product?.variants?.[0]?.option_sources?.[0]?.collection_id ||
        [],
      R = Dm()[s] || [],
      L = g ? g.reduce((q, M) => q + M.quantity, 0) : 0,
      J = R.reduce(
        (q, M) => (
          (q[M.condition_quantity_gte] = parseFloat(M.discount_value) / 100),
          q
        ),
        {},
      );
    return T.jsx("div", {
      className: "configurator-subheader",
      children: T.jsx("div", {
        className: "subheader-steps",
        children: Object.keys(J).map((q, M) => {
          const b = parseInt(q),
            Y = L >= b,
            N = Math.round((J[b * 1] ?? 0) * 100);
          return T.jsxs(
            hf.Fragment,
            {
              children: [
                T.jsxs("div", {
                  className: `subheader-step ${Y ? "active" : ""}`,
                  children: [
                    T.jsx("div", { className: "step-quantity", children: b }),
                    T.jsx("div", {
                      className: "step-label",
                      children: O("subheader.percent_off", { percent: N }),
                    }),
                  ],
                }),
                M < Object.keys(J).length - 1 &&
                  T.jsx("div", { className: "subheader-line" }),
              ],
            },
            q,
          );
        }),
      }),
    });
  },
  Ov = "/api/2026-01/graphql.json";
async function rf(h) {
  return (
    await (
      await fetch(Ov, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "3efb98aad6434e3c9cec07be9713398b",
        },
        body: JSON.stringify({
          query: `
    query ProductsByCollection($handle: String!) {
      collection(handle: $handle) {
        products(first: 50) {
          nodes {
            id
            handle
            discount: metafield(namespace: "custom", key: "subscription_discount") {
              value
            }
            featuredImage {
              altText
              url
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            title
            variants(first: 10) {
              nodes {
                id
                title
                sellingPlanAllocations(first: 10) {
                  nodes {
                    sellingPlan {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
          variables: { handle: h },
        }),
      })
    ).json()
  ).data.collection.products.nodes;
}
const Mv = ({ onRemove: h, onSelect: g, selected: O, system: s }) => {
    const { t: R } = Ea(),
      [L, J] = Ul.useState([]),
      [q, M] = Ul.useState(O?.id || null),
      b = (B) => {
        const vl = B.discount?.value || 0,
          ol = B.priceRange.minVariantPrice.amount;
        return parseFloat(ol) * (1 - Number(vl) / 100);
      },
      Y = () => {
        (h(), M(null));
      },
      N = (B) => {
        (g(B), M(B.id));
      };
    return (
      Ul.useEffect(() => {
        rf(s.machine_collection).then((B) => {
          J(B);
        });
      }, [s]),
      T.jsx("div", {
        id: "step-3",
        children: T.jsx("div", {
          className: "step-grid step-3-grid",
          children: L.map((B) => {
            const vl = b(B),
              ol = B.priceRange.minVariantPrice.amount;
            return T.jsxs(
              "div",
              {
                className: `step-card ${q === B.id ? "selected" : ""}`,
                children: [
                  T.jsx("p", { className: "title", children: B.title }),
                  T.jsxs("div", {
                    className: "price",
                    children: [
                      T.jsx("span", {
                        children: R("step_machine.promo_price"),
                      }),
                      Number(vl) < Number(ol) &&
                        T.jsx("span", {
                          className: "discount",
                          children: Za(ol),
                        }),
                      T.jsx("span", {
                        className: "original",
                        children: Za(vl),
                      }),
                    ],
                  }),
                  T.jsx("div", {
                    className: "image-container",
                    children: T.jsx("img", {
                      className: "image",
                      src: B.featuredImage?.url,
                      alt: B.featuredImage?.altText || B.title,
                    }),
                  }),
                  T.jsx("button", {
                    className: "button button--primary select-system",
                    disabled: q === B.id,
                    onClick: () => N(B),
                    children: R("step_machine.select"),
                  }),
                  q === B.id &&
                    T.jsx("button", {
                      className: "button--icon remove-system",
                      onClick: () => Y(),
                      "aria-label": R("step_machine.deselect_aria"),
                      children: "✕",
                    }),
                ],
              },
              B.id,
            );
          }),
        }),
      })
    );
  },
  Nv = ({ onSelect: h, selected: g, system: O }) => {
    const { t: s } = Ea(),
      [R, L] = Ul.useState([]),
      [J, q] = Ul.useState({}),
      M = (b, Y) => {
        q((N) => {
          const B = N[b.id] || 0,
            vl = Math.max(0, B + Y),
            ol = { ...N, [b.id]: vl },
            Sl = R.map((Nl) => ({
              product: Nl,
              quantity: ol[Nl.id] || 0,
            })).filter((Nl) => Nl.quantity > 0);
          return (h(Sl), ol);
        });
      };
    return (
      Ul.useEffect(() => {
        if (!g) return;
        const b = g.reduce((Y, N) => ((Y[N.product.id] = N.quantity), Y), {});
        q(b);
      }, [O, g]),
      Ul.useEffect(() => {
        rf(O.products_collection).then((b) => {
          const Y = b.filter(
            (N) => N.variants.nodes[0].sellingPlanAllocations.nodes.length > 0,
          );
          L(Y);
        });
      }, [O]),
      T.jsx("div", {
        id: "step-2",
        children: T.jsx("div", {
          className: "step-grid step-2-grid",
          children: R.map((b) =>
            T.jsxs(
              "div",
              {
                className: "step-card",
                children: [
                  T.jsx("p", { className: "title", children: b.title }),
                  T.jsx("div", {
                    className: "price",
                    children: s("step_products.from", {
                      price: Za(b.priceRange.minVariantPrice.amount),
                    }),
                  }),
                  T.jsx("div", {
                    className: "image-container",
                    children: T.jsx("img", {
                      className: "image",
                      src: b.featuredImage?.url,
                      alt: b.featuredImage?.altText || b.title,
                    }),
                  }),
                  T.jsxs("div", {
                    className: "quantity-selector",
                    children: [
                      T.jsx("button", {
                        className: "button quantity-selector-button",
                        type: "button",
                        onClick: () => M(b, -1),
                        disabled: (J[b.id] || 0) === 0,
                        children: "-",
                      }),
                      T.jsx("input", {
                        className: "quantity-selector__input",
                        name: "quantity",
                        readOnly: !0,
                        type: "number",
                        min: 0,
                        value: J[b.id] || 0,
                      }),
                      T.jsx("button", {
                        className: "button quantity-selector-button",
                        type: "button",
                        onClick: () => M(b, 1),
                        children: "+",
                      }),
                    ],
                  }),
                ],
              },
              b.id,
            ),
          ),
        }),
      })
    );
  },
  Dv = ({ onRemove: h, onSelect: g, selected: O, system: s }) => {
    const { t: R } = Ea(),
      [L, J] = Ul.useState([]),
      [q, M] = Ul.useState(O?.id || null),
      b = () => {
        (h(), M(null));
      },
      Y = (N) => {
        (g(N), M(N.id));
      };
    return (
      Ul.useEffect(() => {
        rf(s.sample_collection).then((N) => {
          J(N);
        });
      }, [s]),
      T.jsx("div", {
        id: "step-4",
        children: T.jsx("div", {
          className: "step-grid step-4-grid",
          children: L.map((N) =>
            T.jsxs(
              "div",
              {
                className: `step-card ${q === N.id ? "selected" : ""}`,
                children: [
                  T.jsx("p", { className: "title", children: N.title }),
                  T.jsx("div", { className: "price" }),
                  T.jsx("div", {
                    className: "image-container",
                    children: T.jsx("img", {
                      className: "image",
                      src: N.featuredImage?.url,
                      alt: N.featuredImage?.altText || N.title,
                    }),
                  }),
                  T.jsx("button", {
                    className: "button button--primary select-sample",
                    disabled: q === N.id,
                    onClick: () => Y(N),
                    children: R("step_sample.select"),
                  }),
                  q === N.id &&
                    T.jsx("button", {
                      className: "button--icon remove-system",
                      onClick: () => b(),
                      "aria-label": R("step_sample.deselect_aria"),
                      children: "✕",
                    }),
                ],
              },
              N.id,
            ),
          ),
        }),
      })
    );
  },
  Uv = ({ state: h }) => {
    const { t: g } = Ea();
    return T.jsx("div", {
      id: "step-5",
      className: "config-step step-5",
      children: T.jsxs("div", {
        className: "summary-content",
        children: [
          T.jsx("p", {
            className: "h5 summary-title",
            children: g("step_summary.monthly_subscription"),
          }),
          T.jsx("div", {
            className: "step-grid",
            children: h.products?.map((O) =>
              [...Array(O.quantity)].map((s, R) =>
                T.jsxs(
                  "div",
                  {
                    className: "step-card",
                    children: [
                      T.jsx("p", {
                        className: "title",
                        children: O.product.title,
                      }),
                      T.jsx("img", {
                        className: "image",
                        src: O.product.featuredImage?.url,
                        alt: O.product.title,
                        width: "550",
                        height: "550",
                      }),
                    ],
                  },
                  `${O.product.id}-${R}`,
                ),
              ),
            ),
          }),
          (h.machine || h.sample) &&
            T.jsxs(T.Fragment, {
              children: [
                T.jsx("p", {
                  className: "h5 summary-title",
                  children: g("step_summary.additional_first_delivery"),
                }),
                T.jsxs("div", {
                  className: "step-grid",
                  children: [
                    h.machine &&
                      T.jsxs(
                        "div",
                        {
                          className: "step-card",
                          children: [
                            T.jsx("p", {
                              className: "title",
                              children: h.machine.title,
                            }),
                            T.jsx("img", {
                              className: "image",
                              src: h.machine.featuredImage?.url,
                              alt: h.machine.title,
                              width: "550",
                              height: "550",
                            }),
                          ],
                        },
                        `${h.machine.id}`,
                      ),
                    h.sample &&
                      T.jsxs(
                        "div",
                        {
                          className: "step-card",
                          children: [
                            T.jsx("p", {
                              className: "title",
                              children: h.sample.title,
                            }),
                            T.jsx("img", {
                              className: "image",
                              src: h.sample.featuredImage?.url,
                              alt: h.sample.title,
                              width: "550",
                              height: "550",
                            }),
                          ],
                        },
                        `${h.sample.id}`,
                      ),
                  ],
                }),
              ],
            }),
        ],
      }),
    });
  },
  jv = ({ selected: h, systems: g, onSelect: O }) => {
    const { t: s } = Ea(),
      [R, L] = Ul.useState(h?.id || null),
      J = (q) => {
        (O(q), L(q.id));
      };
    return T.jsx("div", {
      id: "step-1",
      children: T.jsx("div", {
        className: "step-grid step-1-grid",
        children: g.map((q) =>
          T.jsxs(
            "div",
            {
              className: `step-card step-1-card ${R === q.id ? "selected" : ""}`,
              children: [
                T.jsx("p", { className: "title", children: q.name }),
                T.jsx("div", {
                  className: "image-container",
                  children: T.jsx("img", {
                    className: "image",
                    src: q.image,
                    alt: q.name,
                    width: "550",
                    height: "550",
                  }),
                }),
                T.jsx("p", {
                  className: "description",
                  children: q.description,
                }),
                T.jsx("button", {
                  className: "details-button",
                  type: "button",
                  children: s("step_system.view_details"),
                }),
                T.jsx("div", { className: "details", children: q.details }),
                T.jsx("button", {
                  className: "button button--primary select-system",
                  disabled: R === q.id,
                  onClick: () => J(q),
                  children: s("step_system.select"),
                }),
              ],
            },
            q.id,
          ),
        ),
      }),
    });
  };
function Hv(h) {
  return (
    h.products?.reduce(
      (g, O) => g + O.quantity * Number(O.product.variants.nodes[0].title),
      0,
    ) || 0
  );
}
function Rv({ state: h, rechargeBundle: g, machineDiscountPercent: O }) {
  let s = 0,
    R = 0;
  h?.products?.forEach(({ product: N, quantity: B }) => {
    ((s += parseFloat(N.priceRange.minVariantPrice.amount) * B), (R += B));
  });
  let L = 0;
  if (g) {
    const N =
        g?.bundle_product?.variants?.[0]?.option_sources?.[0]?.collection_id ||
        [],
      vl = (Dm()[N] || []).reduce(
        (Nl, jl) => (
          (Nl[jl.condition_quantity_gte] = parseFloat(jl.discount_value) / 100),
          Nl
        ),
        {},
      ),
      ol = Object.keys(vl).map(Number),
      Sl = ol.length > 0 ? Math.max(...ol) : -1;
    L = vl[R] ?? (Sl >= 0 && R > Sl ? vl[Sl] : 0);
  }
  const J = s * (1 - L),
    q = h.machine ? parseFloat(h.machine.priceRange.minVariantPrice.amount) : 0,
    M = h.machine ? q * (1 - O / 100) : 0,
    b = s + q,
    Y = J + M;
  return {
    productsTotal: s,
    productsDiscounted: J,
    firstDeliveryTotal: b,
    firstDeliveryDiscounted: Y,
  };
}
async function Cv({ bundle: h, state: g }) {
  const O = window.recharge;
  if (!O || !O.bundle)
    throw new Error("Recharge Bundle service is not available");
  if (!h || !g.system) return;
  const s = {
      handle: g.system?.products_collection,
      productId: h.bundle_product.external_product_id,
      variantId: h.bundle_product.variants[0].external_variant_id,
      sellingPlan: h.selling_plan_groups[0].selling_plans[0].selling_plan_id,
    },
    R = g?.products?.map(({ product: b }) => {
      const Y = Number(b.id.split("/").pop());
      return Hm(Y);
    }),
    J = (await Promise.all(R || []))
      .map((b, Y) =>
        b?.id
          ? {
              externalProductId: b.external_product_id,
              externalVariantId: b.variants[0].id,
              sellingPlan:
                b.selling_plan_groups[0].selling_plans[0].selling_plan_id,
              quantity: g?.products?.[Y]?.quantity,
            }
          : null,
      )
      .filter(Boolean),
    q = {
      externalProductId: s.productId,
      externalVariantId: s.variantId,
      selections: J,
    };
  return await O.bundle.getDynamicBundleItems(q, s.handle);
}
async function Hm(h) {
  const g = window.recharge;
  if (!g || !g.cdn) throw new Error("Recharge CDN is not available");
  return await g.cdn.getCDNProduct(h);
}
const qv = "/cart/add.js";
async function xv(h) {
  try {
    const g = await fetch(qv, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: h }),
    });
    if (!g.ok) {
      const s = await g.text().catch(() => "");
      throw new Error(`HTTP error! status: ${g.status} ${s}`);
    }
    return await g.json();
  } catch (g) {
    throw (console.error("Error adding products to cart:", g), g);
  }
}
const Bv = (h) => {
    const [g, O] = Ul.useReducer(rv, Um),
      [s, R] = hf.useState(),
      L = g.step === 4 || (g.step >= 2 && !g?.system?.machine_collection),
      J =
        g.step === 0
          ? !g.system
          : g.step === 1
            ? !g.products || g.products.length === 0
            : !1,
      q = Ul.useMemo(() => Hv(g), [g.products]),
      M = Rv({
        machineDiscountPercent: Number(g.machine?.discount?.value) || 0,
        rechargeBundle: s,
        state: g,
      });
    function b() {
      O({ type: "REMOVE_MACHINE" });
    }
    function Y(ll) {
      O({ type: "SELECT_MACHINE", payload: ll });
    }
    function N(ll) {
      O({ type: "SELECT_PRODUCTS", payload: ll });
    }
    function B() {
      O({ type: "REMOVE_SAMPLE" });
    }
    function vl(ll) {
      O({ type: "SELECT_SAMPLE", payload: ll });
    }
    function ol(ll) {
      (O({ type: "SELECT_SYSTEM", payload: ll }), Sl(ll));
    }
    async function Sl(ll) {
      const Xl = yv()[ll.products_collection],
        Ll = await Hm(Xl);
      R(Ll);
    }
    async function Nl() {
      const ll = await Cv({ bundle: s, state: g });
      if (!ll || ll.length === 0) return;
      if (g.machine) {
        const Hl = {
          id: Number(g.machine.variants.nodes[0].id.split("/").pop()),
          quantity: 1,
          properties: { _subscription: "true" },
        };
        ll.push(Hl);
      }
      if (g.machine && g.sample) {
        const Hl = {
          id: Number(g.sample.variants.nodes[0].id.split("/").pop()),
          quantity: 1,
          properties: { _gift: "true", _subscription: "true" },
        };
        ll.push(Hl);
      }
      const Xl = await xv(ll);
      (console.log("🚀 ~ setSubscription ~ cart:", Xl),
        (window.location.href = "/checkout"));
    }
    function jl() {
      L
        ? Nl()
        : (O({ type: "NEXT_STEP" }),
          document.querySelector(".configurator-content")?.scrollIntoView());
    }
    function Tt() {
      O({ type: "PREV_STEP" });
    }
    return T.jsxs("div", {
      className: "configurator",
      children: [
        T.jsx(zv, { step: g.step }),
        g.step === 1 && T.jsx(Av, { bundle: s, products: g.products }),
        T.jsxs("div", {
          className: "configurator-content",
          children: [
            g.step === 0 &&
              T.jsx(jv, {
                onSelect: ol,
                selected: g.system,
                systems: h.blocks,
              }),
            g.step === 1 &&
              g?.system &&
              T.jsx(Nv, {
                onSelect: N,
                selected: g.products,
                system: g.system,
              }),
            g.step === 2 &&
              g?.system?.machine_collection &&
              T.jsx(Mv, {
                onRemove: b,
                onSelect: Y,
                selected: g.machine,
                system: g.system,
              }),
            g.step === 3 &&
              g.system?.sample_collection &&
              T.jsx(Dv, {
                onRemove: B,
                onSelect: vl,
                selected: g.sample,
                system: g.system,
              }),
            L && T.jsx(Uv, { state: g }),
          ],
        }),
        T.jsx(Tv, {
          count: q,
          disabled: J,
          lastStep: L,
          onBack: Tt,
          onNext: jl,
          pricing: M,
          systemImage: g.system?.image,
          showBackButton: g.step > 0,
        }),
      ],
    });
  },
  yf = document.getElementById("react-configurator");
if (yf) {
  const h = JSON.parse(yf.dataset.blocks || "[]"),
    g = pv();
  mv.createRoot(yf).render(
    T.jsx(Ul.StrictMode, {
      children: T.jsx(Ev, { messages: g, children: T.jsx(Bv, { blocks: h }) }),
    }),
  );
}
